// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*var(--main-color)
var(--secondary-color)
#A28C75
#82705E
#685A4B
#53483C
#423A30
#352E26
#2A251E
#221E18
Black
 */

 /*
  background:#35425c; - card - grey-blue
  background:#2E2E52;  - radar violet 
  yellow = F2B43B; rgb(242, 180, 59)
  coral = FC5D47;
 */



 :root {
  --main-color:#FEDBB7;
  --secondary-color:#CBAF92;
  --shadow-main-color:#6D5E4F;
  --background-color: #2E2E52;
  --background-color-transparent: #2e2e52c0;
  -webkit-tap-highlight-color: transparent;

  --border-radius: 8px;

  --1: 4px;
  --2: calc(var(--1) * 2);
  --3: calc(var(--1) * 3);
  --4: calc(var(--1) * 4);

  --typing-animation-speed: 220;
  /*
  --background-color: #2E2E52;
    --background-color: #22223c;

  --background-color:#222222;
  */
}

.display-none{
  display: none !important;
}

.main-color{
  color: var(--main-color) !important;
 }


 .cyan-color{
  color: cyan !important;
 }

 
 .cyan-color-link{
  color: cyan !important;
  cursor: pointer;
  pointer-events: all;
 }

 .red-color{
  color: red !important;
 }

 .uppercase{
  text-transform: uppercase;
 }

*{
  margin:0;
  padding: 0;
  box-sizing: border-box;
}

html, body, #root{
  overflow:hidden;
  width: 100%;
  height:100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

canvas{
  background:var(--background-color);

  /*background: black;*/
}

html {
  height: calc(100%);

  margin: 0;
  width: 100%;
  background:var(--background-color);

  color: #fff;

}


a {
  text-decoration: none;
  color: cyan;
}

a:hover {
  color: #fff;
}


.material-symbols-outlined {
  font-variation-settings:
  'FILL' 0,
  'wght' 300,
  'GRAD' 0,
  'opsz' 24;
}

/* width */
::-webkit-scrollbar {
  width: 3px;
  height: 6px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-corner {
  background: rgba(0, 0, 0, 0);
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 2px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

small, .ce-popover__item-label, .cdx-search-field__input
{
  /* small */


  font-family: 'Roboto Mono', monospace;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  /*text-align: center;*/
  vertical-align: baseline;
  /* identical to box height */
  margin: 0;

}

html,
b, a, p,
.ce-paragraph, .cdx-block,
input,
button,
.right-menu-arrow-button,
select,
li {
  /* body */
  line-height: 20px;
  /*19 25*/


  font-family: 'Roboto Mono', monospace;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;

  margin: 0px;

}

b{
  font-weight:  500;
}


h3, .dropdown-btn li {
  font-family: 'Roboto Mono', monospace;
  font-style: normal;
  font-weight: 400 !important;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: -1px;

  margin: 0px;
}

h2,
.h2-input {
  font-family: 'Roboto Mono', monospace;
  font-style: normal;
  font-weight: 200;
  font-size: 24px;
  line-height: 29px;
  /* identical to box height

  letter-spacing: 0.1em;*/
  letter-spacing: -1px;

  margin: 0px;
}

h1,
.h1-input {
  font-family: 'Roboto Mono', monospace;
  font-style: normal;
  font-weight: 600;
  font-size: 52px;
  line-height: 52px;
  /* identical to box height */

  letter-spacing: -1px;

  margin: 0px;
}

.process-space-right .content .name h1 {
  text-transform: capitalize;
}


.inactive {
  color: #888;
}




.hud{
  height:0px;
  position: relative;
  width:0px;
  opacity: 0.8;
  color: var(--main-color);
  z-index: 200;
}

.hud.no-opacity{
  opacity: 1;
  z-index: 100;
}

.zero-opacity{
  opacity: 0;
}

.hud .computer-header{
  position: fixed;
  display: flex;
  flex-direction: column;
  top: 0px;
  gap:5px;
  left: 0px;
  width:100%;
  justify-content: end;
  text-align: end;
  background:#2E2E52;
  box-shadow: 2px 2px 10px 1px rgba(0, 0, 0, 1);  

  border-bottom: 1px solid var(--main-color);
  height: 70px;
}


.navigation-btn{
  max-width: 150px;
}

.hud .computer-header img{

  position: absolute;
  width:60px;
  height:60px;
  top:5px;
  left:5px;
  object-fit: cover;
  border-radius: 10px;
  z-index: 10;
  border: 1px solid var(--secondary-color);
  z-index: 0;
}

.hud .computer-header .description{

  position: absolute;
  left: 80px;
  top: 5px;
  width: 100px;
  display: flex;
  flex-direction: row;
  align-items: start;
  flex-wrap: wrap;
  gap: 0px;
}

.hud .computer-header .description-section{
  display: flex;
  flex-direction: column;
  align-items: start;
  flex-wrap: wrap;
  gap: 0px;
}



.hud .text-stats-left{
  text-align: right;
  position: fixed;
  top: 35px;
  right: calc(50% + 20px);
  width: 100px;
  padding:var(--1);
  padding-right:10px;
}

.hud .text-stats-left::after{
  position: absolute;
  width:10px;
  right:0;
  top:14px;
  bottom:13px;
  border-right:1px solid var(--main-color);
  content: '';
}


.hud .text-stats-center{
  text-align: center;
  position: fixed;
  top: 34px;
  left: calc(50% - 20px);
  width: 40px;
  padding:var(--1);
}

.hud .text-stats-right{
  text-align: left;
  position: fixed;
  top: 35px;
  left: calc(50% + 20px);
  width: 100px;
  padding:var(--1);
  padding-left:10px;
}

.hud .text-stats-right::after{
  position: absolute;
  width:10px;
  left:0;
  top:14px;
  bottom:13px;
  border-left:1px solid var(--main-color);
  content: '';
}

.hud .manual-modal{
  position: fixed;
  top:0;
  left:0;
  right:0;
  bottom: 0;
  z-index: 400;
  margin:auto;
  opacity: 1;
  max-width: calc(600px);
  max-height: calc(100%); 
  background-color: var(--background-color-transparent);
  -webkit-user-select: none ;
          user-select: none ;
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
  
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.hud .manual-modal.hidden{
  opacity: 0;
  z-index: 1;
  pointer-events: none;
}

.hud .bottom-drawer{
  position : fixed;
  left: var(--2);
  right: var(--2);
  bottom: var(--2);
  bottom: 28px; /* web app problems */
  padding: var(--2);
  margin:auto;
  border-radius: 0 0 var(--border-radius) var(--border-radius);
  

  min-height: 50px;
  max-width: calc(600px - 2 * var(--2));
  max-height: calc(100% - var(--2) - 32px - 28px); /*32 шапка*/

  display: flex;
  flex-direction: column;
  justify-content: start;
  gap: var(--2);

  transform: translateY(calc(0%));
  transition-duration: 0.4s;
  transition-timing-function: ease-in-out;
  background-color: var(--background-color);
  border: 1px solid #888;  

  /*border-left:1px solid var(--main-color);
  border-bottom:1px solid var(--main-color);*/
  z-index: 100;
  pointer-events: all;
}


.hud .bottom-drawer.hidden{
  transform: translateY(calc(100% + 60px));
  opacity: 0;
}

.hud .bottom-drawer.open-voyage-hat{
  border-radius: var(--border-radius);
  max-height: calc(100% - 190px); /*32 шапка - старый вариант с табами*/
  max-height: calc(100% - 146px); 
  padding: var(--1);
}

.hud .bottom-drawer.station-card-drawer{
  max-height: calc(100% - var(--2) - 32px); /*32 шапка*/
  height: calc(100%); /*32 шапка*/
  border: none;
}

.hud .bottom-drawer.open-voyage-hat .command-order-btns-row{
  padding: var(--1);
}


.hud .bottom-drawer .extra-modal-btn{
  position: absolute;
  height: 38px;
  top:-44px;
  width:auto;
  left: -1px;
  background-color: var(--background-color);
  padding: var(--2);
  border: 1px solid cyan;
  color: cyan;
  text-transform: uppercase;
  border-radius: var(--border-radius);
  opacity: 1;
  transform: translateY(calc(0%));
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
  cursor: pointer;
}

.hud .bottom-drawer.hidden .extra-modal-btn{
  opacity: 0;
  pointer-events: none;
}

.hud .bottom-drawer .drawer-header{
  position: absolute;
  top:-32px;
  left:-1px;
  height:32px;
  right: -1px;
  background-color: #888;
  padding: var(--2);
  color: var(--background-color);
  border-radius: var(--border-radius) var(--border-radius) 0 0;
}


.hud .stats{
  display: flex;
  display: none;
  position: relative;
  align-items: end;
  flex-direction: column;
  gap:5px;
  /*margin-right: -120px;*/
  /*background-color: rgba(40, 40, 40, 0.7);*/
  flex: none;
  flex-grow: 0;
  z-index: 1;
}

.hud .stats{
  align-items: end;
}

.left.stats{
  align-items: start;
}

.hud .stats .row{
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 5px;
  z-index: 1;
  height: 20px;
}

.no-transparent{
  opacity: 1;
}

.hud .stats .row .title{
  background-color: var(--main-color);
  line-height: 10px;
  color: #000;
  height: 18px;
  width: 24px;
  text-align: center;
  vertical-align:middle;
  justify-content: center;
}

.hud .stats .row .points{
  display: flex;
  flex-direction: row-reverse;
  gap: 3px;
  justify-content: right;
  align-items: center;
}



.left .row{
  justify-content: left !important;
  flex-direction: row !important;

}

.left .row .points{
  justify-content: left;
  flex-direction: row !important;
  align-items: center;
}


.hud .stats .row .points .p1,
.hud .stats .row .points .p1-blank{
  width: 15px;
  height: 5px;
  border: 1px solid var(--main-color);
}

.row.yellow .p1,
.row.yellow .title,
.key.yellow{
    background-color: #FCCA02 !important;
    color:#000 !important;
}

.row.gold .p1,
.row.gold .title,
.key.gold{
    background-color: var(--main-color) !important;
    color:#000 !important;
}

.row.red .p1,
.row.red .title,
.key.red{
    background-color: #a50000 !important;
    color:#fff !important;

}

.row.blue .p1,
.row.blue .title,
.key.blue{
    background-color: #4cb5f5 !important;
    color:#000 !important;

}

.row.grey .p1,
.row.grey .title,
.key.grey{
    background-color: white !important;
    color:#000 !important;
}

.p1.blank{
  background-color: #888 ;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }

}




.commands-panel{
  position : fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap:var(--1);
  right: 0;
  left:0;
  width: calc(100%);
  margin:auto;
  max-width: 600px;
  bottom: 10px;
  bottom: 20px; /* web app problems */
  /*border-left:1px solid var(--main-color);
  border-bottom:1px solid var(--main-color);*/

  min-height: 50px;
  min-width: 100px;
  border-radius:  0px 0px 0px var(--border-radius);
  padding:var(--2);
  pointer-events: none;
}

.commands-panel .commands-list{
  display: flex;
  position: relative;
  width:100%;
  flex-direction: row;
  justify-content: end;
  align-items: end;
  gap:var(--1);
}

.top-tabs{
  z-index: 100;
  display: flex;
  width:100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;
  padding-left: var(--2);
  padding-right: var(--2);
  gap:0;
}


.top-tabs .tab{
  text-align: center;
  align-self: flex;
  flex: auto;
  padding: var(--1);
  border-top: 1px solid #888;
  color: #888;
}


.top-tabs .tab.selected{
  border-top: 1px solid cyan;
  color: cyan;
}

.commands-panel .commands-list .commands-right-block{
  display: flex;
  gap:5px;
  flex-direction: row;
  align-items: end;
  justify-content: end;
  flex-wrap: wrap-reverse;
  min-width: 160px;
  /*max-width: 180px;*/
  max-width: 100%;
  flex: auto;
  /*max-width: calc(50%);*/
}

.commands-panel .commands-list .command,
.commands-panel .commands-list .disabled-command{
  display: flex;
  flex-direction: row;
  align-items: center;
  border:1px solid var(--main-color);
  padding:10px;
  flex:auto;
  max-width: 54px;
  border-radius: var(--border-radius);
  background-color: var(--background-color);
  cursor: pointer;
  justify-content: center;
  pointer-events: auto;
  width: 30%;
}


.commands-panel .commands-list .selected{
  background-color: var(--main-color);
  color:#000;
}


.commands-panel .commands-list .command:hover{
  background-color: var(--main-color);
  color:#000;
}

.commands-panel .commands-list .command:active{
  background-color: #fff;
  color:#000;
}

.commands-panel .commands-list .disabled-command{
  border:1px solid #888;
  color: #888;
}

.primary-btn{
  cursor: pointer;
  background-color: var(--main-color);
  color:#000;
  padding:5px;
}

.primary-btn:hover{
  background-color: var(--secondary-color);
}

.primary-btn:active{
  background-color: #fff;
}

.commands-descriptions{
  display: flex;
  height: 1px;
  position: relative;
  align-items: end;
  justify-content: start;
  max-height: 100px;
  flex-grow: 1;
  
  width:calc(100% - 180px);
  flex: none;
}

.commands-descriptions.disabled{
  max-height: none;
  height: 100%;
  width:24px;
}
.commands-descriptions.full-width{
  width: calc(100% - var(--border-radius));
  margin-right: var(--border-radius);
}

.commands-descriptions .commands-description{
  display: flex;
  position: absolute;
  bottom: 0px;
  left:0px;
  flex-direction: column;
  align-items: start;
  justify-content: end;
  text-wrap:wrap;
  width:100%;
  padding:10px;
  color: #888;
  border-left: 1px solid #888;
  border-bottom: 1px solid #888;
  border-radius: 0 0 0 var(--border-radius);
  line-height: 15px;
  gap: 10px;
}

.clickable-field{
  pointer-events: auto !important;
}

.non-clickable-field{
  pointer-events: none !important;
}


.command-order-btns-row{
  display: flex;
  flex-direction: row;
  align-items: center;
  gap:var(--1);
}

.btn{
  cursor: pointer;
  background-color: var(--background-color);
  color: var(--main-color);
  padding:var(--2);
  margin: -1px;
  border-radius: var(--border-radius);
  border: 1px solid var(--main-color);
  text-align: center;
}

.btn:hover{
  background-color: var(--main-color);
  color: var(--background-color);
}

.btn:active{
  background-color: #fff;
  color: var(--background-color);
}

.order-btn,
.secondary-order-btn{
  gap:5px;
  justify-content: center;
  cursor: pointer;
  flex:auto;
  color:#000;
  background-color: var(--main-color);
  text-align: center;
  padding: 19px;
  border-radius: var(--border-radius);
  margin: 0px;
  height:60px;
  pointer-events: auto;
}

.secondary-order-btn{
  border: 1px solid var(--main-color);
  background-color: var(--background-color);
  color: var(--main-color);
}

.order-btn:active{
  background-color: #fff;
  color:#000;
}


.secondary-order-btn:active{
  border: 1px solid #fff;
  color: #fff;
}


.order-btn a{
  text-decoration: none;
  color:#000;
}

.order-btn h2{
  color:#000;
  background-color: var(--main-color);
  padding: 10px;
}

.next-target-btn{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  color:var(--main-color);
  border: 1px solid var(--main-color);
  flex:none;
  height:60px;
  padding:var(--1);
  padding-left:10px;
  padding-right:10px;
  border-radius: var(--border-radius);
  cursor: pointer;
  pointer-events: auto;
}


.next-target-btn.inactive,
.order-btn.inactive{
  border: 1px solid #888;
  color:  #888;
  background:transparent;
  margin:0px;
  height:60px;
}

.order-btn.error{
  background-color: crimson;
}

.secondary-btn{
  border: 1px solid var(--main-color);
  cursor: pointer;
  pointer-events: auto;
}

.secondary-btn:active{
  color:#000;
  background-color: var(--main-color);
}

.next-target-btn:active{
  border: 1px solid #fff;
  color: #fff;
}


.hud .text-stats-left .indicators-row,
.hud .text-stats-right .indicators-row{
  display: flex;
  position: relative;
  flex-direction: row;
  height: 16px;
  height: 20px;
  align-items: center;
  justify-content: end;
  padding-top:2px;
  padding-bottom:2px;
  flex-wrap: nowrap;
  text-wrap: none;
}

.hud .text-stats-right .indicators-row{
  justify-content: start;
}


.hud .text-stats-left .indicators-row:before{
  position: absolute;
  right:-10px;
  top:10px;
  width:4px;
  height:1px;
  background-color: var(--main-color);
  content: '';
}

.hud .text-stats-right .indicators-row:before{
  position: absolute;
  left:-10px;
  top:10px;
  width:4px;
  height:1px;
  background-color: var(--main-color);
  content: '';
}


.square-indicator,
.square-indicator-empty{
  display: inline-block;
  width:6px;
  height:12px;
  margin-left:2px;
  margin-right:2px;
  background-color: var(--main-color);
  border-radius: 2px;
}

.square-indicator-empty{
  opacity: 0.2;
  height:12px;
}

.red-indicators .square-indicator,
.red-indicators .square-indicator-emptyzzz{
  background-color: red;
}

.cyan-indicators .square-indicator,
.cyan-indicators .square-indicator-emptyzzz{
  background-color: cyan;
}

.yellow-indicators .square-indicator,
.yellow-indicators .square-indicator-emptyzzz{
  background-color: #FCCA02;
}


.white-indicators .square-indicator,
.white-indicators .square-indicator-emptyzzz{
  background-color: #FFF;
}

.hud .ship-name-right{
  display: flex;
  flex-direction: column;
  align-items: end;
  text-align: end;

  width:100%;
  padding-left:20px;
  overflow: hidden;

  /*border-right:1px solid var(--main-color);
  border-bottom:1px solid var(--main-color);
  border-radius: 0 0 10px 0;*/

}

.hud .ship-name-left{
  display: flex;
  flex-direction: column;
  align-items: start;
  text-align: start;
  width:100%;
  padding-right:20px;
  overflow: hidden;

  /*border-right:1px solid var(--main-color);
  border-bottom:1px solid var(--main-color);
  border-radius: 0 0 10px 0;*/

}


.counter{
  padding-left: 2px;
  padding-right: 2px;
}

.hud .counter-center{
  display: flex;
  flex-direction: column;
  align-items: center;
  gap:5px;
  position:relative;
  margin:0px;
  padding:var(--1);
}


.info-panel-top{
  position : fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;

  top: 0;
  right: 0;
  left:0;
  width: calc(100%);
  margin:auto;
  max-width: 600px;
  flex:none;

  min-height: 50px;
  min-width: 100px;

  gap:var(--1);
  padding: var(--2);

  color: #888;
}

.info-panel-top .info-block{
  position: relative;
  width: 100%;
}

.info-panel-top.not-fixed{
  position : absolute;
  top: -2px;
  align-self: center;
  align-items: center;
  z-index: 11;
  padding: 0;
}

.locations-panel{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: var(--2);
}

.info-panel-left{
  position : fixed;
  display: flex;
  flex-direction: column;
  align-items: start;

  top: var(--2);
  right: calc(50% + 50px);
  width: calc(50% - 58px);
  max-width: 242px;/*(600 - 100) /2  -8px*/
  flex:none;
  min-height: 50px;
  min-width: 68px;

  gap:0px;
  padding: var(--2);
  /*border-left:1px solid var(--main-color);*/
  border-left:1px solid #888;
  border-top:1px solid #888;
  color: #888;

  border-radius:  var(--border-radius) 0px 0px 0px;

  transition-duration: 0.5s;
  transition-timing-function: ease-in-out;
}

.info-panel-left.no-borders{
  border: none;
}

.info-panel-left.not-fixed{
  position : absolute;
  top: 0;
  left: 0;
  right: auto;
  z-index: 11;
}

.info-panel-right{
  position : fixed;
  display: flex;
  flex-direction: column;
  align-items: end;

  top: var(--2);
  left: calc(50% + 50px);
  width: calc(50% - 58px);
  max-width: 242px;/*600 - 100 /2  -10px*/
  flex:none;
  min-height: 50px;
  min-width: 68px;

  gap:0px; 
  color: #888;
  padding: var(--2);
  /*border-left:1px solid var(--main-color);*/
  border-right:1px solid #888;
  border-top:1px solid #888;

  border-radius:  0px var(--border-radius) 0px 0px;
  text-align: right;

  transition-duration: 0.5s;
  transition-timing-function: ease-in-out;
}


.info-panel-right.not-fixed{
  position : absolute;
  top: 0;
  right: 0;
  left: auto;
  z-index: 11;
}

.info-panel-right.no-borders{
  border: none;
}

.info-panel-right-bottom{
  position : absolute;
  bottom: 0;
  right: 0;
  left: auto;
  z-index: 11;
  display: flex;
  flex-direction: column;
  align-items: end;
  justify-content: end;

  width: 50px;/*600 - 100 /2  -10px*/
  flex:none;
  min-height: 50px;

  gap:0px; 
  color: #888;
  padding: var(--2);
  /*border-left:1px solid var(--main-color);*/
  border-right:1px solid #888;
  border-bottom:1px solid #888;

  border-radius:  0 0 var(--border-radius) 0;
  text-align: right;

  transition-duration: 0.4s;
  transition-timing-function: ease-in-out;
}

.info-panel-right.no-border,
.info-panel-left.no-border,
.info-panel-right-bottom.no-border,
.info-panel-left-bottom.no-border{
  padding: 0;
  border: none;
}


.info-panel-left-bottom{
  position : absolute;
  bottom: 0;
  left: 0;
  right: auto;
  z-index: 11;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: end;
  flex:none;
  min-height: 50px;
  width: 50px;

  gap:0px; 
  color: #888;
  padding: var(--2);
  /*border-left:1px solid var(--main-color);*/
  border-left:1px solid #888;
  border-bottom:1px solid #888;

  border-radius:  0 0 0 var(--border-radius) ;
  text-align: left;

  transition-duration: 0.4s;
  transition-timing-function: ease-in-out;

}

.info-panel-left-bottom.active,
.info-panel-right-bottom.active{
  color: var(--main-color);
  border-color: var(--main-color);
}

.info-panel-center{
  position : fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  top: var(--2);
  gap:0px;
  left: calc(50% - 50px);
  width: 100px;
  /*border:1px solid var(--main-color);*/

  min-height: 20px;
  max-width: 100px;
}

.info-panel-center::after{
  position: absolute;
  bottom:0px;
  border-left:1px solid var(--main-color);
  border-right:1px solid var(--main-color);
  border-bottom:1px solid var(--main-color);
  border-radius: 0 0 5px 5px;
  width: 100%;
  height: 10px;

}

.info-panel-center-modal{
  position : fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 50px;
  top: calc(50% - 100px);
  left: calc(50% - 150px);
  right: calc(50% - 150px);

  background-color: var(--background-color);
  border:1px solid var(--main-color);
  padding:10px;
  min-height: 200px;
  min-width: 300px;
  border-radius: var(--border-radius);
  text-align: center;
  z-index: 1000;
}

.freight-tax-text{
  white-space: pre-line;
  color: #888;
}


.faction-logo{
  width:50px;
  height:50px;
  border: 1px solid cyan;
  border-radius: 5px;
  display: none;
}


.key1{
  position : fixed;
  bottom: 50px;
  left: 50px;
  border-radius:10px;
  width:40px;
  height:40px;
  border: solid 2px white;
}


.key2, .key3, .key4, .key1{
  display: none;
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}


.inventory-old{
  display: flex;
  color: var(--main-color);
  flex-direction: row;
  flex-wrap: wrap;
  gap:20px;
  overflow-y: scroll;
  max-height: 100%;
  /*max-width: 800px;
  margin:auto*/
}


.total-stats-section{
  position: relative;
  width:calc(100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--3);
  gap:30px;
  border-radius: 10px;
  align-self: center;
  overflow: scroll;
}

.total-stats-section .title{
  width:calc(100%);
  text-align: center;
}

.total-stats-section .stats {
  width:calc(100%);
  display: flex;
  flex-direction: row;
  gap:10px;
  justify-content: space-between;
}

.total-stats-section .stats .left-stats{
  display: flex;
  flex-direction: column;
  align-items: start;
}

.total-stats-section .stats .right-stats{
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  align-self: start;
}

.general-inventory{
  position: relative;
  width:100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;

  padding: var(--2);
  gap:var(--2);
  max-width: 600px;
  border-radius: 10px;
  height:calc(100% - 90px);
  flex: none;

  margin-bottom: 90px ;
  --dot-bg: #2E2E52;

  --dot-color: var(--secondary-color);
  --dot-size: 1px;
  --dot-space: 24px;

  
  transition-duration: 0.4s;
  transition-timing-function: ease-in-out;
	/*
  border: 1px solid var(--secondary-color);

  background:
		linear-gradient(90deg, var(--dot-bg) calc(var(--dot-space) - var(--dot-size)), transparent 1%) center / var(--dot-space) var(--dot-space),
		linear-gradient(var(--dot-bg) calc(var(--dot-space) - var(--dot-size)), transparent 1%) center / var(--dot-space) var(--dot-space),
		var(--dot-color);
    background-position: center center ;*/

}

.voyage .general-inventory{
  padding:0;
  margin-bottom: 0;
  flex:auto;
  height: calc(50% - 50px);
}


.general-inventory .hull {
  width: calc(100%);
  height: calc(70%);
  border-radius: 150px;
  top: -35%;
  position: absolute;
  border-radius: var(--border-radius);
  flex:none;
  overflow: hidden;  
  pointer-events: none;
  z-index: 15;
}


.general-inventory .items {
  position: relative;
  width:calc(100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100%);
  gap: var(--1);
  justify-content: start;
  /*height:500px;*/
  /*overflow-y: scroll;*/
}

.general-inventory .items .background-color-pulse{
  position: absolute;
  width: 100%;
  left:0;
  right:0;
  top:-79%;
  aspect-ratio: 1/1;
  border-radius: calc(50%) ;
  border-left: 40px solid transparent;
  border-top: 40px solid transparent;
  border-right: 40px solid var(--background-color);

  border-bottom: 40px solid var(--background-color);
  animation: background-color-pulse 1s ease-out;
  opacity: 0;
}

@keyframes background-color-pulse {
  0% {
    transform: rotate(45deg) scale(0);
    opacity: 1;
  }
  100% {
    transform:  rotate(45deg)  scale(2);
    opacity: 1;
  }
}

.general-inventory .items::after123 {
  position: absolute;
  content: "";
  bottom: 0;
  left: 0;
  right: 0;
  height: 10%;  
  border-radius: 0 0 var(--border-radius) var(--border-radius);
  border: 1px solid #888;
  border-top: none;
  pointer-events: none;
}

.appear{
  animation: appear 0.5s ease;
  opacity: 1;
}

@keyframes appear {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes appear-delayed {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}


@keyframes appear-with-opacity-delayed {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 0.4;
  }
}

@keyframes appear-with-scale-delayed {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  50% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}



.appear-with-shift{
  animation: appear-with-shift 0.5s ease;
  opacity: 1;
}

@keyframes appear-with-shift {
  0% {
    transform: translate(0, 100px);
    opacity: 0;
  }
  100% {
    transform: none;
    opacity: 1;
  }
}

.appear-with-shift-left{
  animation: appear-with-shift-left 0.5s ease;
  opacity: 1;
}

@keyframes appear-with-shift-left {
  0% {
    transform: translate(50px, 0);
    opacity: 0;
  }
  100% {
    transform: none;
    opacity: 1;
  }
}

.appear-with-shift-right{
  animation: appear-with-shift-right 0.5s ease;
  opacity: 1;
}

@keyframes appear-with-shift-right {
  0% {
    transform: translate(-50px, 0);
    opacity: 0;
  }
  100% {
    transform: none;
    opacity: 1;
  }
}

.appear-with-shift-down{
  animation: appear-with-shift-right 0.5s ease;
  opacity: 1;
}

@keyframes appear-with-shift-down {
  0% {
    transform: translate(0px, -50px);
    opacity: 0;
  }
  100% {
    transform: none;
    opacity: 1;
  }
}



.items .info-left{
  position: absolute;
  top: calc(28%);
  right: calc(50% + var(--2));
  left: 0;

  color: #888;
  z-index: 0;
  border-right: 1px solid #888;
  padding:var(--2);
  padding-top: var(--2);
  padding-bottom: var(--2);
  
  top: calc(50% + 20px);
  transform: translateY(-50%)
}

.items .info-left::after12{
  content: '';
  position: absolute;
  top: -100px;
  right: -1px;
  left: 0;
  border-right: 1px solid #888;
  height: 100px;
}

.items .info-right{
  position: absolute;
  top: calc(28%);
  left: calc(50% + var(--2)) ;
  right: 0;
  color: #888;
  z-index: 0;
  border-left: 1px solid #888;
  padding:var(--2);
  padding-top: var(--2);
  padding-bottom: var(--2);
    
  top: calc(50% + 20px);
  transform: translateY(-50%)
}


.general-inventory .hull img{

  /*width:100%;
  height:100%;
    box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.5);  
  filter: grayscale(80%); 

  object-fit: cover;*/
  left: 0; 
  right: 0; 
  margin-left: auto; 
  margin-right: auto; 
  height: calc(100%);
  top: 0;
  bottom:0;
  position: absolute;
  aspect-ratio: 1/1;
  object-fit: contain;
  border-radius:20px;
  z-index: 10;
  pointer-events: none;
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
}

.img-float-animation{
  animation: img-float-animation 6s ease-in-out infinite;
}


.general-inventory .hull .circle{
  position: absolute;
  left: 0; 
  right: 0; 
  margin: auto; 
  top:calc(20%);
  height: calc(60%);
  z-index: 1;
  aspect-ratio: 1/1;
  border-radius: calc(50%);
  border: 1px solid transparent;
  background-color: transparent;
  pointer-events: all;
}

/*
.general-inventory .hull .circle::before{
  position: absolute;
  background:#2E2E52;
  top:-50px;
  left:-50px;
  width:300px;
  z-index: -1;
  aspect-ratio: 1/2;
  border-radius:150px;
  border: 1px solid var(--main-color);
    content: "";
    display: none;
}
*/

.general-inventory .hull .circle::before{
  position: absolute;
  top: calc(-20% - 1px);
  left:calc(-20% - 1px);
  height: calc(140%);
  z-index: -1;
  aspect-ratio: 1/1;
  border-radius: calc(70%);
  border: 1px solid #2E2E52;
  border-top: 1px dashed var(--main-color);

  border-left: 1px solid var(--main-color);
  border-right: 1px solid var(--main-color);
  border-bottom: 1px dashed var(--main-color);

  border: 1px solid #888;

  transition-duration: 0.6s;
  transition-timing-function: ease-in-out;

  background-color: var(--background-color);

  transform: rotate(45deg);
    content: "";
}

.general-inventory .hull .circle.active1::before{
    animation: circle-tap-effect1 0.5s ease-in;

}
.general-inventory .hull .circle.active2::before{
  animation: circle-tap-effect2 0.7s ease-in;

}

@keyframes circle-tap-effect1 {
  0%, 100% {
    background-color: var(--background-color);
  }
  50% {
    background-color: red;
  }
}
@keyframes circle-tap-effect2 {
  0%, 100% {
    background-color: var(--background-color);
  }
  50% {
    background-color: red;
  }
}
/*
.general-inventory .items .hull:hover .circle::before {
  transform: rotate(180deg);
}*/


.tabs-row{
  z-index: 100;
  width: calc(100%);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: calc(var(--border-radius));
  border: 1px solid #888;  
  padding: var(--1);
  gap: var(--1);
  transition-duration: 0.2s;
  transition-timing-function: ease-in-out;
}

.tabs-row .tab{
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding: var(--2);
  border-radius: 5px;
  flex: auto;
  color: var(--main-color);
  justify-content: center;
  cursor: pointer;
  flex: 1 1;
  width: 0;
  text-wrap: nowrap;
}

.tab:hover{
  color: #fff;
}

.tabs-row .tab.selected{
  background-color: var(--main-color);
  color: #000;
}

.general-inventory .items .ship-present-card{
  position: relative;
  width:100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap:var(--2);
  justify-content: start;
  border-radius: var(--border-radius);
  height: 100%;
  flex:auto;
  overflow: hidden;
}

.ship-present-card .modules-block-list,
.ship-present-card .crews-block-list{
  position: absolute;
  width: 40%;
  top:0;
  left: 0;
  display: flex;
  flex-direction: column;

}

.ship-present-card .crews-block-list{
  left: auto;
  right: 0;

}

.general-inventory .items .items-row{
  position: relative;
  width:100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap:var(--2);
  justify-content: start;
  border-radius: var(--border-radius);
  height: auto;
  flex:auto;
  overflow-y: auto;
  padding: var(--2);
}

.general-inventory .items .section-title{
  position:absolute;
  left:0; 
  right: 0;
  border-radius: var(--border-radius) var(--border-radius) 0px 0px;
  padding: var(--2);
  top:0px;
  background-color:#888;  
  color:var(--background-color);
  margin:-1px;
  text-align: start;
  
}

.general-inventory .items .items-row .equip-items,
.general-inventory .items .items-row .crew-items{
  width:calc(100%);
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap:var(--2);
  justify-content: start;
  border-radius: var(--border-radius);
}

.general-inventory .items .items-row .crew-items::beforex,
.general-inventory .items .items-row .equip-items::beforex{
  content:"equip";
  position:absolute;
  top:-18px;
  left:-1px;
  border-radius: var(--border-radius) var(--border-radius) 0px 0px;
  padding-left: 5px;
  padding-right: 5px;
  height: 18px;
  width:70px;
  background-color:var(--main-color);  
  color:#2E2E52;
  
  text-align: center;
}

.general-inventory .items .ship-present-card::afterx,
.general-inventory .items .items-row .equip-items::afterx,
.general-inventory .items .items-row .crew-items::afterx{

  content:"";
  position:absolute;
  top:0;
  left:0;
  bottom: 0;
  border-radius: 0 0 0 var(--border-radius);
  width:78px;
  border: 1px solid  var(--main-color);  
  border-right: none;
  border-top: none;

}

.general-inventory .items .items-row .crew-itemsx{
  width:92px;
  border-radius: 10px 0px 10px 10px;
}

.general-inventory .items .items-row .crew-items::beforex{
  content:"crew";
  left:auto;
  right:-1px;
}

.general-inventory .items .item {
  width:80px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  aspect-ratio: 1/1;
  gap:10px;
  justify-content: center;
  border-radius: 0 0 5px 5px;
  flex:none;
  z-index: 1;
  padding: 3px;
  border: 1px solid #888;  
  margin-top:12px;

}

.general-inventory .items .item .name{
  position: absolute;
  top:-13px;
  height: 13px;
  left: -1px;
  right: -1px;
  background-color: #888;
  border-radius: 5px 5px 0 0;
  color: var(--background-color );

  overflow: hidden;
  text-wrap: nowrap;
  text-overflow: ellipsis;
  padding-left: var(--1);
  padding-right: var(--1);
}

.general-inventory .items .navigator-items{
  width: calc(100%);
  height: calc(100%);
}

.general-inventory .items .item.navigator{
  width: calc(100%);
  height: calc(100%);
}

.general-inventory .items .item:hover::before123,
.general-inventory .items .item:hover::after123{
  width:40px;
}

.general-inventory .items .item.crew img{
  border-radius: 10px;
}

/*
.general-inventory .items .item::before {
  position: absolute;
  width:84px;
  aspect-ratio: 1/1;
  left:-4px;
  top:-4px;
  flex:none;
  border: 1px solid  transparent;
  border-left: 1px solid  var(--main-color);
  transform: rotate(45deg);
  border-radius: 42px ;
  content: "";
  z-index: 10;
}*/

.general-inventory .items .item::before123 {
  position: absolute;
  width:20px;
  aspect-ratio: 1/1;
  left:-2px;
  top:-2px;
  flex:none;
  border: 1px solid  transparent;
  border-left: 1px solid  var(--main-color);
  border-top: 1px solid  var(--main-color);
  border-radius: 5px 0px;
  content: "";
  z-index: 10;
  
  transition-duration: 0.2s;
  transition-timing-function: ease-in-out;
}

.general-inventory .items .item::after123 {
  position: absolute;
  width:20px;
  aspect-ratio: 1/1;
  right:-2px;
  bottom:-2px;
  flex:none;
  border: 1px solid  transparent;
  border-right: 1px solid  var(--main-color);
  border-bottom: 1px solid  var(--main-color);
  border-radius: 5px 0px;
  content: "";
  z-index: 10;
  
  transition-duration: 0.2s;
  transition-timing-function: ease-in-out;
}


.general-inventory .items .item img{
  width:100%;
  aspect-ratio: 1/1;
  object-fit: contain;
  z-index: 10;
  display: none;
}


.category{
  position: relative;
  display: flex;
  flex-direction: column;
  gap:20px;
  justify-content: start;
  align-items: center;
  width: 100%;
  max-width: 800px;
  margin: auto;
  /*background-color: var(--main-color);
  padding:10px;
  color: black;*/
  max-height: calc(100%);
  overflow-y: scroll;
}

.category .title{
  
}

.category .card-row{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap:var(--2);
  max-width: 630px;
  padding-right: var(--1);
  scroll-snap-type: y mandatory;
  width: calc(100%)
}

.category .card-row.vertical{
  flex-direction: column;
}



.hull-card,
.hull-card-placeholder,
  .stats-holder{
    width:300px;
    /*width:80px;*/
    aspect-ratio: 3 / 5;
  }

.hull-card-placeholder{
  border-radius: 10px;
  border: 1px dashed var(--main-color);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hull-card{
  position: relative;
  border-radius: 20px;
  scroll-snap-align: start;

  background: #2E2E52;
  background: radial-gradient(circle at top, #32b5f2, #2E2E52, #2E2E52);  

  background: radial-gradient(circle at top, #e66465, #2E2E52, #2E2E52);  
  flex:none;
  box-shadow: 1px 1px 5px 1px rgba(42, 42, 42, 0.5);  
  border: 1px solid var(--secondary-color);

}


.crew-card,
.crew-card-placeholder,
.crew-stats-holder{
    width:150px;
    aspect-ratio: 3/4;
  }

.crew-card{
  position: relative;
  border-radius: 10px 10px 10px 10px;
  margin-right:150px;
  width:150px;
  /*width:80px;*/
  /*background: #e8ded4;
  background: #d3cac1;*/
  background: #bdbdbd;
  background: var(--main-color);

  /*background: radial-gradient(circle at bottom, #32b5f2, #2E2E52, #2E2E52);  */
  flex:none;
  box-shadow: 1px 1px 5px 1px rgba(42, 42, 42, 0.5);  
  border: 2px solid var(--secondary-color);
  border-right: 2px solid var(--main-color);
  border-top: 2px solid var(--main-color);
  color: var(--main-color);
}

.crew-card .middle-line{
  position: absolute;
  top: 0px;
  width:0px;
  border-right: 2px solid var(--secondary-color);
  left:149px;
  height:200px;
  display: none;
}

.crew-card::after{
  position: absolute;
  border-radius: 20px 0px 0px 20px;
  left:-12px;
  top: 10px;
  width:0px;
  height:100px;
  border-left: 14px solid var(--main-color);
  content: "";
}

.crew-card::before{
  position: absolute;
  border-radius: 0px 20px 20px 0px;
  left:140px;
  top: -2px;
  width:160px;
  height:170px;
  border: 1px solid var(--main-color);

  border-left: 0px;
  content: "";
}

.crew-card-placeholder{
  border-radius: 10px;
  border: 2px dashed var(--main-color);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.crew-card .description-right{
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 10px;
  bottom: 10px;
  left:160px;
  width:140px;
  gap:10px;
}

.crew-card img{

  /*width:100%;
  height:100%;
    box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.5);  
  filter: grayscale(80%); 

  object-fit: cover;*/
  position: absolute;
  width:130px;
  height:130px;
  top:6px;
  left:9px;
  object-fit: cover;
  border-radius: 10px;
  z-index: 10;
  border: 2px solid var(--secondary-color);

}

.crew-card .name{
  position: absolute;
  top:140px;
  left:10px;
  right:160px;
  color: #000;
}


/*
.inventory .hull-card::after{
  position: absolute;
  border-radius:  10px 10px 10px 0px;
  right:0px;
  top:-10px;
  width:150px;
  height:503px;
  border-right: 1px solid var(--main-color);
  border-bottom: 1px solid var(--main-color);
  border-top: 10px solid var(--main-color);
  content: "";
}

.inventory .hull-card::before{
  position: absolute;
  border-radius: 10px  0px 10px  10px;
  left:0px;
  bottom:-10px;
  width:150px;
  height:503px;
  border-left: 1px solid var(--main-color);
  border-top: 1px solid var(--main-color);
  border-bottom: 10px solid var(--main-color);
  content: "";
}*/

.hull-card img{

  /*width:100%;
  height:100%;
    box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.5);  
  filter: grayscale(80%); 

  object-fit: cover;*/
  position: absolute;
  width:94%;
  aspect-ratio: 1/1;
  object-fit: contain;
  border-radius:20px;
  margin:3%;
  z-index: 10;

}

.hull-card .middle-line{
  position: absolute;
  top: 280px;
  width:1px;
  background-color: var(--main-color);
  left:149px;
  height:170px;
}

.hull-card .circle{
  position: absolute;
  top:50px;
  left:50px;
  width:200px;
  z-index: 1;
  aspect-ratio: 1/1;
  border-radius:100px;
  background-color: var(--main-color);
}

.hull-card .circle::before{
  position: absolute;
  top:-16px;
  left:-16px;
  width:230px;
  z-index: 1;
  aspect-ratio: 1/1;
  border-radius:115px;
  border: 1px solid var(--main-color);
    content: "";
}

.hull-card .description-left{
  display: flex;
  flex-direction: column;
  align-items: end;
  justify-content: start;
  top: 300px;
  right:170px; /*150 + 20*/
  left:20px;
  position: absolute;
  height: 130px;
  gap:5px;
  text-align: end;
}

.transparent-text{
  color: transparent;
}

.highlight{
  color:#2E2E52;
  font-weight: 400;
    background-color:var(--main-color);
}

.main-border-highlight{
  background-color:#2E2E52;
  border: 1px solid var(--main-color);
  color:var(--main-color);
}

.inactive-border-highlight{
  background-color:#2E2E52;
  border: 1px solid #888;
  color: #888;
}

.grey-highlight{
  color:#2E2E52;
  background-color:#888;
}

.grey-highlight-inversed{
  background-color:#2E2E52;
  color:#888;
}

.red-highlight{
  color:black;
  background-color:red;
}

.cyan-highlight{
  color:black;
  background-color:cyan;
}

.yellow-highlight{
  color:black;
  background-color:yellow;
}

.white-highlight{
  color:black;
  background-color:white;
}

.black-highlight{
  color:var(--main-color);
  background-color:black;
}

.white-font{
  color: #fff;
}

.hull-card .description-right{
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  top: 300px;
  left:170px; /*150 + 20*/
  right:20px;
  position: absolute;
  height: 130px;
  gap:5px;
}


.hull-card .title{
  position: absolute;
  text-align: left;
  left: 20px;
  right: 20px;
  margin: auto;
  bottom: 20px;
  padding: 5px;
  padding-left: 10px;
  padding-right: 10px;
  color:#2E2E52; 
  
  border-radius: 10px;
  background-color:var(--main-color);
}



.equip-card,
.equip-card-placeholder,
.crew-stats-holder{
    min-width:300px;
    width: 100%;
    height: 200px;
  }


.equip-card{
  position: relative;
  border-radius: var(--border-radius);
  /*width:80px;*/
  /*background: #e8ded4;*/
  background: #2E2E52;
  overflow: hidden;
  /*background: radial-gradient(circle at bottom, #32b5f2, #2E2E52, #2E2E52);
    box-shadow: 1px 1px 5px 1px rgba(42, 42, 42, 0.5);  
  */
  flex:none;
  border: 1px solid #888;
  color: #888;
  order: 10;
  opacity: 0.5;
}

.equip-card.navigator{
  height: 250px;
  background-size: cover;
}

.equip-card.navigator.chosen{
  height: calc(100%);
  height: 250px;
  border: 1px solid #888;
  opacity: 1;
}

.equip-card.navigator .price-text{
  z-index:10;
  right:10px;
}

.equip-card.navigator .description,
.equip-card.navigator .title{
  z-index:10;
  left: 10px;
  right:100px;
  color: white;
}
.equip-card.navigator .description{
 display: none;
}

.navigator-accent-line{
  position: absolute;
  z-index:1;
  width:auto;
  left: 0;
  right:0;
  top:0;
  bottom: 0;
  background-color: none;
  background: radial-gradient(ellipse at bottom left,var(--background-color), transparent, transparent);
}




.equip-card.selected{
  border: 1px solid var(--main-color);
  color: var(--main-color);
  opacity: 1;
}

.equip-card.equipped{
  background-color: var(--background-color);
  order: 1;
  border: none;
  color: #fff;
  border-radius: 0;
  border: none;
  border-bottom: 1px solid #fff;
  border-top: 1px solid #fff;
  opacity: 1;
}


.equip-card.equipped::after{
  content: "";
  position: absolute;
  top: -1px;
  left: -1px;
  right: -1px;
  bottom: -1px;
  border-radius: var(--border-radius);
  z-index: 10;

}

.equip-card .left-accent{
  position: absolute;
  border-radius: 0px  20px  20px 0px;
  left:-1px;
  top: 55px;
  width:0px;
  height:90px;
  border-left: 12px solid #888;
  content: "";
}

.equip-card.selected .left-accent{
  border-left: 12px solid var(--main-color);
}

.equip-card.equipped .left-accent{
  border-left: none;
}

.equip-card-placeholder{
  border-radius: 10px;
  border: 2px dashed var(--main-color);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.equip-card img{

  /*width:100%;
  height:100%;
    box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.5);  
  filter: grayscale(80%); 

  object-fit: cover;*/
  position: absolute;
  width:150px;
  height:150px;
  top:25px;
  right:10px;
  object-fit: contain;

  z-index: 10;

}

.equip-card .crew-img{
  border-radius: var(--border-radius);
  border: 1px solid #888;
  height: 100px;
  width: 100px;
  right: 25px;
  top: 50px;
}

.equip-card.selected .crew-img{
  border: 1px solid var(--main-color);
}


.equip-card .accent-line{
  position: absolute;
  top:0px;
  right:40px;
  width:60px;
  height: calc(100%);
  z-index: 1;
  border-radius: 0px;
  background-color: #888;
}

.equip-card.equipped .accent-line{
  background-color: #fff;

}

.equip-card.selected .accent-line{
  background-color: var(--main-color);
}

.equip-card .accent-circle{
  position: absolute;
  top:0px;
  right:30px;
  width:110px;
  border-radius: 0 0 55px 55px;
  height:160px;
  z-index: 1;
  background-color: #888;
}


.equip-card.selected .accent-circle{
  background-color: var(--main-color);
}

.equip-card.equipped .accent-circle{
  border: 1px solid #fff;
  border-top: none;
  background-color: var(--background-color);
  color: #000;
  order: 1;
}

.equip-card .accent-circle::after{
  position: absolute;
  content: '';
  top:-10px;
  bottom: -10px;
  left: -10px;
  right: -10px;
  border: 1px solid #888;
  border-radius: 0 0 65px 65px;
}

.equip-card.equipped .accent-circle::after{

  border: 1px solid #fff;
}


.equip-card.selected .accent-circle::after{
  border: 1px solid var(--main-color);
}

.equip-card .title{
  position: absolute;
  bottom:10px;
  left:10px;
  right:160px;
  
}


.equip-card .description{
  display: flex;
  justify-content: start;
  align-items: center;
  position: absolute;
  top: 60px;
  bottom: 50px;
  left:20px;
  right:150px;
  white-space: pre-wrap; /* or pre-line */
  
}


.equip-card .hull-description{
  display: flex;
  justify-content: space-between;
  align-items: start;
  position: absolute;
  top: 50px;
  bottom: 50px;
  left:var(--2);
  right:180px;
  gap: var(--4);
  max-width: 200px;
}



.equip-card .price-text{
  position: absolute;
  top:10px;
  left:10px;
  right:160px;
  background-color: #888;
  color: var(--background-color);
  text-align: center;
  text-transform: uppercase;
}

.equip-card.equipped .price-text{
  background-color: #fff;

}

.equip-card.selected .price-text{
  background-color: var(--main-color);
}

.terminal{
  width:100%;
  max-width: 500px;
  padding:10px;
  padding-bottom: 20px;
  position: relative;
  align-self: center;
  border-radius: 10px ;
  /*width:80px;*/
  /*background: #e8ded4;*/
  background: var(--main-color);
  /*background: radial-gradient(circle at bottom, #32b5f2, #2E2E52, #2E2E52);  */
  flex:none;
  color: #000;
  box-shadow: 1px 1px 5px 1px black;  
  border: 2px solid var(--secondary-color);
  border-right: 2px solid var(--main-color);
  border-bottom: 2px solid var(--main-color);
}

.terminal::after{
  content: "";
  position: absolute;
  width:310px;
  left:calc(50% - 155px);
  bottom:-8px;
  height:15px;
  background: #2E2E52;
  background: linear-gradient(black, #2E2E52);
  border-radius: 10px 10px 0px 0px;
}

.terminal .window{
  width:100%;
  aspect-ratio: 3/2;
  position: relative;
  border-radius: 10px ;
  /*width:80px;*/
  /*background: #e8ded4;*/
  background: #2E2E52;
  /*background: radial-gradient(circle at bottom, #32b5f2, #2E2E52, #2E2E52);  */
  flex:none;
  box-shadow: 1px 1px 5px 1px inset rgba(42, 42, 42, 0.5);  
  border: 4px solid var(--secondary-color);
  color: #000;
  overflow: hidden;
}

.terminal .keyboard{
  width:100%;
  height:100px;
  position: relative;
  margin: auto;
  margin-top: 10px;
  border-radius: 10px ;
  /*width:80px;*/
  /*background: #e8ded4;*/
  background: var(--main-color);
  /*background: radial-gradient(circle at bottom, #32b5f2, #2E2E52, #2E2E52);  */
  flex:none;
  box-shadow: 1px 1px 5px 1px rgba(42, 42, 42, 0.5);  
  overflow: hidden;
}


.terminal img{

  position: absolute;
  width:100%;
  aspect-ratio: 3/2;
  object-fit:cover;
  border-radius: 10px ;
}

.terminal .description{
  position: absolute;
  left:10px;
  top: 10px;
  padding:10px;
  border-radius: 10px 0px 0px 0px;
  border-left: 1px solid var(--main-color);
  border-top: 1px solid var(--main-color);
  max-height:200px;
  color: var(--main-color);
}


.gray img{
  -moz-filter: grayscale(100%);
  -o-filter: grayscale(100%);
 -ms-filter: grayscale(100%);
     filter: grayscale(100%); 
}

/*
canvas{
  background:#000;
}

.hud{
  color: #7ab98d;
}

.info-panel-left,
.info-panel-right,
.order-btn,
.commands-panel{
  border-color: #7ab98d;
}

.commands-panel .selected{
  background-color: #7ab98d;
  color:#000;
}

.order-btn h2{
  color:#000;
  background-color: #7ab98d;
  padding: 10px;
}
*/
@keyframes glitch1 {
  0% {
    transform: none;
    opacity: 1;
  }
  7% {
    transform: skew(-0.5deg, -0.9deg);
    opacity: 0.75;
  }
  10% {
    transform: none;
    opacity: 1;
  }
  27% {
    transform: none;
    opacity: 1;
  }
  30% {
    transform: skew(0.8deg, -0.1deg);
    opacity: 0.75;
  }
  35% {
    transform: none;
    opacity: 1;
  }
  52% {
    transform: none;
    opacity: 1;
  }
  55% {
    transform: skew(-1deg, 0.2deg);
    opacity: 0.75;
  }
  50% {
    transform: none;
    opacity: 1;
  }
  72% {
    transform: none;
    opacity: 1;
  }
  75% {
    transform: skew(0.4deg, 1deg);
    opacity: 0.75;
  }
  80% {
    transform: none;
    opacity: 1;
  }
  100% {
    transform: none;
    opacity: 1;
  }
}

@keyframes glitch2 {
  0% {
    transform: none;
    opacity: 0.25;
  }
  7% {
    transform: translate(-4px, -5px);
    opacity: 0.5;
  }
  10% {
    transform: none;
    opacity: 0.25;
  }
  27% {
    transform: none;
    opacity: 0.25;
  }
  30% {
    transform: translate(-7px, -3px);
    opacity: 0.5;
  }
  35% {
    transform: none;
    opacity: 0.25;
  }
  52% {
    transform: none;
    opacity: 0.25;
  }
  55% {
    transform: translate(-5px, -1px);
    opacity: 0.5;
  }
  50% {
    transform: none;
    opacity: 0.25;
  }
  72% {
    transform: none;
    opacity: 0.25;
  }
  75% {
    transform: translate(-2px, -6px);
    opacity: 0.5;
  }
  80% {
    transform: none;
    opacity: 0.25;
  }
  100% {
    transform: none;
    opacity: 0.25;
  }
}

@keyframes glitch3 {
  0% {
    transform: none;
    opacity: 0.25;
  }
  7% {
    transform: translate(2px, 3px);
    opacity: 0.5;
  }
  10% {
    transform: none;
    opacity: 0.25;
  }
  27% {
    transform: none;
    opacity: 0.25;
  }
  30% {
    transform: translate(5px, 2px);
    opacity: 0.5;
  }
  35% {
    transform: none;
    opacity: 0.25;
  }
  52% {
    transform: none;
    opacity: 0.25;
  }
  55% {
    transform: translate(5px, 1px);
    opacity: 0.5;
  }
  50% {
    transform: none;
    opacity: 0.25;
  }
  72% {
    transform: none;
    opacity: 0.25;
  }
  75% {
    transform: translate(2px, 6px);
    opacity: 0.5;
  }
  80% {
    transform: none;
    opacity: 0.25;
  }
  100% {
    transform: none;
    opacity: 0.25;
  }
}

.ally-mark{
  fill: #F2B43B;
}

#ally-mark{
  fill: #F2B43B;
}

.enemy-mark{
  fill: #FC5D47;
}

.modal-list{
  position: fixed;
  background:#2E2E52;
  border-radius: var(--border-radius);
  border: 1px solid var(--main-color);
  /*box-shadow: 1px 1px 20px black;*/
  display: flex;
  flex-direction: column;
  max-width: 800px;
  margin: 0% auto; /* Only centers horizontally not vertically! */
  bottom: var(--4);
  top:var(--2);
  left: var(--2);
  right: var(--2);
  z-index: 1000;
}

.modal-list .btns{
  padding: 20px;
  width:100%;
  border-bottom:1px solid var(--main-color);
}

.modal-list .btns .back-btn{
  flex:none;  
  cursor: pointer;
}

.modal-list .category{
  padding-top: 20px;
  padding-bottom: 20px;
  overflow: scroll;
  flex: auto;
  order: 1;
  align-self: stretch;
  flex-grow: 1;
}


.voyage{
  position: relative;
  width:100%;
  max-width: 600px;

  height: calc(100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  /*padding: var(--2);*/
  /*max-width: 600px;*/
  overflow: hidden;
  /*margin-bottom: 50px;*/
  gap:var(--2);
  padding-top: var(--2);
  padding: var(--2);

  
  transition-duration: 0.2s;
  transition-timing-function: ease-in-out;
}

.voyage .voyage-section{
  position: relative;
  width:100%;
  height: calc(100% - 86px);
  margin-bottom: 86px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  /*padding: var(--2);*/
  /*max-width: 600px;*/
  /*margin-bottom: 50px;*/
  gap:var(--1);
  z-index: 100;

}

.opacity-transform{
  opacity: 0.2;
}

.opacity-transform-full{
  opacity: 0;
}

.station-card-div{
  position: relative;
  width: 100%;
  min-height: 200px;
  object-fit:cover !important;
  background-size: cover;
  border-radius: var(--border-radius) var(--border-radius);
  overflow: hidden;
  opacity: 1;
  max-height: none;

  transition-duration: 0.4s;
  transition-timing-function: ease-in-out;
}

.bottom-drawer.hidden .station-card-div{
  opacity: 0;
  max-height: 200px;
  height: 200px;
}

.station-card-background{
  position: relative;
  width: 100%;
  min-height: 200px;
  max-height: 100%;
  object-fit:cover !important;
  background-size: cover;
}

.station-card-div::after{
  content: '';
  position: absolute;
  width: 100%;
  height: 100px;
  left:0;
  right:0;
  bottom: 0;
  z-index: 12;
}

.background-canvas{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 0;
  
}

.voyage .anomaly-canvas{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 0;
  overflow: hidden;
  opacity: 0.2;
  
}

.voyage .anomaly-canvas .anomaly-alert{
  position: absolute;
  width:2px;
  height: 2px;
  border-radius: 50%;
  background-color: red;
}


.voyage .anomaly-canvas .anomaly-alert .anomaly-label{
  color: #888;
}


.voyage .full-absolute-div{
  position: absolute;
  flex: none;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 0;
}

.background-canvas .anomaly-alert .anomaly{

}

.background-canvas .cross{
  position: absolute;
  width:1px;
  height: 1px;
  

  transition-duration: 1s;
  transform-origin: bottom center;
  transition-timing-function: ease-in-out;
  opacity: 0.2;
}


.background-canvas .cross.light{
  opacity: 0.5;
}

  .background-canvas .cross.light::before,
  .background-canvas .cross.light::after{
      
}

.background-canvas .cross::before{
  content: '';
  position: absolute;
  width:1px;
  height: 7px;
  left: 0px;
  top:-3px;
  background-color: var(--main-color);
}

.background-canvas .cross::after{
  content: '';
  position: absolute;
  width: 7px;
  height: 1px;
  left: -3px;
  top:0px;
  background-color: var(--main-color);
}

.background-canvas .cross.cyan::before11,
  .background-canvas .cross.cyan::after11{
    background-color: cyan;
    /*animation:glitch2 13s infinite;*/
    opacity: 0;
    
}


.background-canvas .cross.red::before11,
  .background-canvas .cross.red::after11{
    background-color: red;
    animation:glitch3 21s infinite;
  }



.background-canvas .dot-star,
.background-canvas .dot-star-big{
  position: absolute;
  width:1px;
  height: 1px;
  

  transition-duration: 1s;
  transform-origin: bottom center;
  transition-timing-function: ease-in-out;
  background-color: #fff;
  opacity: 0.8;
}

.background-canvas .dot-star-big{
  opacity: 0.3;
}


.star-shift-animation .background-canvas .cross{
  animation: pulsate-twice  1.5s ease-in-out;
  /*transform: translateY(70px) scaleY(50);   
  opacity: 0.5;*/

}

.star-shift-animation .background-canvas .cross.light{
  animation: pulsate-twice-2  1.5s ease-in-out;
  /*transform: translateY(70px) scaleY(50);   
  opacity: 0.5;*/

}

.voyage .star-shift-animation .background-canvas .dot-star{
  animation: star-shift-animation 1.3s ease-in-out;
  
  /*transform: translateY(70px) scaleY(50);   
  opacity: 0.5;*/

}

.voyage .star-shift-animation .background-canvas .dot-star-big{
  animation: star-shift-animation 1.15s ease-in-out;
  /*transform: translateY(50px) scaleY(30);   
  opacity: 0.5;*/

}


@keyframes star-shift-animation {
  0%, 100%{
  }
  50% {
    transform: scaleY(150) translateY(3px);  
    opacity: 0; 
  }
  50.01% {
    transform: scaleY(100) translateY(-3px);  
    opacity: 0; 
  }

}

.voyage .hyperdive-animation .background-canvas .dot-star{
  animation: hyperdive-animation-frames 1.0s ease-in-out;
  transform-origin: center center;

  /*transform: translateY(70px) scaleY(50);   
  opacity: 0.5;*/

}

.voyage .hyperdive-animation .background-canvas .dot-star-big{
  transform-origin: center center;
  animation-delay: 100ms;
  animation: hyperdive-animation-frames 0.90s ease-in-out;
  /*transform: translateY(50px) scaleY(30);   
  opacity: 0.5;*/

}


@keyframes hyperdive-animation-frames {
  0%, 100%{
  }
  50%{
    background-color: var(--background-color);
    transform: translateY(-100px) scaleY(100); 
  }
  51%{
    background-color: var(--background-color);
    transform: translateX(-100px) scaleX(-100);
  }
}




.voyage .secondary-screen{
  z-index: 10;
  display: flex;
  flex: auto;
  width: calc(100%);
  height: auto;
  max-height: 600px;
  position: relative;
  justify-content: start;
  align-items: center;
  border-top: none;


  transition-duration: 0.4s;
  transition-timing-function: ease-in-out;
  overflow-x: auto;
  gap: var(--2);
}


.secondary-screen .path{
  position: relative;
  overflow: hidden;
  flex: none;
  height: 100%;
  width: 1000%;
}

.voyage .secondary-screen .indicators-boxes{
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  justify-content: center;
  flex: auto;
  gap: var(--1);
  overflow: hidden;
  align-self: stretch;
  padding: var(--2);
}

.voyage .secondary-screen .indicators-boxes .label{
  position: relative;
  width: 100%;
  color: #888;
  border: 1px solid #888;
  text-wrap: nowrap;
  overflow: hidden;
  flex: none;
  text-align: center;
}

.voyage .secondary-screen .indicator-box{
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  justify-content: center;
  flex: auto;
  overflow: hidden;
  gap: var(--1);
  background-color: var(--background-color-transparent);
}

.radar-waves-box{
  position: absolute;
  right:0;
  left: 0;
  top:0;
  bottom:0px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: none;
  overflow: hidden;
  opacity: 0.7;
  z-index: 11;
  pointer-events: none;
}

.radar-waves-svg{
  width: 100%;
}

.animated-line {
  stroke: #888;
  stroke-width: 2;
  transform-origin: center top; /* Set origin so the line shrinks from the top */
  animation: shrinkAnimation infinite ease-in-out;
}


.animated-line.second-line{

}

@keyframes shrinkAnimation {
  0%, 100% {
    transform: translateY(0%); /* Full height */
  }
  50% {
    transform: translateY(10%); /* Shrinks to half height */
  }
}
.voyage .secondary-screen .indicator-box .probability-label{
  height: 100%;
  width: 80px;
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: stretch;
  justify-content: center;
  flex: auto;
  overflow: hidden;
  color: var(--main-color);
  opacity: 0.8;
  text-align: center;
}

.voyage .secondary-screen .indicator-box .probability-label .header{
  border: 1px solid var(--main-color);
  background-color: var(--background-color-transparent);
}

.voyage .secondary-screen .indicator-box .probability-label .label-body{
  
}

.voyage .secondary-screen .indicator-box::after{
  content:"";
  position: absolute;
  bottom:0;
  left:0;
  right:0;
  height: var(--border-radius);
  border: 1px solid  #888;
  border-top: none;
  border-radius: 0 0  calc(var(--border-radius)/2) calc(var(--border-radius)/2);
}


.voyage .secondary-screen .indicator-box::before{
  content:"";
  position: absolute;
  top:0;
  left:0;
  right:0;
  height: var(--border-radius);
  border: 1px solid  #888;
  border-bottom: none;
  border-radius: calc(var(--border-radius)/2) calc(var(--border-radius)/2) 0 0  ;
}


.voyage .secondary-screen .indicator-box::before123{
  content:"";
  position: absolute;
  left:0;
  bottom:0;
  top:0;
  width: var(--border-radius);
  border: 1px solid  #888;
  border-right: none;
  border-radius:  calc(var(--border-radius)/2) 0 0 calc(var(--border-radius)/2);
}

.voyage .secondary-screen .indicator-box::after123{
  content:"";
  position: absolute;
  right:0;
  bottom:0;
  top:0;
  width: var(--border-radius);
  border: 1px solid #888;
  border-left: none;
  border-radius: 0 calc(var(--border-radius)/2)  calc(var(--border-radius)/2) 0;
}


.voyage .secondary-screen .indicator-box.locations-list{
  display: flex;
  flex-direction: column;
  border-radius: 0;
  gap: var(--1);
  align-items: center;
  justify-content: space-evenly;
  color: #888;
  border: none;
  padding: var(--2);
}

/*
.voyage .secondary-screen .indicator-box.locations-list::after,
  .voyage .secondary-screen .indicator-box.locations-list::before{
    display: none;
}*/

.voyage .secondary-screen .locations-list .title{
  border: 1px solid #888;
  color: #888;
  width: 100%;
  padding-left: var(--1);
  padding-right: var(--1);
  text-align: center;
  border-radius: var(--border-radius) ;

}


.voyage .secondary-screen .locations-list .sector{
  overflow: hidden;
  width: 120px;
  max-width: calc(100%);
  border-radius: 0;
  padding: var(--1);
  gap: 0;
  color: #888;
  border-top: none;
  border: 1px solid #888;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  z-index: 20;
  flex: none;
  height: auto;
  opacity: 0.5;
  text-align: center;
}


.voyage .secondary-screen .locations-list .sector.selected{
  color: var(--main-color);
  border-color: var(--main-color);
  opacity: 1;
}

.voyage .secondary-screen .locations-list .sector.not-selected{
  color: red;
  border-color: red;
}


.voyage .secondary-screen .locations-list .sector .location-name{
  background-color: #888;
  color: var(--background-color);
}

.voyage .secondary-screen .locations-list .sector.selected .location-name{
  background-color: var(--main-color);
  color: var(--background-color);
}


.voyage .secondary-screen .locations-list .sector.not-selected .location-name{
  background-color: red;
  color: var(--background-color);
}

.location-type-name{
  color: #888;
  width: 60px;
  margin-top: var(--2);
}

.location-name{
  margin-bottom: 10px;
  margin-bottom: 0px;
}

.toggler-boxes-row{
  display: flex;
  gap:var(--1);
  flex-direction: row;
  flex: auto;
  height: 130px;
  align-items: stretch;
  justify-content: stretch;
}

.toggler-box{
  height: 100%;
  min-width: 50px;
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  justify-content: center;
  flex: none;
  gap: var(--1);
  transition-duration: 0.3s;
  transition-timing-function: linear;
  transition-delay: 0ms;
  color: #888;
  overflow: hidden;
  
  padding: var(--1);
  padding-top: var(--2);
  padding-bottom: var(--2);

}


.toggler-box.on{
}

.toggler-box .title{
  text-wrap: none;
  text-align: center;
  width: 100%;
  color: #888;
  transition-duration: 0.2s;
  transition-timing-function: ease-in;
  transition-delay: 0ms;
  border: 1px solid #888;
  background-color: var(--background-color);
}

.toggler-box.on .title{
  border: 1px solid var(--main-color);
  color: var(--main-color);

}

.toggler-box .label{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap:var(--1);
  transition-duration: 0.2s;
  transition-timing-function: ease-in;
  transition-delay: 0ms;
  width: 100%;
}



.toggler-box .label .lamp{
  width: 7px;
  border-radius: 50%;
  aspect-ratio: 1/1;
  border: 1px solid #888;
  margin-top:2px;
}

.toggler-box.on .label.on,
.toggler-box.off .label.off{
  color:var(--main-color)
}

.toggler-box.on  .label.on .lamp,
.toggler-box.off .label.off .lamp{
  border: 1px solid var(--main-color);
  background-color: var(--main-color);
}


.toggler-box .vertical-toggler{
  min-width: 50px;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  justify-content: center;
  flex: auto;
  gap: 0;
  padding:var(--1);
  
}

.toggler-box .vertical-toggler::after{
  content:"";
  position: absolute;
  bottom:0;
  left:0;
  right:0;
  height: var(--border-radius);
  border: 1px solid  var(--main-color);
  border-top: none;
  border-radius: 0 0  calc(var(--border-radius)/2) calc(var(--border-radius)/2);
}


.toggler-box .vertical-toggler::before{
  content:"";
  position: absolute;
  top:0;
  left:0;
  right:0;
  height: var(--border-radius);
  border: 1px solid  var(--main-color);
  border-bottom: none;
  border-radius: calc(var(--border-radius)/2) calc(var(--border-radius)/2) 0 0;

}
/*
.toggler-box.on .vertical-toggler::before,
.toggler-box.off .vertical-toggler::after{
  border-color: var(--main-color);
}
*/
.toggler-box .vertical-toggler .toggler{
  width: 100%;
  border-radius: calc(var(--border-radius)/2 - 2px);
  height: 10px;
  background-color: var(--main-color);
  flex: none;
}



.toggler-box .vertical-toggler .white-space{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: auto;
  transition-duration: 0.1s;
  transition-timing-function: ease-in;
  transition-delay: 0ms;
  height:60%;
  color: #fff;
  background-color: var(--background-color-transparent);
  width: 100%;
}


.toggler-box.on .vertical-toggler .white-space.on,
.toggler-box.off .vertical-toggler .white-space.off{
  flex: none;
  height:0;
  
}




.voyage .screen{
  z-index: 10;
  display: flex;
  flex: none;
  width: calc(100%);
  height: calc(100% - 50px); /*раньше табы шли сверху*/
  height: calc(100%);

  /*max-height: 600px;*/
  position: relative;
  justify-content: end;
  border-top: none;

  transition-duration: 0.4s;
  transition-timing-function: ease-in-out;
  transition-delay: 0ms;
  
}

.voyage .screen.no-tab{
  height: calc(100%);
}

.voyage .screen.shrinked{
  height: calc(50%);
}




.voyage .screen-bottom{
  --group-window-size: 120px;
  z-index: 10;
  pointer-events: none;

  flex: none;
  width: calc(100%);
  height: 120px;
  height: calc(100% - 120px);
  position: relative;
  align-self: end;
  border: 1px solid #888;
  border: none;
  border-radius: 0 0 var(--border-radius) var(--border-radius);
  
  transition-duration: 0.5s;
  transition-timing-function: ease-in-out;
}

.hyperdive-map{
  position: absolute;
  aspect-ratio: 1/1;
  height: calc(100%);
  width: calc(100%);
  z-index: 10;
  pointer-events: none;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  top: 0;

  opacity: 1;

  display: flex;
  justify-content: center;
  align-items: start;

  -webkit-user-select: none;

          user-select: none;
  overflow: hidden;

}

.hyperdive-map::after123{
  z-index: 20;
  content:'';
  position: absolute;
  height: calc(100%);
  width: 20px;
  z-index: 10;
  pointer-events: none;
  left: 0;
  top: 0;

  opacity: 1;

  background: linear-gradient(90deg, var(--background-color), transparent);
}





.hyperdive-map .hyperdive-map-header{
  position: absolute;
  top:-32px;
  left:0px;
  height:32px;
  right: 0px;
  background-color: #888;
  padding: var(--2);
  color: var(--background-color);
  border-radius: var(--border-radius) var(--border-radius) 0 0;

  display: none;
}

.hyperdive-map .map-grid{
  position: absolute;
  max-width: calc(100%);
  height: calc(100%);
  display: flex;
  flex-direction: column-reverse;

  flex:auto;
  align-items: stretch;          
  align-self: top;
  /*border: 1px solid #888;*/
  border-radius:  0 0 var(--border-radius) var(--border-radius);
  background-color: var(--background-color);
  overflow: scroll;
  pointer-events: all;
  padding-bottom: 220px;
  animation: appear-with-zoom-in 0.4s ease-in-out;

}



.appear-with-zoom-in{
  animation: appear-with-zoom-in 1s ease-in-out;
  opacity: 1;
}

@keyframes appear-with-zoom-in {
  0% {
    transform: scale(2);
    opacity: 0;
  }
  100% {
    transform: none;
    opacity: 1;
  }
}


.scroll-bar-hide{
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

.scroll-bar-hide::-webkit-scrollbar {
  display: none;
}

.hyperdive-map .map-grid .row{
  flex:auto;
  display: flex;
  flex-direction: row;
}


.hyperdive-map .map-grid .row .loc-box{
  flex:auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 70px;
  height: 70px;
  position: relative;
  /*
  border-left:1px dashed  #3a3a52;
  border-top:1px dashed  #3a3a52;
  */
  pointer-events: all;
}


.hyperdive-map .map-grid .loc-selection{
  flex:none;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  bottom:220px;
  left:0;
  width: 70px;
  height: 70px;
  position: absolute;
  
  pointer-events: none;

  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
  transition-delay: 0ms;
}

.hyperdive-map .map-grid .selected-direction{
  flex:none;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  bottom:240px;
  left:20px;
  width: 30px;
  height: 30px;
  z-index: 100;
  position: absolute;
  pointer-events: none;
  color: var(--background-color);
  background-color: cyan;
  animation: pulsate 1s infinite ease-in-out;

  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
  transition-delay: 0ms;
}

.hyperdive-map .map-grid .loc-selection .selection-border-1::before,
.hyperdive-map .map-grid .loc-selection .selection-border-1::after,
.hyperdive-map .map-grid .loc-selection .selection-border-2::before,
.hyperdive-map .map-grid .loc-selection .selection-border-2::after{
  content: '';
  position: absolute;
  width: 6px;
  height: 6px;
}


.hyperdive-map .map-grid .loc-selection .selection-border-1::before{
  left:0;
  top:0;
  border-top: 1px solid #888;
  border-left: 1px solid #888;
}

.hyperdive-map .map-grid .loc-selection .selection-border-1::after{
  right:0;
  top:0;
  border-top: 1px solid #888;
  border-right: 1px solid #888;
}

.hyperdive-map .map-grid .loc-selection .selection-border-2::before{
  left:0;
  bottom:0;
  border-bottom: 1px solid #888;
  border-left: 1px solid #888;
}

.hyperdive-map .map-grid .loc-selection .selection-border-2::after{
  right:0;
  bottom:0;
  border-bottom: 1px solid #888;
  border-right: 1px solid #888;
}



.hyperdive-map .map-grid .row .loc-box .loc-mark{
  position: absolute;
  left:0;
  top:0;
  right:0;
  bottom:0;
  overflow: scroll;
}

.hyperdive-map .map-grid .row .loc-box .dive-level{
  position: absolute;
    left:0;
    top:0;
    right:0;
    bottom:0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 20;
  
}


.hyperdive-map .map-grid .row .loc-box .loc-label{
  position: absolute;
    left: 0;
    top: 60%;
    bottom:0;
    right:0;
    display: flex;
    align-items: start;
    justify-content: center;
    vertical-align: start;
    opacity: 1;
    color: var(--main-color);
    z-index: 100;
    text-align: center;
  }

  .hyperdive-map.no-markers .map-grid .row .loc-box .loc-label{
    opacity: 0;
  }
  .hyperdive-map .map-grid .row .loc-box .loc-label.hyperdive-loc-label{
    top: 70%;
  }
  

.loc-box .dive-level .hyperdive-loc{
    flex:none;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
    left:20px;
    width: 26px;
    height: 26px;
    z-index: 100;
    pointer-events: none;
    color: var(--background-color);
    background-color: cyan;
    animation: pulsate 1s infinite ease-in-out;
  
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
    transition-delay: 0ms;
  
}


.loc-box .dive-level .storm{
  position: relative;
  width: 5px;
  height: 5px;
  aspect-ratio: 1/1;
  flex:none;
  color: #888;
}

.loc-box .dive-level .storm::before{
  position: absolute;
  align-self: center;
  /*width: calc(30%);*/
  height: 100%;
  width: 1px;
  left: calc(50% - 0.5px);
  background-color: red;
  content: '';
  z-index: 2;

}

.loc-box .dive-level .storm::after{
  position: absolute;
  align-self: center;
  /*width: calc(30%);*/
  width: 100%;
  height: 1px;
  top: calc(50% - 0.5px);
  background-color: red;
  content: '';
  z-index: 2;

}

.loc-box .dive-level .null-sector{

}


.loc-box .dive-level .null-sector::before,
.loc-box .dive-level .null-sector::after{
    background-color: red;
}

.loc-box .dive-level .station-loc{

  position: relative;
  width: 7px;
  height: 7px;
  border: 1px solid cyan;
  rotate: 45deg;
  border-radius: 1px;
}

.loc-box .dive-level .station-loc::before{
  position: absolute;
  height: 1px;
  width: 1px;
  left: calc(50% - 0.5px);
  top: calc(50% - 0.5px);
  background-color: cyan;
  content: '';
}

.hyperdive-map .team-location{
  flex:none;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  bottom:220px;
  left:0;
  width: 70px;
  height: 70px;
  position: absolute;
  
  pointer-events: none;

  transition-duration: 0.5s;
  transition-timing-function: ease-in-out;
  transition-delay: 0ms;
}

.team-location .marker{
  transform: rotate(180deg);
  height: 31px;
  width: 31px;
  margin-top:5px;
}

.loc-box .dive-level .possible_direction{
  position: absolute;
  width: 100%;
  height: 100%;
  flex:none;
  z-index:50;
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
}


.loc-box .dive-level .minerals-loc{

  position: relative;
  width: 5px;
  height: 5px;
  border: 1px dotted var(--main-color);
  animation: border-pulsate 1s infinite;
}

@keyframes border-pulsate {
  0% {
    border: 1px dotted var(--main-color);
  }

  50% {
    border: 1px solid var(--main-color);
  }
}

.loc-box .dive-level .minerals-loc::before{
  position: absolute;
  height: 1px;
  width: 1px;
  left: calc(50% - 0.5px);
  top: calc(50% - 0.5px);
  background-color: var(--main-color);
  content: '';
}

.loc-box .dive-level .level-0{
  opacity: 0.1;
}

.loc-box .dive-level .storm.level-1{
  opacity: 1;
}

.loc-box .dive-level .storm.level-2{
  opacity: 1;
}

.loc-box .dive-level .storm.level-2::before{
  background-color: red;
}

.loc-box .dive-level .storm.level-2::after{
  background-color: red;
}

.loc-box .dive-level .only-dot::before{
  position: absolute;
  height: 1px;
  width: 1px;
  left: calc(50% - 0.5px);
  top: calc(50% - 0.5px);
  background-color: var(--main-color);
  content: '';
}

.loc-box .dive-level .only-dot::after{
  display: none;
}

.loc-box .dive-level .only-dot::before{
  position: absolute;
  height: 1px;
  width: 1px;
  left: calc(50% - 0.5px);
  top: calc(50% - 0.5px);
  background-color: red;
  content: '';
}

.loc-box .dive-level .only-dot::after{
  display: none;
}


.hyperdive-map .map-grid .row .loc-box .dive-level{
  opacity: 1;
}

.hyperdive-map .map-grid .row .loc-box .dive-level.level-2{
  opacity: 1;

}
.hyperdive-map .map-grid .row .loc-box .dive-level.level-3{
  opacity: 1;
}

.loc-box .dive_level.level-3::after{
  background-color: red;
  box-shadow: rgba(240, 46, 170, 0.4) 5px 5px, rgba(240, 46, 170, 0.3) 10px 10px, rgba(240, 46, 170, 0.2) 15px 15px, rgba(240, 46, 170, 0.1) 20px 20px, rgba(240, 46, 170, 0.05) 25px 25px;
}
.loc-box .dive_level.level-3::before{
  background-color: red;
  box-shadow: rgba(240, 46, 170, 0.4) 5px 5px, rgba(240, 46, 170, 0.3) 10px 10px, rgba(240, 46, 170, 0.2) 15px 15px, rgba(240, 46, 170, 0.1) 20px 20px, rgba(240, 46, 170, 0.05) 25px 25px;
}

.voyage .screen .event-card{
  z-index: 9;
  position: absolute;

  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--2);
  margin:auto;
  color: var(--background-color);
  overflow: hidden;
  
  left:calc(50% - 120px);
  right:calc(50% - 120px);
  top: calc(30px);
  
  bottom: calc(30px);
  -webkit-user-select: none ;
          user-select: none ;
}

.voyage .screen .event-card .event-card-face{
  width: 100px;
  height: 150px;
  flex:none;
  background-color: red;
}

.voyage .screen .event-card .event-card-description{
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  align-self: stretch ;
  justify-content: center;
  width: 100%;
  color: cyan;
  gap: var(--1);
}

.voyage .screen .event-card .event-card-description p{
  max-height: 70px;
}

.loading-bar{
  height: 5px;
  width: 100%;
  position: relative;
  border: 1px solid red;
}

.loading-bar .bar{
  position: absolute;
  height: 100%;
  width: 100%;
  left:0;
  transform-origin: left;
  background-color: red;
  transition-duration: 1s;
  transition-timing-function: linear;
}


.cyan-warning .loading-bar{
  border: 1px solid cyan;


}

.cyan-warning .loading-bar .bar{
  background-color: cyan;
}


.voyage .screen .hyperdive-portal-1,
  .voyage .screen .hyperdive-portal-2,
    .voyage .screen .hyperdive-portal-3{
      position: absolute;
  left: calc(50% - 50px);
  top: calc(50% - 50px);
  width:100px;
  aspect-ratio: 1/1;
  transform: rotate(45deg);
  border-radius: 30px;
  animation: portal-shrink infinite 1.5s ease-in;
  opacity: 0;
  /*background-color: #000;*/
  border: 1px solid cyan;
}

.voyage .screen .hyperdive-portal-2{
  animation-delay: 0.5s;
}


.voyage .screen .hyperdive-portal-3{
    animation-delay: 1s;

}


@keyframes portal-shrink {
  0% {
    opacity: 0;
    transform: scale(2) rotate(45deg);
  }
  100% {
    opacity: 1;
    transform: scale(0) rotate(45deg);
  }
}


.voyage .screen .station-description{
  /*padding-top: 20px;*/
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap:var(--3);
}

.voyage .screen .station-description .description{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap:0;
  transition-duration: 0.2s;
  transition-timing-function: linear;
}


.voyage .screen .station-marker{
  width:26px;
  height: 26px;
  margin: var(--3);
  border: 1px solid cyan;
  transform: rotate(45deg);
  border-radius: 2px;
}



.voyage .screen .station-marker::after{
  content: '';
  position: absolute;
  top: var(--1);
  left: var(--1);
  right: var(--1);
  bottom: var(--1);
  background-color: cyan;
  animation: pulsate 2s infinite ease-in-out;
}

.voyage .screen .station-marker-2{
  width:110px;
  height: 110px;
  margin: var(--3);
  border: 1px solid #888;
  transform: rotate(45deg);
  border-radius: 20px;
  background-color: var(--background-color);

}

.voyage .screen .station-marker-2::after{
  content: '';
  position: absolute;
  top: var(--2);
  left: var(--2);
  right: var(--2);
  bottom: var(--2);
  transform: translate(-20px,20px);
  border-left: 1px solid cyan;
  border-bottom: 1px solid cyan;
  animation: pulsate 2s infinite ease-in-out;
  border-radius: 0 22px 0 22px;
}

.voyage .screen .station-marker-2::before{
  content: '';
  position: absolute;
  top: var(--2);
  left: var(--2);
  right: var(--2);
  bottom: var(--2);
  transform: translate(20px,-20px);
  border-right: 1px solid cyan;
  border-top: 1px solid cyan;
  animation: pulsate 2s infinite ease-in-out;
  border-radius: 0 22px 0 22px;
}

.voyage .screen .player-marker{
  position: absolute;
  width: 0px;
  height: 0px;
  animation: marker-float-animation 10s ease infinite;
  z-index: 10;
  pointer-events: none;
  -webkit-user-select: none ;
          user-select: none ;

}


.voyage .screen .player-marker .label{
  position: absolute;
  left: 50px;
  bottom: 20px;
  text-wrap: nowrap;
  z-index: 10;
  /*border-left: 1px solid cyan;*/
  border-bottom: 1px solid transparent;
  padding-top: 0px;
  padding-left: var(--2);
  
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
  
}


.voyage .screen .player-marker .label::after123{
  content: '';
  position: absolute;
  left: -15px;
  bottom: -35px;
  width: 29px;
  height: 29px;
  border-right: 1px solid transparent;

  border-top: 1px solid cyan;
  transform: rotate(-45deg);
}


.voyage .screen .player-marker .label .extra-label{
  position: absolute;
  display: flex;
  flex: none;
  top: 0px;
  left:-140px;
  width: 130px;
  justify-content: end;
  text-align: end;
  overflow: hidden;
  background-color: var(--background-color-transparent);
}


.scan-wave{
  position: absolute;
  top: -38px;
  left: -35px;
  width:100px;
  opacity: 0;
  height:100px;
  border-radius: 50px;
  border: 1px solid #888;
  animation: scan-wave-animation 7s linear infinite;
}

.voyage .screen .player-marker .marker{
  position: absolute;
  top: 0;
  left: 0;
  transform: rotate(180deg);
  height: 31px;
  width: 31px;
}

.voyage .screen .player-marker .tracer{
  position: absolute;
  width: 1px;
  left: 15px;
  height: 80px;
  top: 26px;
  opacity: 0.5;
  background: linear-gradient(cyan, transparent, transparent);
	background-size: 100% 200%;
  transform-origin: top;

  animation: tracer-flame-animation 2s linear infinite;

}


.overfloat-inventory{
  position: absolute;
  left: 0px;
  top: 0px;
  width: auto;
  height: auto;
  z-index: 100;
  opacity: 0;
  transition-duration: 0.4s;
  transition-timing-function: ease;
  pointer-events:all;
}

.overfloat-inventory.reveal{
  opacity: 1;
}

.overfloat-inventory .inventory-background-circle{
  position: absolute;
  left: -85px;
  top:-87px;
  width: 200px;
  height: 200px;
  z-index: 50;
  border-radius: 100px;
  opacity: 0.5;
  background-color: #000;
}

.overfloat-inventory .inventory-circle{
  position: absolute;  

  left: -15px;
  top:-17px;
  width: 60px;
  height: 60px;
  z-index: 100;
  border-radius: 0px;
  border: 1px solid cyan;
  border-radius: 0 0 4px 4px;
}

.overfloat-inventory .hull-name{
  position: absolute;
  left: -15px;
  top:-29px;
  width: 60px;
  max-width: 60px;
  z-index: 100;
  background-color: cyan;
  color:var(--background-color);
  text-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: var(--1);
  border-radius: 4px 4px 0 0;
}


.overfloat-inventory .inventory-list{
  position: absolute;
  left: -20px;
  top:70px;
  z-index: 100;
  width:auto;
  display: flex;
  flex-direction: column;
  padding: var(--1);
}

.module-block-connector{
  border-top: 1px solid cyan;
  position: absolute;
  left: -51px;
  top: 46px;
  width: 34px;
  transform: rotate(-30deg);
}


.crew-block-connector{
  border-top: 1px solid cyan;
  position: absolute;
  right: -81px;
  bottom: 30px;
  width: 34px;
  transform: rotate(-30deg);
}


.overfloat-inventory .inventory-list.module-list{
  left: -49px;
  top: 55px;
  border-left: 1px solid cyan;
}

.overfloat-inventory .inventory-list.crews-list{
  left: -50px;
  top: -95px;
  text-align: end;
  border-right: 1px solid cyan;
}

.overfloat-inventory .inventory-list .list-item{
  color: cyan;
  background-color: var(--background-color);
  text-wrap: nowrap;
  flex: none;
  width: 120px;
  overflow: hidden;
  background-color: var(--background-color);
  text-overflow: ellipsis;
}

.overfloat-inventory .inventory-list .list-item.section-name{
  background-color: cyan;
  color: var(--background-color);
  padding-left: var(--1);
  padding-right: var(--1);
}

.player-marker.marker-1{
  left:calc(50% - 15px);
  top:calc(50% - 25px);
}

.marker-main-svg-line{
  position: absolute;
  top:0;
  left:-40px;
}


.player-marker.marker-2{
  left:calc(65% - 15px);
  top:calc(50% + 70px);
}

.player-marker.marker-2,
.player-marker.marker-2 .scan-wave,
.player-marker.marker-2 .tracer{
  animation-delay: 0.5s !important;
}

.player-marker.marker-3{
  left:calc(35% - 15px);
  top:calc(50% + 70px);
}


.player-marker.marker-3,
.player-marker.marker-3 .scan-wave,
.player-marker.marker-3 .tracer{
  animation-delay: 1.5s !important;
}


@keyframes img-float-animation {
  0% {
    transform: translate(0, 0);
  }
  50% { 
    transform: translate(0px,-10px);
  }
  100% { 
    transform: translate(0, 0);
  }
}

@keyframes marker-float-animation {
  0% {
    transform: translate(0, 0);
  }
  20% { 
    transform: translate(-4px,2px);
  }
  40% { 
    transform: translate(0px,0px);
  }
  50% { 
    transform: translate(2px,2px);
  }
  70% { 
    transform: translate(4px,0px);
  }
  90% { 
    transform: translate(4px,-2px);
  }

  100% { 
    transform: translate(0, 0);
  }
}

@keyframes scan-wave-animation {
  0% {
    transform: scale(0.5);
    opacity: 1;
  }
  10% { 
    transform: scale(2);
    opacity: 0;
  }
  100% { 
    transform: scale(0.5);
    opacity: 0;
  }
}


@keyframes tracer-flame-animation {
  0%{background-position:0% 0%}
  50%{
    background-position:0% 0%;
  }
  60%{
    background-position:0% 50%;
  }
  70%{
    background-position:0% 0%;
  }
  80%{
    background-position:0% 40%;
  }

  100%{background-position:0% 0%}
}

@keyframes tracer-shift-animation {
  0%{transform: rotate(0)}
  40%{
    background-position:0% 30%;
    transform: rotate(5deg)
  }
  70%{
    background-position:0% 40%;
    transform: rotate(-5deg)
  }
  90%{
    background-position:0% 40%;
    transform: rotate(3deg)
  }

  100%{transform: rotate(0)}
}

.voyage .screen .warning-message{
  z-index: 160;
  /*position: absolute;
  left:calc(50% - 100px);
  top: calc(50% - 30px);
  top: -10px;*/
  opacity: 0.8;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--2);
  width: 200px;
  margin:auto;
  pointer-events: none;
}

.warning-message .red-alarm{
  background-color: red;
  color: black;
}

.top-center-loc-bar{
  position: absolute;
  z-index: 20;
  left:30%;
  right:30%;
  top: 0px;
  border-top: 1px solid var(--background-color);
  -webkit-user-select: none ;
          user-select: none ;
  transition-duration: 0.1s;
  transition-timing-function: ease-in-out;
}

.top-center-loc-bar .destination-btn{
  text-wrap: nowrap;
}

.top-center-loc-bar .label-bar{
  width: 100%;
  text-align: center;
  border-radius: var(--border-radius);
  color: #888;
  padding:var(--2);
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
  transition-duration: 0.4s;
  transition-timing-function: ease-in-out;
}

.top-center-loc-bar .label{  
  color: #888;
  transition-duration: 0.4s;
  transition-timing-function: ease-in-out;
}

.top-center-loc-bar .position-bar{
  height: 8px;
  position: relative;
  width: calc(100%);
  border: 1px solid #888;
  border-top: none;
  border-radius:  0 0 var(--border-radius) var(--border-radius);
  transition-duration: 0.4s;
  transition-timing-function: ease-in-out;
}


/*
.top-center-loc-bar.active .label-bar,
.top-center-loc-bar.active .position-bar {
  border-color: cyan;
  color: cyan
}
*/

.top-center-loc-bar .position-bar .rail-bar{
  height: 100%;
  position: relative;
  width: calc(100%);
  display: flex;
  flex-direction: row;
  gap: var(--1);
  padding: var(--1);
}

.top-center-loc-bar .position-bar .rail-bar.danger-1 .danger-mark{
  background-color: #888;
}

.top-center-loc-bar .position-bar .rail-bar.danger-2 .danger-mark{
  background-color: var(--main-color);
}
.top-center-loc-bar .position-bar .rail-bar.danger-3 .danger-mark{
  background-color: var(--main-color);
  animation: pulsate 2s infinite;
}

.top-center-loc-bar .position-bar .rail-bar .position-mark{
  position: absolute;
  margin: var(--1);
  height: 100%;
  height: 4px;
  max-width: calc(100% - 2* var(--1));
  top:-6px;
  left: 0;
  background-color: cyan;
  transition-duration: 1s;
  transition-timing-function: ease-in-out;
  border-radius: var(--border-radius);
}

.top-center-loc-bar .position-bar .rail-bar .danger-mark{
  height: 4px;
  width: calc((100% - 2 * var(--1))/3);
  background-color: cyan;
  transition-duration: 1s;
  transition-timing-function: ease-in-out;
  border-radius: var(--border-radius);
}

.top-center-loc-bar .position-bar .rail-bar .danger-mark.disabled{
  width: 0;
}

.voyage .screen-bottom .left-info-bar,
.voyage .screen-bottom .right-info-bar{
  position: absolute;
  z-index: 10;
  left: 0;
  top:  0;
  height: calc(100% - var(--2));
}


.voyage .screen-bottom .right-info-bar{
  right: 0;
  left: auto;
}


.voyage .screen-bottom .right-corner-info,
.voyage .screen-bottom .left-corner-info{
    position: absolute;
  z-index: 10;
  left: calc(4 * var(--2));
  bottom:  var(--2);
  color: var(--main-color)
}

.voyage .screen-bottom .right-corner-info{
  right: calc(4 * var(--2));
  left: auto;
  bottom:  var(--2);
  top:auto;
}


.altitude-bar{
  position: relative;
  display: flex;
  flex:auto;
  flex-direction: column;
  align-items: end;
  height: calc(100%);
  justify-content: stretch;
  border-radius: 0;
  border: none;
  width: 8px;
  border-bottom: 1px solid #888;
  border-right: 1px solid #888;
  border-radius: 0 0 4px  0;
  -webkit-user-select: none ;
          user-select: none ;

  height: 150px;
  border-radius: 0 !important;
  border: 0 !important ;
}


.altitude-bar .full-scale{
  height: auto;
  flex: auto;
  width: calc(100%);
  border-top: 1px solid #888;
  position: relative;
  opacity: 1;  

  transition-duration: 1s;
  transition-timing-function: ease-in-out;

}


.altitude-bar .no-scale{
  height: auto;
  flex: auto;
  width: calc(100%);
  position: relative;
}

 .altitude-bar .label,
 .altitude-bar .end-label{
  position: absolute;
  left: -20px;
  top: -9px;
  height: 16px;
  width: 20px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888;

  transition-duration: 1s;
  transition-timing-function: ease-in-out;
}


.altitude-bar .full-scale.highlighted,
.altitude-bar .empty.highlighted,
.altitude-bar .end-label.highlighted{
    opacity: 1
}

.altitude-bar .end-label{
  top: auto;
  bottom: -8px;
  opacity: 0.5;

  transition-duration: 1s;
  transition-timing-function: ease-in-out;
}


.altitude-bar.left .label{
  left: auto;
  right: -20px;
}

.altitude-bar.left .end-label{
  left: auto;
  right: -20px;
}

.altitude-bar .half-scale{
  height: auto;
  flex: auto;
  width: calc(60%);
  border-top: 1px solid #888;
  position: relative;
  opacity: 1;
  margin: calc(20%);

  

  transition-duration: 1s;
  transition-timing-function: ease-in-out;

}
.altitude-bar .empty{
  height: auto;
  flex: auto;
  width: calc(100%);
  position: relative;
  border-top: 1px solid transparent;
  opacity: 0.5;

  

  transition-duration: 1s;
  transition-timing-function: ease-in-out;
}


.altitude-bar .scale-marker{
  position: absolute;
  height:0%;
  width: calc(100%);
  bottom: 0;
  left: 0px;
  opacity: 1;
  transition-duration: 1s;
  transition-timing-function: ease-in-out;
}

.altitude-bar .scale-marker .marker-label{
  position: absolute;
  right: 9px;
  top: -8px;
  border: 1px solid #888;
  height: 16px;
  padding-right: 15px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  text-align: center;
}

.altitude-bar .scale-marker .marker-label small{
  height: calc(100%);
  background-color: #888;
  color: var(--background-color);
  padding-left: var(--1);
  padding-right: var(--1);
  vertical-align: center;
}

.altitude-bar.left .scale-marker .marker-label{
  right: auto;
  text-align: left;
  left: 9px;
  padding-left: 15px;
  padding-right: 0;
}

.altitude-bar .scale-marker .marker-label.negative1{
  border-color: white;
}
.altitude-bar .scale-marker .marker-label.negative1 small{
  background-color: white;
}


.altitude-bar.left{
  border-left: 1px solid #888;
  border-right: none;
  align-items: start;
  border-radius: 0 0 0 4px;
}



.voyage .screen-bottom .stat-bar{
  flex:auto;
  flex-direction: column;
  align-items: start;
  height: calc(100%);
  border-radius: 0;
  border: none;
  border-bottom: 1px solid var(--main-color);
}

.voyage .screen-bottom .stat-bar .full,
.voyage .screen-bottom .stat-bar .empty{
  width:auto;
  border: none;
  border-bottom: 1px solid var(--main-color);
  border-left: 1px solid var(--main-color);
  flex:auto;
  width: 6px;
}



.voyage .screen-bottom .stat-bar .full{
  position: relative;
  width: 10px;
}

.voyage .screen-bottom .right-info-bar .stat-bar{
  align-items: end;
}

.voyage .screen-bottom .left-info-bar .stat-bar .full,
.voyage .screen-bottom .left-info-bar .stat-bar .empty{
  border: none;
  border-top: 1px solid var(--main-color);
  border-left: 1px solid var(--main-color);
}

.voyage .screen-bottom .left-info-bar .stat-bar .full::afterzz,
.voyage .screen-bottom .right-info-bar .stat-bar .full::afterzz{
  position: absolute;
  top: -1px;
  bottom: -1px;
  left:-1px;
  right: 50%;
  content: '';
  border-top: 2px solid var(--background-color);
}

.voyage .screen-bottom .right-info-bar .stat-bar .full::afterzz{
  right:-1px;
  left: 50%;
  border-right: 1px solid var(--background-color);
}


.voyage .screen-bottom .right-info-bar .stat-bar .full,
.voyage .screen-bottom .right-info-bar .stat-bar .empty{
  border: none;
  border-top: 1px solid var(--main-color);
  border-right: 1px solid var(--main-color);
}

.voyage .screen-bottom .title{
  background-color: #888;
  width:100%;
}

.voyage .content{
  position: absolute;
  z-index: 10;
  left: 100px;
  right: 0px;
  top: 0px;
  bottom: 0px;
}


.voyage-stats-list{
  min-width: 150px;
  color: var(--main-color);
  flex:none;
  display: flex;
  flex-direction: column;
}

.voyage-stats-list.right{
  text-align: right;
  justify-content: end;
  align-items: end;
}

.voyage-stats-list .positive-stat{
  color: cyan;
}


.voyage-stats-list .negative-stat{
  color: red;
}



.voyage-stats-list .stat{
  position: relative;
  text-wrap: nowrap;
  white-space: nowrap;
}


.voyage-stats-list .stat.short-wrapable{
  width: 70%;
  text-wrap:wrap ;
  white-space: wrap;
}

.voyage-stats-list.cut-content{
  gap:var(--1);
}

.voyage-stats-list.cut-content .stat{
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--main-color);
  width: 100%;
}

.voyage-stats-list.cut-content .stat:hover{
  overflow: hidden;
  text-overflow: ellipsis;
  width: auto;
  color: #fff;
}

/*
.voyage-stats-list .stat .delta-stat{
  position: absolute;
  right: 0px;
  top: 0px;
  background-color: var(--background-color);
}

.voyage-stats-list.right .stat .delta-stat{
  right: auto;
  left: 0px;
}
*/



.stat-bar{
  display: flex;
  flex-direction: row;
  gap: 0px;
  align-items: start;
  align-self: flex-start;
  width: -moz-fit-content;
  width: fit-content;
  flex:none;
  overflow: hidden;
  flex-wrap: nowrap;
  border-bottom: 1px solid var(--main-color);
}


.stat-bar .full,
.stat-bar .empty{
  height:3px;
  width:16px;
  flex:none;

  background-color: var(--main-color);
}
.stat-bar .empty{
  background-color: transparent;
  border-right: 1px solid var(--main-color);
}


.voyage .screen-bottom .group-window .steps-bottom-stats{
  z-index: 100;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: start;
  padding: var(--2);
  padding-top: 0px;
  gap: var(--1);
  left:0;
  bottom: -25px;
  width: 800px;
}


.voyage .screen-bottom .group-window .steps-bottom-stats .text-stats{
  z-index: 100;
  position: absolute;
  padding: var(--2);
  gap: var(--1);
  top:5px;
  left: 0px;
  color: var(--secondary-color); 
  width: var(--group-window-size);
}


.group-window .steps-bottom-stats .stat-bar{
  flex:auto;
  width: calc(var(--group-window-size) - 2 * var(--2) - 2px);
  border-radius: 0;
  border: none;
}

.group-window .steps-bottom-stats .stat-bar .full,
.group-window .steps-bottom-stats .stat-bar .empty{
  width:auto;
  border: none;
  border-top: 1px solid var(--main-color);
  border-right: 1px solid var(--main-color);
  flex:auto;
  height: 6px;
}

.group-window .steps-bottom-stats .stat-bar .full{
  height: 10px;
}



.voyage .screen-bottom .group-window .layer-left-stats{
  z-index: 100;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: start;
  padding: var(--2);
  padding-top: 0px;
  gap: var(--1);
  left:0;
  bottom: 0;
}

.voyage .screen-bottom .group-window .layer-left-stats .text-stats{
  z-index: 100;
  position: absolute;
  gap: var(--1);
  right:-35px;
  top:35px;
  color: var(--secondary-color); 
  width: var(--group-window-size);
  transform: rotate(-90deg);
}


.group-window .layer-left-stats .stat-bar{
  flex:auto;
  flex-direction: column;
  align-items: end;
  height: calc(100%);
  border-radius: 0;
  border: none;
}

.group-window .layer-left-stats .stat-bar .full,
.group-window .layer-left-stats .stat-bar .empty{
  width:auto;
  border: none;
  border-top: 1px solid var(--main-color);
  border-right: 1px solid var(--main-color);
  flex:auto;
  width: 6px;
}

.group-window .layer-left-stats .stat-bar .full{
  width: 10px;
}


.voyage .stats-passive{
  position: absolute;
  z-index: 10;
  bottom:  var(--2);
  width: auto;
  right: var(--2);
  padding: var(--2);
  color: var(--main-color);
}


.cross-background-old {
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  aspect-ratio: 1/1;
  z-index: 1;
  background: 
  radial-gradient(circle, transparent 10%, var(--background-color) 10%),
  linear-gradient(0deg, transparent 49.5%, var(--main-color) 49.5%, var(--main-color) 50.5%, transparent 50.5%), 
  linear-gradient(90deg, transparent 49.5%, var(--main-color) 49.5%, var(--main-color) 50.5%, transparent 50.5%);
  background-size: 37px 37px;
  opacity: 0.5;
}

.cross-background{
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0;
  z-index: 1;

  background-color: #e5e5f7;
  opacity: 0.3;
  background: radial-gradient(circle, transparent 20%, var(--background-color) 20%,var(--background-color) 80%, transparent 80%, transparent), 
  radial-gradient(circle, transparent 20%, var(--background-color) 20%,var(--background-color) 80%, transparent 80%, transparent) 40px 40px, 
  linear-gradient(#888 2px, transparent 2px) 0 -1px,
  linear-gradient(90deg, #888 2px, var(--background-color) 2px) -1px 0;
  background-size: 80px 80px, 80px 80px, 40px 40px, 40px 40px;
}

.dotted-cross-background {
  position: absolute;
  left: -100px;
  right: -60px;
  top: -60px;
  bottom: -60px;
  z-index: 1;
  background: 
  radial-gradient(circle, transparent 2.5%, var(--background-color) 2.5%),
  linear-gradient(0deg, transparent 49.5%, var(--secondary-color) 49.5%, var(--secondary-color) 50.5%, transparent 50.5%), 
  linear-gradient(90deg, transparent 49.5%, var(--secondary-color) 49.5%, var(--secondary-color) 50.5%, transparent 50.5%);
  background-size: 73px 73px;
}

.cross-background-shift-far{
  opacity: 1;
  animation: cross-background-shift-animation-far 10s linear infinite;
}
.background-canvas-shift{
  opacity: 1;
  animation: background-canvas-shift-animation 140s linear infinite;
}

.background-canvas-shift-close{
  opacity: 1;
  animation: background-canvas-shift-animation 60s linear infinite;
}

.background-canvas-shift-far{
  opacity: 1;
  animation: background-canvas-shift-animation 200s linear infinite;
}

.cross-background-shift{
  opacity: 0.5;
  background-size: 101px 101px;
  animation: cross-background-shift-animation 4s linear infinite;
}

@keyframes background-canvas-shift-animation {
  0% {
    transform: translate(0, 0);
  }
  100% { 
    transform: translate(0,100%);
  }
}


@keyframes cross-background-shift-animation-far {
  0% {
    transform: translate(0, 0);
  }
  100% { 
    transform: translate(0,73px);
  }
}

@keyframes cross-background-shift-animation {
  0% {
    transform: translate(0, 0);
  }
  100% { 
    transform: translate(0,101px);
  }
}


.ui-window{
  z-index: 10;
  position: relative;
  width: calc(100%);
  flex:none;
  height: auto;
  display: flex;
  gap: 0;

  border: 1px solid #888;
  border-radius: var(--border-radius);
  overflow: hidden;

  flex-direction: row;
  flex-wrap: wrap;
  align-items: start;
  justify-content: space-evenly;
  gap:var(--3);
  max-width: 800px;
  border-radius: 10px;
}

.ui-window-title{
  z-index: 100;
  display: flex;
  flex-direction: row;
  width: calc(100%);
  justify-content: space-between;
  flex:none;
  color: var(--background-color);
  background-color: #888;
  padding-left:var(--2);
  padding-right:var(--2);
  padding: var(--2);
}


.tabs{
  width: calc(100%);
  display: flex;
  flex-direction: row;
  gap: 0;
  border-bottom: 1px solid #888;
}

.tabs .tab{
  padding: var(--2);
  padding-left: var(--4);
  padding-right: var(--4);
  text-align: center;
  color: #888;
  margin-bottom: -1px;
}

.tabs .tab.active{
  color: var(--main-color);
  border-bottom: 1px solid var(--main-color);
}

.journal{

  z-index: 9;
  display: flex;
  position: relative;
  flex-direction: column;
  width: calc(100%);

  color: var(--main-color);

  padding: 0;
  padding-top: 0;
  padding-bottom: 0;

  max-height: calc(100%);
  overflow: hidden;
  background-color: var(--background-color-transparent);
}

.journal .events{
  width: calc(100%);
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: var(--3);
  flex-direction: column-reverse;
  height: auto;
  overflow-y: scroll;
  padding: var(--1);
  padding-bottom: var(--3);
  padding-top: var(--3);
  
}


.journal .events::before {
  position: absolute;
  content: "";
  top: 0;
  left: var(--2);
  right: var(--2);
  height: 16px;  
  border-bottom: none;
  pointer-events: none;
  z-index: 100;
  /*border: 1px solid red;*/
  background: linear-gradient(var(--background-color), transparent);
}

.journal .events::after {
  position: absolute;
  content: "";
  bottom: 0;
  left: var(--2);
  right: var(--2);
  height: 16px;  
  border-bottom: none;
  pointer-events: none;
  z-index: 100;
  background: linear-gradient(transparent, var(--background-color));
}


.journal .hidden-closing-btn{
  width: 100%;
  height: 450px;
  content: '';
  position: absolute;
  top: -450px;
  background-color: transparent;
  
}

.journal.hidden {
  transform: translateY(calc(100%));
}


.journal .event{
  z-index: 10;
  position: relative;
  width: calc(100%);
  flex:none;
  text-wrap: balance;
  height: auto;
  color: #fff;
  border-left: 1px solid #888;
  padding-left: var(--2);
}

.journal .event.answer{
  text-align: right;
  border: none;
  padding-right: var(--2);
  color: var(--main-color);
  border-right: 1px solid var(--main-color);
}

.journal .event.answer.inactive{
  color: #888;
  border-right: 1px solid #888;
}


/*
.journal .event .description{
  display: flex;
  flex-direction: column;
  gap: var(--3);
  width: calc(100%);
  height: calc(100%);
  overflow: scroll;
  opacity: 1;
  flex:none;
  color: #fff;
  flex-direction: column-reverse
}
*/
.journal .event.description-appear{
  animation: description-appear 1s ease-in-out;
  overflow: hidden;
  max-height: 400px;

}

.journal .event-title,
.journal .event-note{
  width: calc(100%);
  color: var(--main-color);
  text-align: start;
  padding-left: var(--2);
  border-left: 1px solid #888;
  padding-bottom: var(--2);
  margin-bottom: calc(-1 * var(--3));
  text-transform: uppercase;
}


.journal .event-note{
  text-transform: none;
  border: none;
}

.journal .options-list{
  animation: description-appear 1s ease-in-out;
  overflow: hidden;
  max-height: 400px;
}


@keyframes description-appear {
  0% {
    max-height: 0;
  }
  80% {
    max-height: 300px;
  }
  100% {
    max-height: 400px;
  }
}


.journal .options-list .options-list-break{
  margin: 30px;
  height: 1px;
  width: calc(100% - 2* 30px);
}

.journal .event .title{
  display: flex;
  flex-direction: row;
  width: calc(100%);
  justify-content: space-between;
  flex:auto;
  color: var(--background-color);
  background-color: #888;
  padding-left:var(--2);
  padding-right:var(--2);
  padding: var(--2);

}


.journal.hidden .hidden-closing-btn{
  display: none;
}



.background-document{
  background: radial-gradient(ellipse at bottom right,var(--secondary-color), var(--main-color) );
}

.event-options{
  display: flex;
  flex-direction: row;
  position: relative;
  width: calc(100%);
  align-items: center;
  flex: none;
    
  
  transition-duration: 1s;
  transition-timing-function: ease-in-out;
}

.event-options .options-list{
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: auto;
  align-self: stretch;
  justify-content: center;
  margin-right: 0px;

}

.event-options .options-list .option{
  display: flex;
  flex-direction: column;
  text-align: start;
  cursor: pointer;
  margin: 0px;  
  text-align: left;
  color: #888;
  padding: var(--2);
  border-right: 1px solid #888;

}

.event-options .options-list .option.disabled-option{
  opacity: 0.5;
  margin: 0px;  
  border-right: 1px solid red;
  margin-right: 0px;
}

.event-options .options-list .option.disabled-option .requirements{
  color: red !important;
}

.event-options .options-list .option.disabled-option .title{
}

.event-options .options-list .option:active{
  margin: 0px;  
  margin-right: 0px;
  /*box-shadow: 1px 1px #009999; 

  border: 1px solid cyan;*/
  border-right: 1px solid #fff;
  color: #fff;

}



 .event-options .options-list .option:active .title{
  /*background-color: cyan !important;*/
  color: #888;
  
}


.event-options .options-list .option:active .cost,
.event-options .options-list .option:active .requirements{
  color: #888;
}


.event-options .options-list .option.selected{
  margin: 0px;  
  margin-right: 0px;
  /*box-shadow: 1px 1px #009999; 

  border: 1px solid cyan;*/
  border-right: 1px solid var(--main-color);
}

.event-options .options-list .option.selected .title{
  /*background-color: cyan !important;*/
  /*background-color:  var(--main-color)!important;*/
  color: var(--main-color);
  
}


.event-options .options-list .option.selected .cost,
.event-options .options-list .option.selected .requirements{
  color: #fff;
}


.option .title{
  text-wrap: nowrap;
  vertical-align: middle;
}



.option .option-body{
  width: calc(100%);
  color: #888;
}

.option .cost{
  width: calc(100%);
  color: #888;
}

.option .requirements{
  width: calc(100%);
  color: #888;
}


.journal .accept-btn{
  display: flex;
  flex-direction: row;
  border: 1px solid var(--main-color);
  border-top: 1px solid var(--background-color);
  background-color: var(--background-color);
  margin-top: -1px;
  overflow: hidden;
  padding: var(--2);
  width: 150px;
  border-radius: 0 0 var(--border-radius) var(--border-radius);
  justify-content: center;
}

.voyage .accept-btn:hover{
  background-color: var(--main-color);
  color: var(--background-color);
  border: 1px solid var(--main-color);

}

.voyage .accept-btn:active{
  background-color: #fff;
  border: 1px solid #fff;
  color: var(--background-color)
}


.journal .bottom-panel{

  position: relative;
  display: flex;
  flex-direction: row;
  gap: var(--2);
  width: calc(100%);
  justify-content: space-between;
  align-items: center;
  border-top:1px solid var(--main-color);
}

.journal .bottom-panel .calculation{
  width: calc(100%);
  max-height: 32px;
  color: white;
  padding: var(--2);
  text-overflow: ellipsis;
  white-space:nowrap;
  text-wrap: nowrap;
  overflow: hidden;
}

.journal .btn{
  /*border-radius: 0;*/
  height: 32px;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  text-overflow: ellipsis;
  align-items: center;
  gap: var(--2);
  white-space:nowrap;
  text-wrap: nowrap;
  overflow: hidden;
  background-color: var(--background-color);
  color: #fff;
  border: 1px solid #fff;
}

.journal .btn:active{
  background-color: var(--secondary-color);

}

.journal .order-btn.inactive{
  color: black;
}

.journal .next-target-btn{
  border: 1px solid var(--background-color) ;
  color: var(--background-color);
}




.card-roulette{
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin:20px;
}

.card-roulette .warp-card{
  position: relative;
  width:320px;
  /*aspect-ratio: 1 / 2;*/
  height:600px;
  flex:none;
  display: flex;
  flex-direction: column;
}



.warp-card .card-back{
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  transform-style: preserve-3d;
  transform-origin: center right;
  transition: transform 1s;
  backface-visibility: hidden;

  box-shadow: 2px 2px 20px 1px rgba(0, 0, 0, 1);  
  border: 2px solid var(--main-color);
  border-radius: 20px;
  background: #2E2E52;
 
  /*--dot-bg: #2E2E52;

  --dot-color: var(--secondary-color);
  --dot-size: 2px;
  --dot-space: 76px;
	background:
		linear-gradient(90deg, var(--dot-bg) calc(var(--dot-space) - var(--dot-size)), transparent 1%) center / var(--dot-space) var(--dot-space),
		linear-gradient(var(--dot-bg) calc(var(--dot-space) - var(--dot-size)), transparent 1%) center / var(--dot-space) var(--dot-space),
		var(--dot-color);*/
}

.dotted-background{
  --dot-bg: var(--background-color);

  --dot-color: var(--secondary-color);
  --dot-size: 1px;
  --dot-space: 18px;
  background-position: center center ;
	background:
		linear-gradient(90deg, var(--dot-bg) calc(var(--dot-space) - var(--dot-size)), transparent 1%) center / var(--dot-space) var(--dot-space),
		linear-gradient(var(--dot-bg) calc(var(--dot-space) - var(--dot-size)), transparent 1%) center / var(--dot-space) var(--dot-space),
		var(--dot-color);
}


.warp-card .card-back img{

  width:100%;
  height:100%;
  object-fit: cover;
}

.warp-card .card-back .moon{
  width: 200px;
  position: relative;
  aspect-ratio: 1/1;
  background-color: var(--secondary-color);
  border-radius: 100px;
  flex:none;
  align-self: center;
}

.warp-card .card-back .moon::after{
  position: absolute;
  width: 150px;
  top:25px;
  right:-3px;
  aspect-ratio: 1/1;
  background-color:  #2E2E52;
  border-radius: 75px;
  flex:none;
  align-self: center;
    content: "";
}

.warp-card .card-back .diamond1{
  width: 40px;
  position: absolute;
  right:125px;
  top:50px;
  aspect-ratio: 1/1;
  background-color: var(--secondary-color);
  transform: scaleX(0.5) rotate(45deg);
}

.warp-card .card-back .diamond2{
  width: 40px;
  position: absolute;
  right:125px;
  bottom:50px;
  aspect-ratio: 1/1;

  background-color: var(--secondary-color);
  transform: scaleX(0.5) rotate(45deg);
}


.warp-card .is-flipped {
  transform: translateX(-100%) rotateY(-180deg);
}


.warp-card .card-face{
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  cursor: pointer;
  transform-style: preserve-3d;
  transform-origin: center right;
  transition: transform 1s;
  backface-visibility: hidden;
  box-shadow: 2px 2px 20px 1px rgba(0, 0, 0, 1);  
  border: 1px solid var(--main-color);
  border-radius: 20px;
  background: #2E2E52;

}

.warp-card .card-face .header{
  width: 100%;
  padding: 10px;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid var(--main-color);
  backface-visibility: hidden;
  position: relative;
}

.warp-card .card-face .header::before{
  content: "";
  position: absolute;
  bottom:-11px;
  right:10px;
  background: #2E2E52;
  width: 70px;
  height:10px;
  border: 1px solid var(--main-color);
  border-top: 0px solid var(--main-color);
  border-radius: 0px 0px 10px 10px;
  z-index: 10;
}

.warp-card .card-face .pic{
  position: relative;
  width: 100%;
  height: 200px;
  border-bottom: 1px solid var(--main-color);
  overflow: hidden;
  flex:none;
  backface-visibility: hidden;
}

.warp-card .card-face .pic img{
  width:100%;
  height: 100%;
  object-fit: cover;
  z-index: 10;
}

.warp-card .card-face .description{
  display: flex;
  backface-visibility: hidden;
  flex: auto;
  align-self: stretch;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  width: 100%;
  padding: 10px;
  gap:5px;
  min-height: 150px;
  font-weight: 200;
  line-height: 30px;
  overflow: scroll;
}

.voyage .answers-section{
  position: relative;
  width:300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  gap:30px;
  border-radius: 10px;
}

.voyage .answers-section .answers{
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  gap:10px;
}

.voyage .answers-section .answers .answer{
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  width: 100%;
  padding: 10px;
  border: 1px solid var(--main-color);
  border-radius: 20px;
  gap:5px;
  background: #2E2E52;
}

.voyage .answers-section .answer:before {
  content: ;
  position:absolute;
  top:-40px;
  left:0;
  height:40px;
  width: 40px;
  border-bottom-left-radius: 50%;
  background:#000;
  box-shadow: 0 20px 0 0 #522d5b;
}

.voyage .answers-section .answers .answer:hover{
  color:#000;
  background-color: var(--main-color);
}

.voyage .answers-section .answers .answer:active{
  color:#000;
  background-color: #fff;
}

.voyage .answers-section .group-stats{

}

.on-graph-stats{
  /*background-color: rgba(0, 0, 0, 0.7);*/
  color: white;
  flex-wrap: none;
  text-wrap: nowrap;
  margin-left:15px;
  height: 16px;
  margin-top:-12px;
}

.waiting-room{
  display: flex;
  color: var(--main-color);
  flex-direction: column;
  gap:0px;
  /*max-width: 800px;
  margin:auto*/
  overflow-y: hidden;
}

.auto-chat{
  display: flex;
  height: 300px;
  max-height: 300px;
  flex-direction: column;
  gap: 10px;
  width: 300px;
  overflow-y: scroll;
  padding-top:10px;
}
.auto-chat .chat-message{
  padding: 10px;
}

.auto-chat .chat-message.primary{
  color:var(--main-color);
  border-left: 2px solid var(--main-color);
}

.auto-chat .chat-message.secondary{
  color:#888;
  border-left: 2px solid #888;
}

.auto-chat .chat-message.warning{
  color:red;
  border-left: 2px solid red;
}

.waiting-room .header{
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  text-align: center;
  width: 300px;
  height: 50px;
  align-items: center;
  padding: 20px;
  justify-content: center;
  background-color:var(--main-color);
  color:#000;
}

.waiting-room .header.inactive{
  border: 1px solid var(--main-color);
  background-color:transparent;
  color:var(--main-color);
}

.waiting-room .btns-section{
  display: flex;
  height: 300px;
  max-height: 300px;
  flex-direction: column;
  gap: 10px;
  width: 300px;
  padding: 10px;
  overflow-y: scroll;
  align-items: center;
}

.pulsate{
  animation: pulsate 1.5s infinite;
}

.blink{
  animation: pulsate 0.5s infinite;
}

.pulsate-once{
  animation: pulsate-once 1s;
}

.pulsate-once-fast{
  animation: pulsate-once 0.3s;
}


.hide-after-animation{
  animation: hide 3s ease-out;
  opacity: 0;
  pointer-events: none;
}

@keyframes hide {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.radar-indicator{
  position: relative;
  color: var(--main-color);
  padding-left: 24px;
  margin-top:-12px;
  cursor: 'default'; 
  display: flex;
  gap:2px;
  flex:none;
  align-items: start;
  flex-direction: column;
} 


.radar-indicator .row{
  max-width: 200px; 
  min-width: 40px;
  padding:0px;
  text-wrap: nowrap;
  flex-wrap: none;
  line-height: 12px;
  max-height: 12px;

  overflow: hidden;
  opacity: 0.8;
  flex:none;
}

.radar-indicator .row.highlight{
  padding-left: 2px;
  padding-right: 2px;

}

.radar-animation-indicator {
  position: relative;
  color: var(--main-color);
  padding-left: 14px;
  margin-top:-11px;
  cursor: 'default'; 
  display: flex;
  gap:2px;
  flex:none;
  align-items: start;
  flex-direction: column;
  pointer-events: none;
}

.radar-animation-indicator .jets-marker{
  left: -6px;
  top:6px;
  position: absolute;
  width: 12px;
  height: 12px;
  border: 4px dotted #fff;
}

.radar-animation-indicator .jets-marker.red{
  border: 4px dotted red;
}

.radar-animation-indicator .jets-marker.cyan{
  border: 4px dotted cyan;
}


.triangle{
	content:'';
	position:relative;
  left: -17px;
  top:-8px;
	width:0px;
	height:0px;
	border-left: 4px solid transparent;
	border-right: 4px solid transparent;
	border-bottom: 7px solid cyan;
  transform: rotate(180deg);
}

.triangle::before{
	content:'';
	position:absolute;
	display:block;
	border-left: 4px solid transparent;
	border-right: 4px solid transparent;
	border-bottom: 7px solid cyan;
	top:9px;
	left:-9px;
}

.triangle::after{
	content:'';
	position:absolute;
	display:block;
	border-left: 4px solid transparent;
	border-right: 4px solid transparent;
	border-bottom: 7px solid cyan;
	top:9px;
  left:1px;
}

.triangle.red,
.triangle.red::after,
.triangle.red::before{
	border-bottom: 7px solid red;
}


.radar-animation-indicator .rocket-aim-styler{
  left: -12px;
  top:0px;
  position: absolute;
  width: 24px;
  height: 24px;
  border: 1px solid #888;
}


.radar-animation-indicator .heat-trap-animation{
  left: -12px;
  top:0px;
  position: absolute;
  width: 24px;
  height: 24px;
  animation-delay: 0ms;
  align-items: center;
  transform:  scale(1);
  opacity: 0.8;
  text-align: center;
  color: #fff;
  border: 1px solid #fff;
}

.radar-animation-indicator .heat-trap-animation{
  animation: heat-trap 0.6s infinite;
}

.radar-animation-indicator .heat-trap-animation.red-marker{
  animation: heat-trap-red 0.6s infinite;
}


@keyframes heat-trap{
  0%, 50%, 100%{
    color: #fff;
    border: 1px solid #fff;
    transform: none;
  }
  30%{
    border: 1px solid cyan;
    transform: scew(15deg, 15deg);
    color: cyan;
  }

}

@keyframes heat-trap-red{
  0%, 50%, 100%{
    color: #fff;
    border: 1px solid #fff;
    transform: none;
  }
  30%{
    border: 1px solid red;
    transform: scew(15deg, 15deg);
    color: red;
  }

}

.radar-animation-indicator .ew-pulse-animation{
  left: -20px;
  top:-8px;
  position: absolute;
  width: 40px;
  height: 40px;
  background: radial-gradient(transparent, var(--background-color));
  animation: ew-pulse 1s infinite;
  border-radius: 20px;
}

@keyframes ew-pulse{
  0%{
    opacity: 1;
    transform: scale(1);
  }
  100%{
    opacity: 2;
    transform: scale(10);
  }
}

.radar-animation-indicator .ew-animation{
  left: -20px;
  top:-8px;
  position: absolute;
  width: 40px;
  height: 40px;
  opacity: 0.8;
  border: 1px solid #888;
}



.radar-animation-indicator .ew-animation::after{
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  border: 1px solid red;
  animation: ew-glitch 0.3s infinite;
  animation-delay: 0ms;
}

.radar-animation-indicator .ew-animation::before{
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  border: 1px solid cyan;
  animation: ew-glitch2 0.4s infinite;
  animation-delay: 130ms;
}

@keyframes ew-glitch{
  0%, 100%{
    top: 0px;
    left: 0;
    opacity: 1;
  }
  20%{
    top: 0;
    left: -5px;
    opacity: 0.7;
    transform: scew(-15deg, -15deg);
    background-color: var(--background-color);
  }
  40%{
    top: 3px;
    left: 0;
    opacity: 0.2;
  }
  60%{
    top: 0;
    left: 7px;
    opacity: 0.3;
  }
  80%{
    top: 0;
    left: 3;
    opacity: 0.9;
    transform: scew(15deg, 15deg);
  }
}

@keyframes ew-glitch2{
  0%{
    top: 0;
    left: -10px;
    opacity: 0.7;
    transform: scew(-15deg, -15deg);
  }
  20%, 100%{
    top: 0px;
    left: 0;
    opacity: 1;
  }
  60%{
    top: -7px;
    left: 0;
    opacity: 0.2;
    transform: scew(35deg, 15deg);
  }
  80%{
    top: 0;
    left: -5px;
    opacity: 0.3;
    transform: scew(15deg, 15deg);
  }
  40%{
    top: 0;
    left: 0;
    opacity: 0.9;
  }
}


.rocket-aim-styler.red{
  border: 1px solid red;
}

.rocket-aim-styler.cyan{
  border: 1px solid cyan;
}

.station-radar-indicator{
  color: var(--main-color);
  padding-left: 0px;
  height:0px;
  cursor: 'default'; 
  display: flex;
  gap:2px;
  flex:none;
  align-items: start;
  flex-direction: column;
  position: relative;
  z-index: 10;
} 

.station-radar-indicator .row{
  position: absolute;
  padding:0px;
  text-wrap: nowrap;
  line-height: 12px;
  max-height: 12px;
  left: 0px;
  width: 2px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end;
  text-align: center;
  flex:none;
  top: -155px;
  opacity: 0.5;
  color: #fff;
  z-index: 10;
}
.station-radar-indicator .row small{
  text-wrap: nowrap;
}

.station-radar-indicator .indicators-column{
  position: absolute;
  padding:0px;
  line-height: 12px;
  left: 6px;
  display: flex;
  flex-direction: column;
  flex:none;
  top: -140px;
  opacity: 0.5;
  color: cyan;

  left:10px;
  top: -5px;
  z-index: 10;

}



.station-radar-indicator .line{
  position: absolute;
  top: -140px;
  height: 135px;
  width: 10px;
  border-left: 1px solid cyan;
  opacity: 0.5;
  z-index: 10;

}


.station-radar-indicator .center{
  position: absolute;
  bottom: -3px;
  left: -2px;
  height: 5px;
  width: 5px;
  border-radius: 2px;
  background-color: cyan;
  opacity: 1;
  z-index: 10;

}


.station-radar-indicator .gdp-circle{
  position: absolute;
  bottom: -16px;
  left: -15px;
  height: 31px;
  width: 31px;
  border-radius: 2px;
  background-color: cyan;
  border-radius: 50%;
  opacity: 0.2;
  z-index: 10;

}

.station-radar-indicator .gdp-circle.owned::after{
  content: '';
  position: absolute;
  top: -6px;
  left: -6px;
  width: calc(100% + 10px);
  height: calc(100% + 10px);
  border-radius: 50%;
  border: 1px solid cyan; 
}

.station-radar-indicator.selected .gdp-circle.owned::after{
  border: 1px solid var(--main-color); 
}

.station-radar-indicator .center-transparent-clickable{
  position: absolute;
  bottom: -11px;
  left: -10px;
  height: 20px;
  width: 20px;
  border-radius: 2px;
  background-color: transparent;
  border-radius: 50%;
}

.station-radar-indicator .row .name{
  color: cyan;
}

.station-radar-indicator.selected .line{
  border-left: 1px solid var(--main-color);
  opacity: 1;
}


.station-radar-indicator.selected .gdp-circle{
  background-color: var(--main-color);
}


.station-radar-indicator.selected .center{
  background-color: var(--main-color);
}

.station-radar-indicator.selected .row{
  opacity: 1;
}

.station-radar-indicator.selected .row .name{
  color: var(--main-color);
}

.station-radar-indicator.type2 .line{
  top: -170px;
  height: 165px;
}
.station-radar-indicator.type2 .row{
  top: -185px;
}
.station-radar-indicator.type2 .indicators-column123{
  top: -170px;
}


.station-radar-indicator.type3 .line{
  top: -50px;
  height: 45px;
}
.station-radar-indicator.type3 .row{
  top: -65px;
}
.station-radar-indicator.type3 .indicators-column123{
  top: -50px;
}




.secondary-order-btn,
.order-btn,
.next-target-btn,
.tabs-row,
.btn,
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

.yesselect {
  -webkit-touch-callout: text; /* iOS Safari */
    -webkit-user-select: text; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
            user-select: text; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}


.team-page{
  width: 100%;
  max-width: 600px;
  height: calc(100% - 90px);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  padding: var(--2);
  margin-bottom: 90px ;
  gap: var(--1);
}


.team-page .team-overview{
  position: relative;
  width:100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  flex: auto;
  gap: var(--1);
  overflow-y: scroll;
}

.team-overview .breakable-grid{
  width: calc(100%);
  position: relative;

  display: flex;
  flex-direction: row;
  align-items:stretch;
  gap:var(--1);
  flex-wrap: wrap;
}


.team-overview .breakable-grid .non-breaking-half{
  
  min-width: 258px; /*580/2 - 5px /2 = 258*/
  display: flex;
  flex:auto;
  flex-grow: 1;
  position: relative;
  flex-direction: column;
  gap:var(--1);
  flex-wrap: nowrap;
  align-items:stretch;

}

.team-overview .breakable-grid .non-breaking-half .full-block{
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  width: 100%;
  min-height: 50px;
  gap: var(--1);
  border: 1px solid #888;
  border-radius: var(--border-radius);
  flex:auto;
  padding: 10px;
}

.team-overview .breakable-grid .non-breaking-half .full-block.navigation{
  flex-direction: row;;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  gap: var(--4);
}

.team-overview .breakable-grid .non-breaking-half .line{
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: start;
  width: 100%;
  gap:var(--1);
  height: 80px;
  flex: none;
}

.team-overview .breakable-grid .non-breaking-half .line .non-flex-block{
  border: 1px solid #888;
  border-radius: var(--border-radius);
  padding:10px;
  height: 80px;
  width: 80px;
  flex:none;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: center;
}

.non-flex-block.karma-btn{
  background-color: var(--main-color);
  color: var(--background-color);
  border: 1px solid var(--main-color);
}

.team-overview .breakable-grid .non-breaking-half .line .flex-block{
  border: 1px solid #888;
  border-radius: var(--border-radius);
  padding:10px;
  height: 80px;
  flex:auto;
}

.team-overview .breakable-grid .non-breaking-half .line .flex-block.station-name{
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--2);
  align-items: center;
  text-align: center;
}

.hypderdive-circular-map{
  position: relative;
  width:100%;
  height: 100%;
  max-height: 90px;
  border-radius: var(--border-radius);
  overflow: hidden;
}


.hypderdive-circular-map .layer-5{
  position: absolute;
  width: 100%;
  height: 100%;
  top:0px;
  left:0px;
}

.hypderdive-circular-map .layer-4{
  position: absolute;
  aspect-ratio: 1/1;
  width:190px;
  right:calc(50% - 95px);
  top:calc(50% - 95px);
  border-radius: 95px;

  border: 1px solid var(--main-color);
  margin:auto;
  background-color: var(--background-color);
  animation: breath 4s infinite;
  animation-delay: 0ms;
}


.hypderdive-circular-map .layer-3{
  position: absolute;
  aspect-ratio: 1/1;
  width:150px;
  right:calc(50% - 75px);
  top:calc(50% - 75px);
  border-radius: 75px;

  border: 1px solid var(--main-color);
  margin:auto;
  background-color: var(--background-color);
  animation: breath 4s infinite;
  animation-delay: 200ms;
}

.hypderdive-circular-map .layer-2{
  position: absolute;
  aspect-ratio: 1/1;
  width:110px;
  right:calc(50% - 55px);
  top:calc(50% - 55px);
  border-radius: 55px;

  border: 1px solid var(--main-color);
  margin:auto;
  background-color: var(--background-color);
  animation: breath 4s infinite;
  animation-delay: 400ms;

}

.hypderdive-circular-map .layer-1{
  position: absolute;
  aspect-ratio: 1/1;
  width:70px;
  right:calc(50% - 35px);
  top:calc(50% - 35px);
  border-radius: 35px;

  border: 1px solid var(--main-color);
  margin:auto;
  background-color: var(--background-color);
  animation: breath 4s infinite;
  animation-delay: 600ms;
}

.hypderdive-circular-map .layer-0{
  position: absolute;
  aspect-ratio: 1/1;
  width:30px;
  right:calc(50% - 15px);
  top:calc(50% - 15px);
  border-radius: 15px 15px 15px 15px;
  border: 2px solid var(--main-color);
  margin:auto;
  background-color: var(--background-color);
  animation-delay: 800ms;
}

.hypderdive-circular-map .map-grid{
  position: absolute;
  width:100%;
  height: 1px;
  rotate: 0deg;
  left:0px;
  border-top: 2px dotted #888;
  top:calc(50% - 1px);
  /*animation: breath 10s infinite;
  animation-delay: 800ms;*/
}

.hypderdive-circular-map .map-grid2{
  position: absolute;
  height:100%;
  left: 50%;
  top:0;
  border-left: 1px solid #888;
}

.hypderdive-circular-map .player-icon-layer-5,
  .hypderdive-circular-map .player-icon-layer-4,
    .hypderdive-circular-map .player-icon-layer-3,
      .hypderdive-circular-map .player-icon-layer-2,
        .hypderdive-circular-map .player-icon-layer-1,
          .hypderdive-circular-map .player-icon-layer-0{
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  left:calc(50% - 118px);
  top:calc(50% - 3px);
  background-color: cyan;

}

.hypderdive-circular-map .player-icon-layer-4{left:calc(50% - 88px);}
.hypderdive-circular-map .player-icon-layer-3{left:calc(50% - 68px);}
.hypderdive-circular-map .player-icon-layer-2{left:calc(50% - 48px);}
.hypderdive-circular-map .player-icon-layer-1{left:calc(50% - 28px);}
.hypderdive-circular-map .player-icon-layer-0{left:calc(50% - 3px);}

.hypderdive-circular-map .border-wave-top{
  position: absolute;
  aspect-ratio: 1/1;
  width:300px;
  right:calc(50% - 150px);
  top:-280px;
  border-radius: 100px;

  border: 1px solid var(--main-color);
  margin:auto;
  background-color: var(--background-color);
}

.hypderdive-circular-map .border-wave-bottom{
  position: absolute;
  aspect-ratio: 1/1;
  width:300px;
  right:calc(50% - 150px);
  bottom:-280px;
  border-radius: 100px;

  border: 1px solid var(--main-color);
  margin:auto;
  background-color: var(--background-color);
}

.hypderdive-circular-map .title-bottom{
  position: absolute;
  display: flex;
  align-items: end;
  justify-content: center;
  bottom: var(--1);
  height: 15px;
  color: var(--main-color);
  left: 10%;
  width:80%;
  text-align: center;
}

.hypderdive-circular-map .title-top{
  position: absolute;
  display: flex;
  align-items: start;
  justify-content: center;
  top: 2px;
  height: 15px;
  color: var(--main-color);
  left: 10%;
  width:80%;
  text-align: center;
}



.hypderdive-circular-map .title-layer-5,
.hypderdive-circular-map .title-layer-4,
.hypderdive-circular-map .title-layer-3,
.hypderdive-circular-map .title-layer-2,
.hypderdive-circular-map .title-layer-1,
.hypderdive-circular-map .title-layer-0{
  position: absolute;
  display: flex;
  align-items: end;
  justify-content: start;
  bottom: 2px;
  height: 15px;
  padding-left: 2px;
  padding-bottom: -2px;
  border-left: 1px solid #888;
  color: #888;
  left: calc(50%);
  margin-left:-5px;
  margin-top:-10px;
}


.hypderdive-circular-map .title-layer-5{
  left: calc(50% - 125px);
  height: 25px;
}

.hypderdive-circular-map .title-layer-4{
  left: calc(50% - 85px);
  height: 8px;
}
.hypderdive-circular-map .title-layer-3{
  left: calc(50% - 65px);
  height: 13px;
}
.hypderdive-circular-map .title-layer-2{
  left: calc(50% - 45px)
}
.hypderdive-circular-map .title-layer-1{
  left: calc(50% - 25px)
}


.hypderdive-circular-map .active-layer{
  background-color: var(--main-color);
}
.team-overview .team-showroom{
  max-width:600px;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  gap:5px;
  padding: 10px;
  border-radius: var(--border-radius);
  border: 1px solid #888;

  --dot-bg: #2E2E52;

  --dot-color: var(--secondary-color);
  --dot-size: 1px;
  --dot-space: 24px;
	background:
		linear-gradient(90deg, var(--dot-bg) calc(var(--dot-space) - var(--dot-size)), transparent 1%) center / var(--dot-space) var(--dot-space),
		linear-gradient(var(--dot-bg) calc(var(--dot-space) - var(--dot-size)), transparent 1%) center / var(--dot-space) var(--dot-space),
		var(--dot-color);

}

.team-overview .team-showroom .ship-card{
  position: relative;
  height: 280px;
  width: 160px;
  border-radius: 80px;
  border: 1px solid #888;
  background-color: var(--background-color);
  flex:none;

}
.team-overview .team-showroom .ship-card .ship-img{
  position: absolute;
  top:0px;
  left:0px;
  width: 100%;
  aspect-ratio: 1/1;
  object-fit: contain;
}


.team-overview .team-showroom .ship-card .circle{
  position: absolute;
  top:20px;
  left:19px;
  height: 120px;
  width: 120px;
  background-color: var(--main-color);
  border-radius: 60px;
}

.team-overview .team-showroom .ship-card .circle::after{
  position: absolute;
  content:'';
  top:-10px;
  left:-10px;
  height: 140px;
  width: 140px;
  border: 1px solid #888;
  border-radius: 80px;
  margin:-1px;
}

.team-overview .team-showroom .ship-card .indicators{
  display: flex;
  flex-direction: row;
  position: absolute;
  top:138px;
  left:0px;
  height: 140px;
  width: 100%;
  border-radius: 80px;
  align-items: center;
  justify-content: stretch;
  text-align: center;
}

.team-overview .team-showroom .ship-card .indicators .indicators-name{
  display: flex;
  width: calc(50%);
  flex-direction: column;
  align-items: end;
  padding: 10px;
}
.team-overview .team-showroom .ship-card .indicators .indicators-count{
  display: flex;
  flex-direction: column;
  align-items: start;
  width: calc(50%);
  padding: 10px;
}

.team-overview .team-showroom .ship-card .indicators::before{
  position: absolute;
  content:'';
  top:0px;
  left:calc(50%);
  height: 100%;
  border-left: 1px solid #888;
}


.team-overview .team-showroom .ship-card.reversed .indicators{
  top:0px;
  justify-content: end;
}

.team-overview .team-showroom .ship-card.reversed .circle{
  top:138px;
}

.team-overview .team-showroom .ship-card.reversed .ship-img{
  top:auto;
  bottom:0px;
}



@keyframes pulsate {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes pulsate2 {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes pulsate-once {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes pulsate-twice {
  0% {
    opacity: 0;
  }

  90% {
    opacity: 0;
  }
  
  100% {
    opacity: 0.2;
  }
}
@keyframes pulsate-twice-2 {
  0% {
    opacity: 0;
  }

  90% {
    opacity: 0;
  }
  
  100% {
    opacity: 0.5;
  }
}



@keyframes breath {
  0% {
    opacity: 1;
  }
  25% {
    opacity: 1;
  }
  50% {
    opacity: 0.2;

  }
  75% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}

@keyframes singularity{
  0% {
  }
  25% {
    transform: rotate(100deg);
    box-shadow: rgba(240, 46, 170, 0.4) -5px 5px, rgba(240, 46, 170, 0.3) -10px 10px, rgba(240, 46, 170, 0.2) -15px 15px, rgba(240, 46, 170, 0.1) -20px 20px, rgba(240, 46, 170, 0.05) -25px 25px; 
  }
  50% {
    transform: rotate(200deg);
    box-shadow: rgba(240, 46, 170, 0.4) -5px 5px, rgba(240, 46, 170, 0.3) -10px 10px, rgba(240, 46, 170, 0.2) -15px 15px, rgba(240, 46, 170, 0.1) -20px 20px, rgba(240, 46, 170, 0.05) -25px 25px;
  }
  75% {
    transform: rotate(310deg);
    box-shadow: rgba(240, 46, 170, 0.4) -5px 5px, rgba(240, 46, 170, 0.3) -10px 10px, rgba(240, 46, 170, 0.2) -15px 15px, rgba(240, 46, 170, 0.1) -20px 20px, rgba(240, 46, 170, 0.05) -25px 25px;  
  }
  100% {
    transform: rotate(360deg);
  }
}


.fade-in{
  animation: fade 3s;
  animation-delay: 0ms;
}

@keyframes fade {
  0% {
    opacity: 0;
  }
  75% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.events-list{
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  width: 100%;
  padding: 20px;
  overflow-y: scroll;
  padding-bottom: 100px;
}

.events-list .top-stats{
  display: flex;
  flex-direction: row;
  gap:20px;
  color: #888;
}

.events-list .event{
  border-radius: 10px;
  /*border: 1px solid var(--main-color);*/
  display: flex;
  flex-direction: column;
}


.events-list .event .description{
  gap:10px;
  max-height: 40px;
  position: relative;
  padding-left: 30px;
}

.events-list .event .description::before{
  content:'';
  position: absolute;
  /*border: 1px solid var(--main-color);*/
  left: 15px;
  top:-10px;
  height: calc(100% + 10px);
  border-left: 1px solid var(--main-color);
}
.events-list .event .description.is_delayed::before{
  border-left: 1px dashed var(--main-color);

}
.events-list .event .description .hidden-text{
  gap:10px;
  height: 40px;
  position: relative;
  overflow: hidden;
  color: #888;
}

.events-list .event .description .hidden-text p{
  gap:10px;
  height: auto;
  padding-bottom: 40px;
  background-color: var(--background-color);
}

.events-list .event .description .hidden-text:hover{
  height: 40px;
  overflow: visible;
  z-index: 1000;
}

.events-list .event .consequences{
  display: flex;
  flex-direction: column;
  padding-left: 30px;

}

.events-list .consequence{
  gap:0px;
  position: relative;
  padding-top: 10px;
  padding-bottom: 10px;
}

.events-list .consequence::after{
  content:'';
  position: absolute;
  /*border: 1px solid var(--main-color);*/
  left: -15px;
  top:18px;
  width: 30px;
  border-top: 1px solid var(--main-color);
}

.events-list  .consequence::before{
  content:'';
  position: absolute;
  /*border: 1px solid var(--main-color);*/
  left: -15px;
  top:0px;
  height: 100%;
  border-left: 1px solid var(--main-color);
}

.events-list .consequence.consequence-last::before{
  left: -15px;
  top:0px;
  height: 19px;
}

.events-list .consequence .title{
  width: -moz-fit-content;
  width: fit-content;
  display: flex;
  flex-direction: row;
  align-items: start;
  gap:10px;
  height: 16px;
  padding-left: 30px;
}


.events-list .consequence .title::before{
  content:'';
  position: absolute;
  /*border: 1px solid var(--main-color);*/
  left: 10px;
  top:13px;
  height: 10px;
  width: 10px;
  background-color: var(--main-color);
}

.events-list .no-after-and-before::before{
  display: none;
}

.events-list .no-after-and-before::after{
  display: none;
}


.events-list .no-after-and-before::after{
  display: none;
}

.event-list-commands{
  position: fixed;
  display: flex;
  flex-direction: row;
  gap:40px;
  left:0;
  align-items: center;
  justify-content: center;
  bottom: 20px;
  width: 100%; 
}

/*

.typing-animation {
  color:#0000;
  background:
    linear-gradient(-90deg,#00DFFC 5px,#0000 0) 10px 0,
    linear-gradient(#00DFFC 0 0) 0 0;
  background-size:calc(var(--typing-animation-speed)*1ch) 200%;
  -webkit-background-clip:padding-box,text;
  background-clip:padding-box,text;
  background-repeat:no-repeat;
  animation: 
   b .7s infinite steps(1),   
   t calc(var(--typing-animation-speed)*.05s) steps(var(--typing-animation-speed)) forwards;
}

@keyframes t{
  from {background-size:0 200%}
}
@keyframes b{
  50% {background-position:0 -100%,0 0}
}*/

.background-roundwaves-pattern {
  background-color: var(--background-color);
  
  opacity: 0.8;
  background-image:  repeating-radial-gradient( circle at 0 0, transparent 0, var(--background-color) 10px ), repeating-linear-gradient( #888, var(--background-color) );
}

.background-diagonal-pattern{
  background-color:var(--background-color);
opacity: 0.8;
background-size: 30px 30px;
background-image: repeating-linear-gradient(45deg, #888 0, #888 1px, var(--background-color) 0, var(--background-color) 50%);
}

.stations-list{
  display: flex;
  flex-direction: column;
  gap: var(--2);
  width:calc(100%);
  height: calc(100%);
  overflow:hidden;
  overflow-y: auto;
}

.stations-list .station{
  border: 1px solid #888;
  display: flex;
  flex-direction: column;
  padding: var(--2);
  gap: var(--2);
  border-radius: var(--border-radius);
}

.inline-svg{
  display: inline-block;
  width: 1em; /* Matches the font size of the text */
  height: 1em; /* Matches the font size of the text */
  stroke: currentColor; /* This applies the text color to the SVG stroke, if applicable */
  vertical-align: middle;
}

.inline-svg-h2{
  display: inline-block;
  width: 1em; /* Matches the font size of the text */
  height: 1em; /* Matches the font size of the text */
  stroke: currentColor; /* This applies the text color to the SVG stroke, if applicable */
  vertical-align: middle;
  margin-bottom: 4px;
}

.svg-arrows{
  display: block;
  position: absolute;
  flex:none;
  z-index: 5;
  scale: 1 -1;
  pointer-events: none;
}

.svg-arrows.selected-target{
  z-index: 4;
}

.svg-arrows .arrow{
  opacity: 0.5;
  animation: pulsate 0.2s ease-in-out;
}

.svg-arrows .arrow-path-pulsate{
  animation: pulsate2 1.6s infinite ease-in-out;
}

.svg-arrows .arrow-path{
  animation: appear-delayed 0.6s ease-in-out;
  
}

.svg-arrows .arrow-selected-path{
  animation: appear-delayed  0.4s ease-in-out;
}

.svg-arrows .circle-path{
  animation: appear-with-scale-delayed 0.6 ease-in-out;
}

.arrow-days-label{
  position: absolute;
  flex: none;
  width: 2px;
  margin-left: -1px;
  margin-top: -1px;
  height: 2px;
  pointer-events: none;
  display: flex;
  flex-direction: row;
  align-items: center ;
  justify-content: center;
  text-align: center;
  transition-duration: 0.4s;
  transition-timing-function: ease-in-out;
  transition-delay: 0ms;
  z-index:110;
}

.arrow-days-label .grey-label,
.arrow-days-label .cyan-label{
  padding-left:2px;
  padding-right: 2px;
  border-left: 0px solid #888 ;
  color: #888;
  background-color: var(--background-color-transparent);
}
.arrow-days-label .cyan-label{
  border-left: 0px solid cyan ;
  color: cyan;
}
.station-section-block{
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  padding: var(--2);
  gap: var(--3);
  width: 100%;
  border: 1px solid #888;
  border-radius: var(--border-radius);
  overflow-y: scroll;
}


.station-section-block .station-influence-bar-section{
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  gap: var(--2);
  width: 100%;
  
  transition-duration: 1.5s;
  transition-timing-function: ease-in-out;

}

.station-influence-bar-section .station-influence-bar{
  width: calc(100%);
  height: 6px;
  position: relative;
  display: flex;
  flex-direction: row;
  gap:var(--1);
}

.station-influence-bar-section .station-influence-bar .segment{
  height: calc(100%);
  background-color: #888;
  width: calc(100%);
  border-radius: 3px;
  transition-duration: 1.5s;
  transition-timing-function: ease-in-out;
}

.station-influence-bar-section .station-influence-bar .segment.red{
  background-color: red;
}
.station-influence-bar-section .station-influence-bar .segment.cyan{
  background-color: cyan;
}

.station-influence-bar-section .legend{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  gap: var(--2);
}

.station-influence-bar-section .legend .legend-item {
  text-align: center;
  width: 100%;
}

.station-influence-bar-section .legend .legend-item.left {
  text-align: left;
}

.station-influence-bar-section .legend .legend-item.right {
  text-align: right;
}

.station-section-block .line-with-btns{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}

.inline-btn{
  border: 1px solid var(--main-color);
  color: var(--main-color);
  padding-left: var(--2);
  padding-right: var(--2);
  border-radius: 4px;
  cursor: pointer;
  margin: -1px;
}


.inline-btn:hover{
  background-color: var(--main-color);
  color: black;
}

.inline-btn:active{
  background-color: var(--secondary-color);
  color: black;}

.political-coordinates-select{
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: var(--1);
  padding: var(--2);
}


.political-coordinates-select{
  align-self: center;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  position: relative;
  width: 95%;
}

.political-coordinates-select .bar{
  position: absolute;
  width: 6px;
  border-radius: 3px;
  height: calc(100% - 2*var(--3));
  left: calc(-1 * var(--1));
  top: var(--3);

  display: flex;
  flex: none;
  flex-direction: column;
  gap: var(--2);
}

.political-coordinates-select .bar.right{
  left: auto;
  right: calc(-1 * var(--1));
  display: none;
}

.political-coordinates-select .bar .segment{
  width: 6px;
  border-radius: 3px;
  height: 20%;
  background-color: #888;
}

.political-coordinates-select .bar .segment.red{
  height: 40%;
  background-color: red;
}
.political-coordinates-select .bar  .segment.cyan{
  height: 40%;
  background-color: cyan;
}

.political-coordinates-select .option{
  position: relative;
  padding: var(--2);
  display: flex;
  flex-direction: row;
  gap: var(--4);
  margin: var(--1);
  border-radius: var(--border-radius);
  align-items: center;
  border: 1px solid var(--main-color);
}

.political-coordinates-select .option .box-select{
  width: 12px;
  height: 12px;
  border: 1px solid var(--main-color);
  border-radius: 2px;
}


.political-coordinates-select .option.selected{
  opacity: 1;
  border: 1px solid var(--main-color)
}

.political-coordinates-select .option.selected .box-select{
  background-color: var(--main-color);
  opacity: 1;
}

.political-coordinates-select .disabled{
  border-color: #888;
  color: #888;
  opacity: 0.5;
}

.political-coordinates-select .option.disabled .box-select{
  border-color: #888;
}
`, "",{"version":3,"sources":["webpack://./src/pages/App.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;EAWE;;CAED;;;;;EAKC;;;;CAID;EACC,oBAAoB;EACpB,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;EAC3B,yCAAyC;EACzC,wCAAwC;;EAExC,oBAAoB;;EAEpB,QAAQ;EACR,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;;EAEvB,6BAA6B;EAC7B;;;;;GAKC;AACH;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;CACpC;;;CAGA;EACC,sBAAsB;CACvB;;;CAGA;EACC,sBAAsB;EACtB,eAAe;EACf,mBAAmB;CACpB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,yBAAyB;CAC1B;;AAED;EACE,QAAQ;EACR,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;;EAElC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;;EAElB,SAAS;EACT,WAAW;EACX,kCAAkC;;EAElC,WAAW;;AAEb;;;AAGA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE;;;;WAIS;AACX;;AAEA,UAAU;AACV;EACE,UAAU;EACV,WAAW;AACb;;AAEA,UAAU;AACV;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;;;EAGV,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,wBAAwB;EACxB,4BAA4B;EAC5B,SAAS;;AAEX;;AAEA;;;;;;;;EAQE,SAAS;EACT,iBAAiB;EACjB,QAAQ;;;EAGR,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;;EAEf,WAAW;;AAEb;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,oBAAoB;;EAEpB,WAAW;AACb;;AAEA;;EAEE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB;;yBAEuB;EACvB,oBAAoB;;EAEpB,WAAW;AACb;;AAEA;;EAEE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;;EAE5B,oBAAoB;;EAEpB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;EACE,WAAW;AACb;;;;;AAKA;EACE,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;EACP,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,6CAA6C;;EAE7C,0CAA0C;EAC1C,YAAY;AACd;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,wCAAwC;EACxC,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,QAAQ;AACV;;;;AAIA;EACE,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,QAAQ;EACR,WAAW;EACX,wCAAwC;EACxC,WAAW;AACb;;;AAGA;EACE,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,QAAQ;EACR,WAAW;EACX,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,eAAe;EACf,KAAK;EACL,MAAM;EACN,OAAO;EACP,SAAS;EACT,YAAY;EACZ,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,sBAAsB;EACtB,qDAAqD;EACrD,0BAAkB;UAAlB,kBAAkB;EAClB,yBAAyB;EACzB,uCAAuC;;EAEvC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY,EAAE,qBAAqB;EACnC,iBAAiB;EACjB,WAAW;EACX,4DAA4D;;;EAG5D,gBAAgB;EAChB,qCAAqC;EACrC,+CAA+C,EAAE,WAAW;;EAE5D,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;;EAEb,+BAA+B;EAC/B,yBAAyB;EACzB,uCAAuC;EACvC,yCAAyC;EACzC,sBAAsB;;EAEtB;6CAC2C;EAC3C,YAAY;EACZ,mBAAmB;AACrB;;;AAGA;EACE,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,8BAA8B,EAAE,qCAAqC;EACrE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,wCAAwC,EAAE,WAAW;EACrD,kBAAkB,EAAE,WAAW;EAC/B,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,UAAU;EACV,yCAAyC;EACzC,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,mCAAmC;EACnC,UAAU;EACV,+BAA+B;EAC/B,yBAAyB;EACzB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,8BAA8B;EAC9B,4DAA4D;AAC9D;;;AAGA;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,OAAO;EACP,wBAAwB;EACxB,2CAA2C;EAC3C,UAAU;EACV,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,QAAQ;EACR,sBAAsB;EACtB,mBAAmB;AACrB;;;;AAIA;EACE,gCAAgC;EAChC,8BAA8B;;AAEhC;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;AACrB;;;AAGA;;EAEE,WAAW;EACX,WAAW;EACX,mCAAmC;AACrC;;AAEA;;;IAGI,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;;;IAGI,8CAA8C;IAC9C,qBAAqB;AACzB;;AAEA;;;IAGI,oCAAoC;IACpC,qBAAqB;;AAEzB;;AAEA;;;IAGI,oCAAoC;IACpC,qBAAqB;;AAEzB;;AAEA;;;IAGI,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;;AAEF;;;;;AAKA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,QAAQ;EACR,MAAM;EACN,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,YAAY,EAAE,qBAAqB;EACnC;6CAC2C;;EAE3C,gBAAgB;EAChB,gBAAgB;EAChB,gDAAgD;EAChD,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,KAAK;AACP;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,0BAA0B;EAC1B,WAAW;AACb;;;AAGA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,UAAU;EACV,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kCAAkC;EAClC,YAAY;EACZ,SAAS;EACT,eAAe;EACf,mCAAmC;EACnC,yCAAyC;EACzC,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;AACZ;;;AAGA;EACE,mCAAmC;EACnC,UAAU;AACZ;;;AAGA;EACE,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,UAAU;EACV,WAAW;AACb;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;;EAEZ,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,UAAU;EACV,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,6BAA6B;EAC7B,yCAAyC;EACzC,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yCAAyC;EACzC,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,mCAAmC;EACnC,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;;EAEE,OAAO;EACP,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,UAAU;EACV,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,mCAAmC;EACnC,WAAW;EACX,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,UAAU;AACZ;;;AAGA;EACE,sBAAsB;EACtB,WAAW;AACb;;;AAGA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,mCAAmC;EACnC,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,oBAAoB;AACtB;;;AAGA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;;AAGA;;EAEE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,SAAS;EACT,UAAU;EACV,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,UAAU;EACV,mCAAmC;EACnC,WAAW;AACb;;;AAGA;;EAEE,qBAAqB;EACrB,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;AAC3B;;;AAGA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;;EAEf,UAAU;EACV,iBAAiB;EACjB,gBAAgB;;EAEhB;;6BAE2B;;AAE7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;;EAEhB;;6BAE2B;;AAE7B;;;AAGA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,OAAO;EACP,iBAAiB;EACjB,UAAU;EACV,gBAAgB;AAClB;;;AAGA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;;EAEtB,MAAM;EACN,QAAQ;EACR,MAAM;EACN,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,SAAS;;EAET,gBAAgB;EAChB,gBAAgB;;EAEhB,YAAY;EACZ,iBAAiB;;EAEjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;;EAElB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB,CAAC,uBAAuB;EACxC,SAAS;EACT,gBAAgB;EAChB,eAAe;;EAEf,OAAO;EACP,iBAAiB;EACjB,2CAA2C;EAC3C,0BAA0B;EAC1B,yBAAyB;EACzB,WAAW;;EAEX,gDAAgD;;EAEhD,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;;EAEhB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB,CAAC,sBAAsB;EACvC,SAAS;EACT,gBAAgB;EAChB,eAAe;;EAEf,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,2CAA2C;EAC3C,2BAA2B;EAC3B,yBAAyB;;EAEzB,gDAAgD;EAChD,iBAAiB;;EAEjB,yBAAyB;EACzB,uCAAuC;AACzC;;;AAGA;EACE,mBAAmB;EACnB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;;EAEpB,WAAW,CAAC,sBAAsB;EAClC,SAAS;EACT,gBAAgB;;EAEhB,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,2CAA2C;EAC3C,2BAA2B;EAC3B,4BAA4B;;EAE5B,0CAA0C;EAC1C,iBAAiB;;EAEjB,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;;;;EAIE,UAAU;EACV,YAAY;AACd;;;AAGA;EACE,mBAAmB;EACnB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,SAAS;EACT,gBAAgB;EAChB,WAAW;;EAEX,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,2CAA2C;EAC3C,0BAA0B;EAC1B,4BAA4B;;EAE5B,2CAA2C;EAC3C,gBAAgB;;EAEhB,yBAAyB;EACzB,uCAAuC;;AAEzC;;AAEA;;EAEE,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,sCAAsC;;EAEtC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uCAAuC;EACvC,wCAAwC;EACxC,yCAAyC;EACzC,0BAA0B;EAC1B,WAAW;EACX,YAAY;;AAEd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;;EAExB,yCAAyC;EACzC,kCAAkC;EAClC,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;;AAGA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;;AAGA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,uBAAuB;AACzB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;;AAGA;EACE,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB;cACY;AACd;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;;EAEtB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,UAAU;;EAEV,oBAAoB;EACpB,iBAAiB;;EAEjB,mCAAmC;EACnC,eAAe;EACf,iBAAiB;;;EAGjB,yBAAyB;EACzB,uCAAuC;CACxC;;;;;;;yCAOwC;;AAEzC;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,wBAAwB;AAC1B;;;AAGA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,mCAAmC;EACnC,kCAAkC;EAClC,gDAAgD;;EAEhD,iDAAiD;EACjD,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;EACE;IACE,iCAAiC;IACjC,UAAU;EACZ;EACA;IACE,mCAAmC;IACnC,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;EAC5D,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;;AAGA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;;;AAIA;EACE,sCAAsC;EACtC,UAAU;AACZ;;AAEA;EACE;IACE,8BAA8B;IAC9B,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;AACF;;AAEA;EACE,2CAA2C;EAC3C,UAAU;AACZ;;AAEA;EACE;IACE,6BAA6B;IAC7B,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;AACF;;AAEA;EACE,4CAA4C;EAC5C,UAAU;AACZ;;AAEA;EACE;IACE,8BAA8B;IAC9B,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;AACF;;AAEA;EACE,4CAA4C;EAC5C,UAAU;AACZ;;AAEA;EACE;IACE,gCAAgC;IAChC,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;AACF;;;;AAIA;EACE,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,OAAO;;EAEP,WAAW;EACX,UAAU;EACV,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;;EAExB,qBAAqB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,OAAO;EACP,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,QAAQ;EACR,WAAW;EACX,UAAU;EACV,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;;EAExB,qBAAqB;EACrB;AACF;;;AAGA;;EAEE;;;;;qBAKmB;EACnB,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,sDAAsD;AACxD;;;AAGA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,UAAU;EACV,iBAAiB;EACjB,wBAAwB;EACxB,6BAA6B;EAC7B,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;CAcC;;AAED;EACE,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;EACzB,wCAAwC;;EAExC,wCAAwC;EACxC,yCAAyC;EACzC,2CAA2C;;EAE3C,sBAAsB;;EAEtB,yBAAyB;EACzB,uCAAuC;;EAEvC,yCAAyC;;EAEzC,wBAAwB;IACtB,WAAW;AACf;;AAEA;IACI,0CAA0C;;AAE9C;AACA;EACE,0CAA0C;;AAE5C;;AAEA;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,qBAAqB;EACvB;AACF;AACA;;;EAGE;;;AAGF;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;EACf,SAAW;EACX,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,mCAAmC;EACnC,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,KAAK;EACL,OAAO;EACP,aAAa;EACb,sBAAsB;;AAExB;;AAEA;EACE,UAAU;EACV,QAAQ;;AAEV;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,mCAAmC;EACnC,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,MAAM;EACN,QAAQ;EACR,gEAAgE;EAChE,iBAAiB;EACjB,OAAO;EACP,qBAAqB;EACrB,6BAA6B;EAC7B,WAAW;EACX,iBAAiB;;AAEnB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,SAAS;EACT,gEAAgE;EAChE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,kCAAkC;EAClC,aAAa;;EAEb,kBAAkB;AACpB;;AAEA;;;;EAIE,UAAU;EACV,iBAAiB;EACjB,KAAK;EACL,MAAM;EACN,SAAS;EACT,yCAAyC;EACzC,UAAU;EACV,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;;AAElB;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,uBAAuB;EACvB,0BAA0B;EAC1B,SAAS;EACT,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,eAAe;;AAEjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,0BAA0B;EAC1B,+BAA+B;;EAE/B,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;EAcE;;AAEF;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,SAAS;EACT,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,yCAAyC;EACzC,wCAAwC;EACxC,sBAAsB;EACtB,WAAW;EACX,WAAW;;EAEX,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,SAAS;EACT,8BAA8B;EAC9B,0CAA0C;EAC1C,2CAA2C;EAC3C,sBAAsB;EACtB,WAAW;EACX,WAAW;;EAEX,yBAAyB;EACzB,uCAAuC;AACzC;;;AAGA;EACE,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ;;gBAEc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;AAEA;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B;AACF;;AAEA;EACE,sBAAsB;AACxB;;;;AAIA;;;IAGI,WAAW;IACX,cAAc;IACd,mBAAmB;EACrB;;AAEF;EACE,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;;EAExB,mBAAmB;EACnB,qEAAqE;;EAErE,qEAAqE;EACrE,SAAS;EACT,iDAAiD;EACjD,wCAAwC;;AAE1C;;;AAGA;;;IAGI,WAAW;IACX,iBAAiB;EACnB;;AAEF;EACE,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd;uBACqB;EACrB,mBAAmB;EACnB,6BAA6B;;EAE7B,8EAA8E;EAC9E,SAAS;EACT,iDAAiD;EACjD,wCAAwC;EACxC,yCAAyC;EACzC,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,8CAA8C;EAC9C,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,UAAU;EACV,SAAS;EACT,SAAS;EACT,YAAY;EACZ,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mCAAmC;;EAEnC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,WAAW;EACX,QAAQ;AACV;;AAEA;;EAEE;;;;;qBAKmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,wCAAwC;;AAE1C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,WAAW;AACb;;;AAGA;;;;;;;;;;;;;;;;;;;;;;;;;EAyBE;;AAEF;;EAEE;;;;;qBAKmB;EACnB,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,WAAW;;AAEb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,mCAAmC;EACnC,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;IACjC,WAAW;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;EACV,WAAW,EAAE,WAAW;EACxB,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;IACd,kCAAkC;AACtC;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,UAAU,EAAE,WAAW;EACvB,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,OAAO;AACT;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;;EAEb,mBAAmB;EACnB,kCAAkC;AACpC;;;;AAIA;;;IAGI,eAAe;IACf,WAAW;IACX,aAAa;EACf;;;AAGF;EACE,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB;;GAEC;EACD,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;;EAEE,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;CACC,aAAa;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,OAAO;EACP,OAAO;EACP,KAAK;EACL,SAAS;EACT,sBAAsB;EACtB,qGAAqG;AACvG;;;;;AAKA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,0BAA0B;EAC1B,UAAU;AACZ;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,WAAW;;AAEb;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,SAAS;EACT,SAAS;EACT,SAAS;EACT,WAAW;EACX,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE;;;;;qBAKmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,mBAAmB;;EAEnB,WAAW;;AAEb;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mCAAmC;AACrC;;;AAGA;EACE,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;;AAExB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,WAAW;EACX,4BAA4B;EAC5B,YAAY;EACZ,UAAU;EACV,sBAAsB;AACxB;;;AAGA;EACE,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,yCAAyC;EACzC,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;EACb,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;;EAEE,sBAAsB;AACxB;;;AAGA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;;AAEb;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,SAAS;EACT,WAAW;EACX,qBAAqB,EAAE,gBAAgB;;AAEzC;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;;;AAIA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;;AAExB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,uBAAuB;EACvB,6BAA6B;EAC7B,8EAA8E;EAC9E,SAAS;EACT,WAAW;EACX,iCAAiC;EACjC,wCAAwC;EACxC,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,8EAA8E;EAC9E,SAAS;EACT,uDAAuD;EACvD,wCAAwC;EACxC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,uBAAuB;EACvB,6BAA6B;EAC7B,8EAA8E;EAC9E,SAAS;EACT,iDAAiD;EACjD,gBAAgB;AAClB;;;AAGA;;EAEE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,YAAY;EACZ,+BAA+B;EAC/B,wCAAwC;EACxC,uCAAuC;EACvC,gBAAgB;EAChB,wBAAwB;AAC1B;;;AAGA;EAEE,4BAA4B;EAC1B,0BAA0B;CAC3B,2BAA2B;KACvB,uBAAuB;AAC9B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;CA0BC;AACD;EACE;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,iCAAiC;IACjC,aAAa;EACf;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,gCAAgC;IAChC,aAAa;EACf;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,8BAA8B;IAC9B,aAAa;EACf;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,6BAA6B;IAC7B,aAAa;EACf;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,gCAAgC;IAChC,YAAY;EACd;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,gCAAgC;IAChC,YAAY;EACd;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,gCAAgC;IAChC,YAAY;EACd;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,gCAAgC;IAChC,YAAY;EACd;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,8BAA8B;IAC9B,YAAY;EACd;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,8BAA8B;IAC9B,YAAY;EACd;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,8BAA8B;IAC9B,YAAY;EACd;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,8BAA8B;IAC9B,YAAY;EACd;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mCAAmC;EACnC,mCAAmC;EACnC,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,eAAe,EAAE,8CAA8C;EAC/D,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;;AAGA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;;EAEhB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;;;EAGjB,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,YAAY;;AAEd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,sBAAsB;EACtB,wDAAwD;EACxD,gBAAgB;EAChB,UAAU;EACV,gBAAgB;;EAEhB,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,MAAM;EACN,OAAO;EACP,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,UAAU;;AAEZ;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,YAAY;;AAEd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;;AAGA;EACE,WAAW;AACb;;;AAGA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,UAAU;AACZ;;AAEA;;AAEA;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;;;EAGX,uBAAuB;EACvB,+BAA+B;EAC/B,uCAAuC;EACvC,YAAY;AACd;;;AAGA;EACE,YAAY;AACd;;EAEE;;;AAGF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,SAAS;EACT,QAAQ;EACR,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,OAAO;EACP,mCAAmC;AACrC;;AAEA;;IAEI,sBAAsB;IACtB,kCAAkC;IAClC,UAAU;;AAEd;;;AAGA;;IAEI,qBAAqB;IACrB,8BAA8B;EAChC;;;;AAIF;;EAEE,kBAAkB;EAClB,SAAS;EACT,WAAW;;;EAGX,uBAAuB;EACvB,+BAA+B;EAC/B,uCAAuC;EACvC,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,0CAA0C;EAC1C;gBACc;;AAEhB;;AAEA;EACE,4CAA4C;EAC5C;gBACc;;AAEhB;;AAEA;EACE,gDAAgD;;EAEhD;gBACc;;AAEhB;;AAEA;EACE,iDAAiD;EACjD;gBACc;;AAEhB;;;AAGA;EACE;EACA;EACA;IACE,sCAAsC;IACtC,UAAU;EACZ;EACA;IACE,uCAAuC;IACvC,UAAU;EACZ;;AAEF;;AAEA;EACE,sDAAsD;EACtD,+BAA+B;;EAE/B;gBACc;;AAEhB;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,uDAAuD;EACvD;gBACc;;AAEhB;;;AAGA;EACE;EACA;EACA;IACE,yCAAyC;IACzC,yCAAyC;EAC3C;EACA;IACE,yCAAyC;IACzC,0CAA0C;EAC5C;AACF;;;;;AAKA;EACE,WAAW;EACX,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;;;EAGhB,yBAAyB;EACzB,uCAAuC;EACvC,gBAAgB;EAChB,aAAa;AACf;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,OAAO;EACP,KAAK;EACL,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,4BAA4B,EAAE,gDAAgD;EAC9E,+CAA+C;AACjD;;;AAGA;;AAEA;;AAEA;EACE;IACE,yBAAyB,EAAE,gBAAgB;EAC7C;EACA;IACE,0BAA0B,EAAE,2BAA2B;EACzD;AACF;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,qDAAqD;AACvD;;AAEA;;AAEA;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,OAAO;EACP,4BAA4B;EAC5B,uBAAuB;EACvB,gBAAgB;EAChB,6EAA6E;AAC/E;;;AAGA;EACE,UAAU;EACV,kBAAkB;EAClB,KAAK;EACL,MAAM;EACN,OAAO;EACP,4BAA4B;EAC5B,uBAAuB;EACvB,mBAAmB;EACnB,8EAA8E;AAChF;;;AAGA;EACE,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,KAAK;EACL,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,6EAA6E;AAC/E;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,KAAK;EACL,2BAA2B;EAC3B,sBAAsB;EACtB,iBAAiB;EACjB,6EAA6E;AAC/E;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;;EAIE;;AAEF;EACE,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;;AAEtC;;;AAGA;EACE,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,MAAM;EACN,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;;AAGA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;;AAGA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;;AAGA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,kCAAkC;EAClC,qBAAqB;EACrB,WAAW;EACX,gBAAgB;;EAEhB,iBAAiB;EACjB,qBAAqB;EACrB,wBAAwB;;AAE1B;;;AAGA;AACA;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,mCAAmC;EACnC,qBAAqB;EACrB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;;AAE1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,mCAAmC;EACnC,qBAAqB;EACrB,WAAW;AACb;;;;AAIA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;EAEE;AACF;;AAEA;;EAEE,mCAAmC;EACnC,mCAAmC;AACrC;;;AAGA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,MAAM;EACN,gBAAgB;;AAElB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,OAAO;EACP,4BAA4B;EAC5B,oCAAoC;EACpC,gBAAgB;EAChB,6EAA6E;AAC/E;;;AAGA;EACE,UAAU;EACV,kBAAkB;EAClB,KAAK;EACL,MAAM;EACN,OAAO;EACP,4BAA4B;EAC5B,oCAAoC;EACpC,mBAAmB;EACnB,4EAA4E;;AAE9E;AACA;;;;;CAKC;AACD;EACE,WAAW;EACX,iDAAiD;EACjD,YAAY;EACZ,mCAAmC;EACnC,UAAU;AACZ;;;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,yBAAyB;EACzB,mCAAmC;EACnC,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,qDAAqD;EACrD,WAAW;AACb;;;AAGA;;EAEE,UAAU;EACV,QAAQ;;AAEV;;;;;AAKA;EACE,WAAW;EACX,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,yBAAyB,EAAE,yBAAyB;EACpD,kBAAkB;;EAElB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;;EAEhB,yBAAyB;EACzB,uCAAuC;EACvC,qBAAqB;;AAEvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;;;;AAKA;EACE,0BAA0B;EAC1B,WAAW;EACX,oBAAoB;;EAEpB,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,4DAA4D;;EAE5D,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;EACP,MAAM;;EAEN,UAAU;;EAEV,aAAa;EACb,uBAAuB;EACvB,kBAAkB;;EAElB,yBAAiB;;UAAjB,iBAAiB;EACjB,gBAAgB;;AAElB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,OAAO;EACP,MAAM;;EAEN,UAAU;;EAEV,wEAAwE;AAC1E;;;;;;AAMA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,iBAAiB;EACjB,8BAA8B;EAC9B,4DAA4D;;EAE5D,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;;EAE9B,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,0BAA0B;EAC1B,6DAA6D;EAC7D,yCAAyC;EACzC,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,+CAA+C;;AAEjD;;;;AAIA;EACE,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;AACF;;;AAGA;EACE,wBAAwB,GAAG,gBAAgB;EAC3C,qBAAqB,GAAG,YAAY;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;;AAGA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB;;;GAGC;EACD,mBAAmB;AACrB;;;AAGA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,MAAM;EACN,WAAW;EACX,YAAY;EACZ,kBAAkB;;EAElB,oBAAoB;;EAEpB,yBAAyB;EACzB,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,8BAA8B;EAC9B,sBAAsB;EACtB,0CAA0C;;EAE1C,yBAAyB;EACzB,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;;;;EAIE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;;AAGA;EACE,MAAM;EACN,KAAK;EACL,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,KAAK;EACL,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,MAAM;EACN,QAAQ;EACR,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,6BAA6B;EAC7B,4BAA4B;AAC9B;;;;AAIA;EACE,kBAAkB;EAClB,MAAM;EACN,KAAK;EACL,OAAO;EACP,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;IAChB,MAAM;IACN,KAAK;IACL,OAAO;IACP,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;;AAEf;;;AAGA;EACE,kBAAkB;IAChB,OAAO;IACP,QAAQ;IACR,QAAQ;IACR,OAAO;IACP,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;IACrB,UAAU;IACV,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;EACA;IACE,QAAQ;EACV;;;AAGF;IACI,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,SAAS;IACT,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,8BAA8B;IAC9B,sBAAsB;IACtB,0CAA0C;;IAE1C,yBAAyB;IACzB,uCAAuC;IACvC,qBAAqB;;AAEzB;;;AAGA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,UAAU;;AAEZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,UAAU;;AAEZ;;AAEA;;AAEA;;;AAGA;;IAEI,qBAAqB;AACzB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,MAAM;EACN,WAAW;EACX,YAAY;EACZ,kBAAkB;;EAElB,oBAAoB;;EAEpB,yBAAyB;EACzB,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE;IACE,oCAAoC;EACtC;;EAEA;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,uBAAuB;EACvB,sBAAsB;EACtB,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,uBAAuB;EACvB,sBAAsB;EACtB,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;;AAEZ;AACA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,wLAAwL;AAC1L;AACA;EACE,qBAAqB;EACrB,wLAAwL;AAC1L;;AAEA;EACE,UAAU;EACV,kBAAkB;;EAElB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;;EAEhB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;;EAEf,kBAAkB;EAClB,0BAAkB;UAAlB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,MAAM;EACN,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,kCAAkC;AACpC;;;AAGA;EACE,sBAAsB;;;AAGxB;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;;;MAGM,kBAAkB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,8CAA8C;EAC9C,UAAU;EACV,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;IACI,mBAAmB;;AAEvB;;;AAGA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;;AAGA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,KAAK;EACL,yBAAyB;EACzB,kCAAkC;AACpC;;;AAGA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;AACpB;;;;AAIA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,yCAAyC;;AAE3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,2BAA2B;EAC3B,6BAA6B;EAC7B,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,4BAA4B;EAC5B,0BAA0B;EAC1B,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mDAAmD;EACnD,WAAW;EACX,oBAAoB;EACpB,0BAAkB;UAAlB,kBAAkB;;AAEpB;;;AAGA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,+BAA+B;EAC/B,oCAAoC;EACpC,gBAAgB;EAChB,sBAAsB;;EAEtB,yBAAyB;EACzB,uCAAuC;;AAEzC;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mCAAmC;;EAEnC,0BAA0B;EAC1B,yBAAyB;AAC3B;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qDAAqD;AACvD;;;AAGA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,2DAA2D;CAC5D,0BAA0B;EACzB,qBAAqB;;EAErB,oDAAoD;;AAEtD;;;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;;EAElB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;AAC5B;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;;AAGA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;;AAGA;EACE,WAAW;EACX,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,KAAK;EACL,UAAU;AACZ;;;AAGA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;;AAGA;;;EAGE,gCAAgC;AAClC;;;AAGA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;;AAGA;EACE,GAAG,yBAAyB;EAC5B;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;;EAEA,KAAK,yBAAyB;AAChC;;AAEA;EACE,GAAG,oBAAoB;EACvB;IACE,0BAA0B;IAC1B;EACF;EACA;IACE,0BAA0B;IAC1B;EACF;EACA;IACE,0BAA0B;IAC1B;EACF;;EAEA,KAAK,oBAAoB;AAC3B;;AAEA;EACE,YAAY;EACZ;;;cAGY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,6CAA6C;EAC7C,0BAAkB;UAAlB,kBAAkB;EAClB,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,6DAA6D;EAC7D,yBAAyB;EACzB,uCAAuC;AACzC;;;AAGA;;;;;;CAMC;;AAED;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,mCAAmC;EACnC,QAAQ;EACR,OAAO;EACP,sBAAsB;EACtB,uBAAuB;EACvB,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;EACvB,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,QAAQ;AACV;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,OAAO;EACP,6BAA6B;AAC/B;;;AAGA;EACE,QAAQ;EACR,UAAU;AACZ;;;AAGA;;IAEI,kBAAkB;EACpB,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,iBAAiB;EACjB,QAAQ;AACV;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;EACzB,0BAAkB;UAAlB,kBAAkB;;EAElB,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;AACvB;;;AAGA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU;;EAEV,uBAAuB;EACvB,uCAAuC;;AAEzC;;;AAGA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;CAEC;;EAEC,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;;EAEX,uBAAuB;EACvB,uCAAuC;AACzC;;;AAGA;;;IAGI;AACJ;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,YAAY;;EAEZ,uBAAuB;EACvB,uCAAuC;AACzC;;;AAGA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU;EACV,iBAAiB;;;;EAIjB,uBAAuB;EACvB,uCAAuC;;AAEzC;AACA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;;;;EAIZ,uBAAuB;EACvB,uCAAuC;AACzC;;;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,SAAS;EACT,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;;;AAGA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;;;AAIA;EACE,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;;EAEE,UAAU;EACV,YAAY;EACZ,0CAA0C;EAC1C,wCAAwC;EACxC,SAAS;EACT,UAAU;AACZ;;;;AAIA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,SAAS;EACT,UAAU;EACV,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,UAAU;EACV,SAAS;EACT,+CAA+C;AACjD;;;AAGA;;EAEE,YAAY;EACZ,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,UAAU;EACV,QAAQ;EACR,WAAW;AACb;;;AAGA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,UAAU;AACZ;;;;AAIA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;;AAGA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,WAAW;AACb;;AAEA;;;;;;;;;;;;CAYC;;;;AAID;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,sBAAsB;EACtB,uBAAkB;EAAlB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;AAC5C;;;AAGA;;EAEE,UAAU;EACV,UAAU;EACV,SAAS;;EAET,mCAAmC;AACrC;AACA;EACE,6BAA6B;EAC7B,yCAAyC;AAC3C;;;AAGA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,MAAM;EACN,aAAa;EACb,YAAY;AACd;;;AAGA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,OAAO;EACP,SAAS;EACT,6BAA6B;EAC7B,+BAA+B;AACjC;;;AAGA;EACE,SAAS;EACT,0DAA0D;EAC1D,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,UAAU;EACV,YAAY;EACZ,uCAAuC;EACvC,yCAAyC;EACzC,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;;;AAIA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,MAAM;EACN,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,6BAA6B;EAC7B,+BAA+B;EAC/B,yBAAyB;AAC3B;;;AAGA;EACE,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,UAAU;EACV,YAAY;EACZ,uCAAuC;EACvC,yCAAyC;EACzC,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,iBAAiB;EACjB,UAAU;EACV;;;gHAG8G;EAC9G,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,SAAS;EACT,UAAU;;EAEV,yBAAyB;EACzB,YAAY;EACZ;;;sEAGoE;EACpE,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,aAAa;EACb,UAAU;EACV;;;0HAGwH;EACxH,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,mEAAmE;AACrE;AACA;EACE,UAAU;EACV,iEAAiE;AACnE;;AAEA;EACE,UAAU;EACV,gEAAgE;AAClE;;AAEA;EACE,UAAU;EACV,iEAAiE;AACnE;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,8DAA8D;AAChE;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;AACF;;;AAGA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,6BAA6B;EAC/B;AACF;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,MAAM;;EAEN,sBAAsB;EACtB,mCAAmC;EACnC,gBAAgB;;EAEhB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,SAAS;EACT,8BAA8B;EAC9B,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;;AAGA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA;;EAEE,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;;EAEjB,wBAAwB;;EAExB,UAAU;EACV,cAAc;EACd,iBAAiB;;EAEjB,sBAAsB;EACtB,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;;AAEvB;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,cAAc;EACd,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,yBAAyB;EACzB,iEAAiE;AACnE;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,cAAc;EACd,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,iEAAiE;AACnE;;;AAGA;EACE,WAAW;EACX,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,6BAA6B;;AAE/B;;AAEA;EACE,iCAAiC;AACnC;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B;;;AAGA;;;;;;;;;;;;;CAaC;AACD;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;;AAEnB;;AAEA;;EAEE,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,sBAAsB;EACtB,2BAA2B;EAC3B,wBAAwB;EACxB,kCAAkC;EAClC,yBAAyB;AAC3B;;;AAGA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA;EACE;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;;AAGA;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,SAAS;EACT,8BAA8B;EAC9B,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;;AAEnB;;;AAGA;EACE,aAAa;AACf;;;;AAIA;EACE,+FAA+F;AACjG;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;;;EAGV,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;;AAEnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,4BAA4B;;AAE9B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;AACA;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB;;0BAEwB;EACxB,4BAA4B;EAC5B,WAAW;;AAEb;;;;CAIC;EACC,qCAAqC;EACrC,WAAW;;AAEb;;;AAGA;;EAEE,WAAW;AACb;;;AAGA;EACE,WAAW;EACX,iBAAiB;EACjB;;0BAEwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,kDAAkD;EAClD,wBAAwB;;AAE1B;;;AAGA;;EAEE,WAAW;AACb;;;AAGA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;;;AAIA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,6CAA6C;EAC7C,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,4DAA4D;EAC5D,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,mCAAmC;;AAErC;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB;AACF;;;AAGA;;EAEE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;;AAE1C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;AAChC;;;;;AAKA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;;;;AAIA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;;EAEf,4BAA4B;EAC5B,8BAA8B;EAC9B,wBAAwB;EACxB,2BAA2B;;EAE3B,6CAA6C;EAC7C,mCAAmC;EACnC,mBAAmB;EACnB,mBAAmB;;EAEnB;;;;;;;;oBAQkB;AACpB;;AAEA;EACE,iCAAiC;;EAEjC,mCAAmC;EACnC,eAAe;EACf,iBAAiB;EACjB,mCAAmC;CACpC;;;kBAGiB;AAClB;;;AAGA;;EAEE,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;EACxC,oBAAoB;EACpB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;IAChB,WAAW;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,iBAAiB;EACjB,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,iBAAiB;;EAEjB,wCAAwC;EACxC,oCAAoC;AACtC;;;AAGA;EACE,6CAA6C;AAC/C;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,4BAA4B;EAC5B,8BAA8B;EAC9B,wBAAwB;EACxB,2BAA2B;EAC3B,6CAA6C;EAC7C,mCAAmC;EACnC,mBAAmB;EACnB,mBAAmB;;AAErB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,mCAAmC;EACnC,uCAAuC;EACvC,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;EAChB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,UAAU;EACV,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,OAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,OAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,SAAS;EACT,MAAM;EACN,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,sBAAsB;AACxB;;AAEA;;AAEA;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,sBAAsB;EACtB,OAAO;EACP;cACY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;;AAGA;EACE,2BAA2B;EAC3B,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,OAAO;EACP,SAAS;EACT,kBAAkB;EAClB,sBAAsB;AACxB;;;AAGA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;;EAEhB,gBAAgB;EAChB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;;AAEpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,OAAO;EACP,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,OAAO;EACP,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;;AAGA;CACC,UAAU;CACV,iBAAiB;EAChB,WAAW;EACX,QAAQ;CACT,SAAS;CACT,UAAU;CACV,kCAAkC;CAClC,mCAAmC;CACnC,6BAA6B;EAC5B,yBAAyB;AAC3B;;AAEA;CACC,UAAU;CACV,iBAAiB;CACjB,aAAa;CACb,kCAAkC;CAClC,mCAAmC;CACnC,6BAA6B;CAC7B,OAAO;CACP,SAAS;AACV;;AAEA;CACC,UAAU;CACV,iBAAiB;CACjB,aAAa;CACb,kCAAkC;CAClC,mCAAmC;CACnC,6BAA6B;CAC7B,OAAO;EACN,QAAQ;AACV;;AAEA;;;CAGC,4BAA4B;AAC7B;;;AAGA;EACE,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;;AAGA;EACE,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;AACxC;;;AAGA;EACE;IACE,WAAW;IACX,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,6BAA6B;IAC7B,WAAW;EACb;;AAEF;;AAEA;EACE;IACE,WAAW;IACX,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,6BAA6B;IAC7B,UAAU;EACZ;;AAEF;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iEAAiE;EACjE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,oBAAoB;EACtB;AACF;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sBAAsB;AACxB;;;;AAIA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE;IACE,QAAQ;IACR,OAAO;IACP,UAAU;EACZ;EACA;IACE,MAAM;IACN,UAAU;IACV,YAAY;IACZ,+BAA+B;IAC/B,yCAAyC;EAC3C;EACA;IACE,QAAQ;IACR,OAAO;IACP,YAAY;EACd;EACA;IACE,MAAM;IACN,SAAS;IACT,YAAY;EACd;EACA;IACE,MAAM;IACN,OAAO;IACP,YAAY;IACZ,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,MAAM;IACN,WAAW;IACX,YAAY;IACZ,+BAA+B;EACjC;EACA;IACE,QAAQ;IACR,OAAO;IACP,UAAU;EACZ;EACA;IACE,SAAS;IACT,OAAO;IACP,YAAY;IACZ,6BAA6B;EAC/B;EACA;IACE,MAAM;IACN,UAAU;IACV,YAAY;IACZ,6BAA6B;EAC/B;EACA;IACE,MAAM;IACN,OAAO;IACP,YAAY;EACd;AACF;;;AAGA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,OAAO;EACP,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;;EAEX,SAAS;EACT,SAAS;EACT,WAAW;;AAEb;;;;AAIA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,2BAA2B;EAC3B,YAAY;EACZ,WAAW;;AAEb;;;AAGA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,WAAW;;AAEb;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,WAAW;;AAEb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,UAAU;AACZ;;;AAGA;EACE,mCAAmC;AACrC;;;AAGA;EACE,mCAAmC;AACrC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;;AAGA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;;;;AAKA;;;;;;EAME,2BAA2B,EAAE,eAAe;IAC1C,yBAAyB,EAAE,WAAW,EACX,mBAAmB,EACnB,4BAA4B,EAC5B,2BAA2B;YAC9C,iBAAiB,EAAE;gFACiD;AAChF;;AAEA;EACE,2BAA2B,EAAE,eAAe;IAC1C,yBAAyB,EAAE,WAAW,EACX,mBAAmB,EACnB,4BAA4B,EAC5B,2BAA2B;YAC9C,iBAAiB,EAAE;gFACiD;AAChF;;;AAGA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;AACf;;;AAGA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;;EAElB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;;AAGA;;EAEE,gBAAgB,EAAE,uBAAuB;EACzC,aAAa;EACb,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;;AAErB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,SAAS;EACT,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;EACnC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;EACnC,YAAY;EACZ,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;;EAEnB,mCAAmC;EACnC,WAAW;EACX,yCAAyC;EACzC,6BAA6B;EAC7B,oBAAoB;AACtB;;;AAGA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;;EAEnB,mCAAmC;EACnC,WAAW;EACX,yCAAyC;EACzC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;;EAEnB,mCAAmC;EACnC,WAAW;EACX,yCAAyC;EACzC,6BAA6B;EAC7B,sBAAsB;;AAExB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;;EAEnB,mCAAmC;EACnC,WAAW;EACX,yCAAyC;EACzC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,sBAAsB;EACtB,oBAAoB;EACpB,kCAAkC;EAClC,mCAAmC;EACnC,WAAW;EACX,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB;0BACwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,KAAK;EACL,2BAA2B;AAC7B;;AAEA;;;;;;EAME,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;;AAExB;;AAEA,8CAA8C,qBAAqB,CAAC;AACpE,8CAA8C,qBAAqB,CAAC;AACpE,8CAA8C,qBAAqB,CAAC;AACpE,8CAA8C,qBAAqB,CAAC;AACpE,8CAA8C,oBAAoB,CAAC;;AAEnE;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,uBAAuB;EACvB,UAAU;EACV,oBAAoB;;EAEpB,mCAAmC;EACnC,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,oBAAoB;;EAEpB,mCAAmC;EACnC,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,SAAS;EACT,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,wBAAwB;EACxB,SAAS;EACT,SAAS;EACT,kBAAkB;AACpB;;;;AAIA;;;;;;EAME,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;;AAGA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,YAAY;AACd;AACA;EACE;AACF;AACA;EACE;AACF;;;AAGA;EACE,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,OAAO;EACP,aAAa;EACb,mCAAmC;EACnC,sBAAsB;;EAEtB,iBAAiB;;EAEjB,mCAAmC;EACnC,eAAe;EACf,iBAAiB;CAClB;;;kBAGiB;;AAElB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,yCAAyC;EACzC,SAAS;;AAEX;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;;AAGA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,YAAY;EACZ,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,cAAc;EACd,YAAY;EACZ,2BAA2B;AAC7B;;;AAGA;EACE,OAAO;EACP,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;;;AAIA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;;;AAIA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;;EAEd;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;EACA;EACA;IACE,yBAAyB;IACzB,6LAA6L;EAC/L;EACA;IACE,yBAAyB;IACzB,6LAA6L;EAC/L;EACA;IACE,yBAAyB;IACzB,6LAA6L;EAC/L;EACA;IACE,yBAAyB;EAC3B;AACF;;;AAGA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,aAAa;EACb,sBAAsB;AACxB;;;AAGA;EACE,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,uCAAuC;EACvC,UAAU;EACV,SAAS;EACT,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;EACE,yCAAyC;;AAE3C;AACA;EACE,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;;AAEpB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,uCAAuC;EACvC,WAAW;EACX,QAAQ;EACR,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,uCAAuC;EACvC,WAAW;EACX,OAAO;EACP,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,OAAO;EACP,YAAY;AACd;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,kBAAkB;AACpB;;;AAGA;EACE,UAAU;EACV,kBAAkB;EAClB,uCAAuC;EACvC,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,MAAM;EACN,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;;;;;;;EAqBE;;AAEF;EACE,yCAAyC;;EAEzC,YAAY;EACZ,sKAAsK;AACxK;;AAEA;EACE,wCAAwC;AAC1C,YAAY;AACZ,0BAA0B;AAC1B,4HAA4H;AAC5H;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,UAAU,EAAE,sCAAsC;EAClD,WAAW,EAAE,sCAAsC;EACnD,oBAAoB,EAAE,iEAAiE;EACvF,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,UAAU,EAAE,sCAAsC;EAClD,WAAW,EAAE,sCAAsC;EACnD,oBAAoB,EAAE,iEAAiE;EACvF,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;;AAE5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,uCAAuC;EACvC,qBAAqB;EACrB,WAAW;AACb;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,qDAAqD;AACvD;AACA;EACE,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,mCAAmC;EACnC,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,WAAW;;EAEX,yBAAyB;EACzB,uCAAuC;;AAEzC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;;AAGA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,YAAY,CAAC;;AAEf;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAyB;EACzB,aAAa;;EAEb,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;AACpB;;;AAGA;EACE,UAAU;EACV;AACF;;AAEA;EACE,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["/*var(--main-color)\nvar(--secondary-color)\n#A28C75\n#82705E\n#685A4B\n#53483C\n#423A30\n#352E26\n#2A251E\n#221E18\nBlack\n */\n\n /*\n  background:#35425c; - card - grey-blue\n  background:#2E2E52;  - radar violet \n  yellow = F2B43B; rgb(242, 180, 59)\n  coral = FC5D47;\n */\n\n\n\n :root {\n  --main-color:#FEDBB7;\n  --secondary-color:#CBAF92;\n  --shadow-main-color:#6D5E4F;\n  --background-color: #2E2E52;\n  --background-color-transparent: #2e2e52c0;\n  -webkit-tap-highlight-color: transparent;\n\n  --border-radius: 8px;\n\n  --1: 4px;\n  --2: calc(var(--1) * 2);\n  --3: calc(var(--1) * 3);\n  --4: calc(var(--1) * 4);\n\n  --typing-animation-speed: 220;\n  /*\n  --background-color: #2E2E52;\n    --background-color: #22223c;\n\n  --background-color:#222222;\n  */\n}\n\n.display-none{\n  display: none !important;\n}\n\n.main-color{\n  color: var(--main-color) !important;\n }\n\n\n .cyan-color{\n  color: cyan !important;\n }\n\n \n .cyan-color-link{\n  color: cyan !important;\n  cursor: pointer;\n  pointer-events: all;\n }\n\n .red-color{\n  color: red !important;\n }\n\n .uppercase{\n  text-transform: uppercase;\n }\n\n*{\n  margin:0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml, body, #root{\n  overflow:hidden;\n  width: 100%;\n  height:100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\ncanvas{\n  background:var(--background-color);\n\n  /*background: black;*/\n}\n\nhtml {\n  height: calc(100%);\n\n  margin: 0;\n  width: 100%;\n  background:var(--background-color);\n\n  color: #fff;\n\n}\n\n\na {\n  text-decoration: none;\n  color: cyan;\n}\n\na:hover {\n  color: #fff;\n}\n\n\n.material-symbols-outlined {\n  font-variation-settings:\n  'FILL' 0,\n  'wght' 300,\n  'GRAD' 0,\n  'opsz' 24;\n}\n\n/* width */\n::-webkit-scrollbar {\n  width: 3px;\n  height: 6px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-corner {\n  background: rgba(0, 0, 0, 0);\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 2px;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\nsmall, .ce-popover__item-label, .cdx-search-field__input\n{\n  /* small */\n\n\n  font-family: 'Roboto Mono', monospace;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 12px;\n  /*text-align: center;*/\n  vertical-align: baseline;\n  /* identical to box height */\n  margin: 0;\n\n}\n\nhtml,\nb, a, p,\n.ce-paragraph, .cdx-block,\ninput,\nbutton,\n.right-menu-arrow-button,\nselect,\nli {\n  /* body */\n  line-height: 20px;\n  /*19 25*/\n\n\n  font-family: 'Roboto Mono', monospace;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 15px;\n\n  margin: 0px;\n\n}\n\nb{\n  font-weight:  500;\n}\n\n\nh3, .dropdown-btn li {\n  font-family: 'Roboto Mono', monospace;\n  font-style: normal;\n  font-weight: 400 !important;\n  font-size: 20px;\n  line-height: 24px;\n  letter-spacing: -1px;\n\n  margin: 0px;\n}\n\nh2,\n.h2-input {\n  font-family: 'Roboto Mono', monospace;\n  font-style: normal;\n  font-weight: 200;\n  font-size: 24px;\n  line-height: 29px;\n  /* identical to box height\n\n  letter-spacing: 0.1em;*/\n  letter-spacing: -1px;\n\n  margin: 0px;\n}\n\nh1,\n.h1-input {\n  font-family: 'Roboto Mono', monospace;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 52px;\n  line-height: 52px;\n  /* identical to box height */\n\n  letter-spacing: -1px;\n\n  margin: 0px;\n}\n\n.process-space-right .content .name h1 {\n  text-transform: capitalize;\n}\n\n\n.inactive {\n  color: #888;\n}\n\n\n\n\n.hud{\n  height:0px;\n  position: relative;\n  width:0px;\n  opacity: 0.8;\n  color: var(--main-color);\n  z-index: 200;\n}\n\n.hud.no-opacity{\n  opacity: 1;\n  z-index: 100;\n}\n\n.zero-opacity{\n  opacity: 0;\n}\n\n.hud .computer-header{\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  top: 0px;\n  gap:5px;\n  left: 0px;\n  width:100%;\n  justify-content: end;\n  text-align: end;\n  background:#2E2E52;\n  box-shadow: 2px 2px 10px 1px rgba(0, 0, 0, 1);  \n\n  border-bottom: 1px solid var(--main-color);\n  height: 70px;\n}\n\n\n.navigation-btn{\n  max-width: 150px;\n}\n\n.hud .computer-header img{\n\n  position: absolute;\n  width:60px;\n  height:60px;\n  top:5px;\n  left:5px;\n  object-fit: cover;\n  border-radius: 10px;\n  z-index: 10;\n  border: 1px solid var(--secondary-color);\n  z-index: 0;\n}\n\n.hud .computer-header .description{\n\n  position: absolute;\n  left: 80px;\n  top: 5px;\n  width: 100px;\n  display: flex;\n  flex-direction: row;\n  align-items: start;\n  flex-wrap: wrap;\n  gap: 0px;\n}\n\n.hud .computer-header .description-section{\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  flex-wrap: wrap;\n  gap: 0px;\n}\n\n\n\n.hud .text-stats-left{\n  text-align: right;\n  position: fixed;\n  top: 35px;\n  right: calc(50% + 20px);\n  width: 100px;\n  padding:var(--1);\n  padding-right:10px;\n}\n\n.hud .text-stats-left::after{\n  position: absolute;\n  width:10px;\n  right:0;\n  top:14px;\n  bottom:13px;\n  border-right:1px solid var(--main-color);\n  content: '';\n}\n\n\n.hud .text-stats-center{\n  text-align: center;\n  position: fixed;\n  top: 34px;\n  left: calc(50% - 20px);\n  width: 40px;\n  padding:var(--1);\n}\n\n.hud .text-stats-right{\n  text-align: left;\n  position: fixed;\n  top: 35px;\n  left: calc(50% + 20px);\n  width: 100px;\n  padding:var(--1);\n  padding-left:10px;\n}\n\n.hud .text-stats-right::after{\n  position: absolute;\n  width:10px;\n  left:0;\n  top:14px;\n  bottom:13px;\n  border-left:1px solid var(--main-color);\n  content: '';\n}\n\n.hud .manual-modal{\n  position: fixed;\n  top:0;\n  left:0;\n  right:0;\n  bottom: 0;\n  z-index: 400;\n  margin:auto;\n  opacity: 1;\n  max-width: calc(600px);\n  max-height: calc(100%); \n  background-color: var(--background-color-transparent);\n  user-select: none ;\n  transition-duration: 0.3s;\n  transition-timing-function: ease-in-out;\n  \n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.hud .manual-modal.hidden{\n  opacity: 0;\n  z-index: 1;\n  pointer-events: none;\n}\n\n.hud .bottom-drawer{\n  position : fixed;\n  left: var(--2);\n  right: var(--2);\n  bottom: var(--2);\n  bottom: 28px; /* web app problems */\n  padding: var(--2);\n  margin:auto;\n  border-radius: 0 0 var(--border-radius) var(--border-radius);\n  \n\n  min-height: 50px;\n  max-width: calc(600px - 2 * var(--2));\n  max-height: calc(100% - var(--2) - 32px - 28px); /*32 шапка*/\n\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  gap: var(--2);\n\n  transform: translateY(calc(0%));\n  transition-duration: 0.4s;\n  transition-timing-function: ease-in-out;\n  background-color: var(--background-color);\n  border: 1px solid #888;  \n\n  /*border-left:1px solid var(--main-color);\n  border-bottom:1px solid var(--main-color);*/\n  z-index: 100;\n  pointer-events: all;\n}\n\n\n.hud .bottom-drawer.hidden{\n  transform: translateY(calc(100% + 60px));\n  opacity: 0;\n}\n\n.hud .bottom-drawer.open-voyage-hat{\n  border-radius: var(--border-radius);\n  max-height: calc(100% - 190px); /*32 шапка - старый вариант с табами*/\n  max-height: calc(100% - 146px); \n  padding: var(--1);\n}\n\n.hud .bottom-drawer.station-card-drawer{\n  max-height: calc(100% - var(--2) - 32px); /*32 шапка*/\n  height: calc(100%); /*32 шапка*/\n  border: none;\n}\n\n.hud .bottom-drawer.open-voyage-hat .command-order-btns-row{\n  padding: var(--1);\n}\n\n\n.hud .bottom-drawer .extra-modal-btn{\n  position: absolute;\n  height: 38px;\n  top:-44px;\n  width:auto;\n  left: -1px;\n  background-color: var(--background-color);\n  padding: var(--2);\n  border: 1px solid cyan;\n  color: cyan;\n  text-transform: uppercase;\n  border-radius: var(--border-radius);\n  opacity: 1;\n  transform: translateY(calc(0%));\n  transition-duration: 0.3s;\n  transition-timing-function: ease-in-out;\n  cursor: pointer;\n}\n\n.hud .bottom-drawer.hidden .extra-modal-btn{\n  opacity: 0;\n  pointer-events: none;\n}\n\n.hud .bottom-drawer .drawer-header{\n  position: absolute;\n  top:-32px;\n  left:-1px;\n  height:32px;\n  right: -1px;\n  background-color: #888;\n  padding: var(--2);\n  color: var(--background-color);\n  border-radius: var(--border-radius) var(--border-radius) 0 0;\n}\n\n\n.hud .stats{\n  display: flex;\n  display: none;\n  position: relative;\n  align-items: end;\n  flex-direction: column;\n  gap:5px;\n  /*margin-right: -120px;*/\n  /*background-color: rgba(40, 40, 40, 0.7);*/\n  flex: none;\n  flex-grow: 0;\n  z-index: 1;\n}\n\n.hud .stats{\n  align-items: end;\n}\n\n.left.stats{\n  align-items: start;\n}\n\n.hud .stats .row{\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n  gap: 5px;\n  z-index: 1;\n  height: 20px;\n}\n\n.no-transparent{\n  opacity: 1;\n}\n\n.hud .stats .row .title{\n  background-color: var(--main-color);\n  line-height: 10px;\n  color: #000;\n  height: 18px;\n  width: 24px;\n  text-align: center;\n  vertical-align:middle;\n  justify-content: center;\n}\n\n.hud .stats .row .points{\n  display: flex;\n  flex-direction: row-reverse;\n  gap: 3px;\n  justify-content: right;\n  align-items: center;\n}\n\n\n\n.left .row{\n  justify-content: left !important;\n  flex-direction: row !important;\n\n}\n\n.left .row .points{\n  justify-content: left;\n  flex-direction: row !important;\n  align-items: center;\n}\n\n\n.hud .stats .row .points .p1,\n.hud .stats .row .points .p1-blank{\n  width: 15px;\n  height: 5px;\n  border: 1px solid var(--main-color);\n}\n\n.row.yellow .p1,\n.row.yellow .title,\n.key.yellow{\n    background-color: #FCCA02 !important;\n    color:#000 !important;\n}\n\n.row.gold .p1,\n.row.gold .title,\n.key.gold{\n    background-color: var(--main-color) !important;\n    color:#000 !important;\n}\n\n.row.red .p1,\n.row.red .title,\n.key.red{\n    background-color: #a50000 !important;\n    color:#fff !important;\n\n}\n\n.row.blue .p1,\n.row.blue .title,\n.key.blue{\n    background-color: #4cb5f5 !important;\n    color:#000 !important;\n\n}\n\n.row.grey .p1,\n.row.grey .title,\n.key.grey{\n    background-color: white !important;\n    color:#000 !important;\n}\n\n.p1.blank{\n  background-color: #888 ;\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n\n}\n\n\n\n\n.commands-panel{\n  position : fixed;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap:var(--1);\n  right: 0;\n  left:0;\n  width: calc(100%);\n  margin:auto;\n  max-width: 600px;\n  bottom: 10px;\n  bottom: 20px; /* web app problems */\n  /*border-left:1px solid var(--main-color);\n  border-bottom:1px solid var(--main-color);*/\n\n  min-height: 50px;\n  min-width: 100px;\n  border-radius:  0px 0px 0px var(--border-radius);\n  padding:var(--2);\n  pointer-events: none;\n}\n\n.commands-panel .commands-list{\n  display: flex;\n  position: relative;\n  width:100%;\n  flex-direction: row;\n  justify-content: end;\n  align-items: end;\n  gap:var(--1);\n}\n\n.top-tabs{\n  z-index: 100;\n  display: flex;\n  width:100%;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: end;\n  padding-left: var(--2);\n  padding-right: var(--2);\n  gap:0;\n}\n\n\n.top-tabs .tab{\n  text-align: center;\n  align-self: flex;\n  flex: auto;\n  padding: var(--1);\n  border-top: 1px solid #888;\n  color: #888;\n}\n\n\n.top-tabs .tab.selected{\n  border-top: 1px solid cyan;\n  color: cyan;\n}\n\n.commands-panel .commands-list .commands-right-block{\n  display: flex;\n  gap:5px;\n  flex-direction: row;\n  align-items: end;\n  justify-content: end;\n  flex-wrap: wrap-reverse;\n  min-width: 160px;\n  /*max-width: 180px;*/\n  max-width: 100%;\n  flex: auto;\n  /*max-width: calc(50%);*/\n}\n\n.commands-panel .commands-list .command,\n.commands-panel .commands-list .disabled-command{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  border:1px solid var(--main-color);\n  padding:10px;\n  flex:auto;\n  max-width: 54px;\n  border-radius: var(--border-radius);\n  background-color: var(--background-color);\n  cursor: pointer;\n  justify-content: center;\n  pointer-events: auto;\n  width: 30%;\n}\n\n\n.commands-panel .commands-list .selected{\n  background-color: var(--main-color);\n  color:#000;\n}\n\n\n.commands-panel .commands-list .command:hover{\n  background-color: var(--main-color);\n  color:#000;\n}\n\n.commands-panel .commands-list .command:active{\n  background-color: #fff;\n  color:#000;\n}\n\n.commands-panel .commands-list .disabled-command{\n  border:1px solid #888;\n  color: #888;\n}\n\n.primary-btn{\n  cursor: pointer;\n  background-color: var(--main-color);\n  color:#000;\n  padding:5px;\n}\n\n.primary-btn:hover{\n  background-color: var(--secondary-color);\n}\n\n.primary-btn:active{\n  background-color: #fff;\n}\n\n.commands-descriptions{\n  display: flex;\n  height: 1px;\n  position: relative;\n  align-items: end;\n  justify-content: start;\n  max-height: 100px;\n  flex-grow: 1;\n  \n  width:calc(100% - 180px);\n  flex: none;\n}\n\n.commands-descriptions.disabled{\n  max-height: none;\n  height: 100%;\n  width:24px;\n}\n.commands-descriptions.full-width{\n  width: calc(100% - var(--border-radius));\n  margin-right: var(--border-radius);\n}\n\n.commands-descriptions .commands-description{\n  display: flex;\n  position: absolute;\n  bottom: 0px;\n  left:0px;\n  flex-direction: column;\n  align-items: start;\n  justify-content: end;\n  text-wrap:wrap;\n  width:100%;\n  padding:10px;\n  color: #888;\n  border-left: 1px solid #888;\n  border-bottom: 1px solid #888;\n  border-radius: 0 0 0 var(--border-radius);\n  line-height: 15px;\n  gap: 10px;\n}\n\n.clickable-field{\n  pointer-events: auto !important;\n}\n\n.non-clickable-field{\n  pointer-events: none !important;\n}\n\n\n.command-order-btns-row{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap:var(--1);\n}\n\n.btn{\n  cursor: pointer;\n  background-color: var(--background-color);\n  color: var(--main-color);\n  padding:var(--2);\n  margin: -1px;\n  border-radius: var(--border-radius);\n  border: 1px solid var(--main-color);\n  text-align: center;\n}\n\n.btn:hover{\n  background-color: var(--main-color);\n  color: var(--background-color);\n}\n\n.btn:active{\n  background-color: #fff;\n  color: var(--background-color);\n}\n\n.order-btn,\n.secondary-order-btn{\n  gap:5px;\n  justify-content: center;\n  cursor: pointer;\n  flex:auto;\n  color:#000;\n  background-color: var(--main-color);\n  text-align: center;\n  padding: 19px;\n  border-radius: var(--border-radius);\n  margin: 0px;\n  height:60px;\n  pointer-events: auto;\n}\n\n.secondary-order-btn{\n  border: 1px solid var(--main-color);\n  background-color: var(--background-color);\n  color: var(--main-color);\n}\n\n.order-btn:active{\n  background-color: #fff;\n  color:#000;\n}\n\n\n.secondary-order-btn:active{\n  border: 1px solid #fff;\n  color: #fff;\n}\n\n\n.order-btn a{\n  text-decoration: none;\n  color:#000;\n}\n\n.order-btn h2{\n  color:#000;\n  background-color: var(--main-color);\n  padding: 10px;\n}\n\n.next-target-btn{\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: start;\n  color:var(--main-color);\n  border: 1px solid var(--main-color);\n  flex:none;\n  height:60px;\n  padding:var(--1);\n  padding-left:10px;\n  padding-right:10px;\n  border-radius: var(--border-radius);\n  cursor: pointer;\n  pointer-events: auto;\n}\n\n\n.next-target-btn.inactive,\n.order-btn.inactive{\n  border: 1px solid #888;\n  color:  #888;\n  background:transparent;\n  margin:0px;\n  height:60px;\n}\n\n.order-btn.error{\n  background-color: crimson;\n}\n\n.secondary-btn{\n  border: 1px solid var(--main-color);\n  cursor: pointer;\n  pointer-events: auto;\n}\n\n.secondary-btn:active{\n  color:#000;\n  background-color: var(--main-color);\n}\n\n.next-target-btn:active{\n  border: 1px solid #fff;\n  color: #fff;\n}\n\n\n.hud .text-stats-left .indicators-row,\n.hud .text-stats-right .indicators-row{\n  display: flex;\n  position: relative;\n  flex-direction: row;\n  height: 16px;\n  height: 20px;\n  align-items: center;\n  justify-content: end;\n  padding-top:2px;\n  padding-bottom:2px;\n  flex-wrap: nowrap;\n  text-wrap: none;\n}\n\n.hud .text-stats-right .indicators-row{\n  justify-content: start;\n}\n\n\n.hud .text-stats-left .indicators-row:before{\n  position: absolute;\n  right:-10px;\n  top:10px;\n  width:4px;\n  height:1px;\n  background-color: var(--main-color);\n  content: '';\n}\n\n.hud .text-stats-right .indicators-row:before{\n  position: absolute;\n  left:-10px;\n  top:10px;\n  width:4px;\n  height:1px;\n  background-color: var(--main-color);\n  content: '';\n}\n\n\n.square-indicator,\n.square-indicator-empty{\n  display: inline-block;\n  width:6px;\n  height:12px;\n  margin-left:2px;\n  margin-right:2px;\n  background-color: var(--main-color);\n  border-radius: 2px;\n}\n\n.square-indicator-empty{\n  opacity: 0.2;\n  height:12px;\n}\n\n.red-indicators .square-indicator,\n.red-indicators .square-indicator-emptyzzz{\n  background-color: red;\n}\n\n.cyan-indicators .square-indicator,\n.cyan-indicators .square-indicator-emptyzzz{\n  background-color: cyan;\n}\n\n.yellow-indicators .square-indicator,\n.yellow-indicators .square-indicator-emptyzzz{\n  background-color: #FCCA02;\n}\n\n\n.white-indicators .square-indicator,\n.white-indicators .square-indicator-emptyzzz{\n  background-color: #FFF;\n}\n\n.hud .ship-name-right{\n  display: flex;\n  flex-direction: column;\n  align-items: end;\n  text-align: end;\n\n  width:100%;\n  padding-left:20px;\n  overflow: hidden;\n\n  /*border-right:1px solid var(--main-color);\n  border-bottom:1px solid var(--main-color);\n  border-radius: 0 0 10px 0;*/\n\n}\n\n.hud .ship-name-left{\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  text-align: start;\n  width:100%;\n  padding-right:20px;\n  overflow: hidden;\n\n  /*border-right:1px solid var(--main-color);\n  border-bottom:1px solid var(--main-color);\n  border-radius: 0 0 10px 0;*/\n\n}\n\n\n.counter{\n  padding-left: 2px;\n  padding-right: 2px;\n}\n\n.hud .counter-center{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap:5px;\n  position:relative;\n  margin:0px;\n  padding:var(--1);\n}\n\n\n.info-panel-top{\n  position : fixed;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: start;\n\n  top: 0;\n  right: 0;\n  left:0;\n  width: calc(100%);\n  margin:auto;\n  max-width: 600px;\n  flex:none;\n\n  min-height: 50px;\n  min-width: 100px;\n\n  gap:var(--1);\n  padding: var(--2);\n\n  color: #888;\n}\n\n.info-panel-top .info-block{\n  position: relative;\n  width: 100%;\n}\n\n.info-panel-top.not-fixed{\n  position : absolute;\n  top: -2px;\n  align-self: center;\n  align-items: center;\n  z-index: 11;\n  padding: 0;\n}\n\n.locations-panel{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: var(--2);\n}\n\n.info-panel-left{\n  position : fixed;\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n\n  top: var(--2);\n  right: calc(50% + 50px);\n  width: calc(50% - 58px);\n  max-width: 242px;/*(600 - 100) /2  -8px*/\n  flex:none;\n  min-height: 50px;\n  min-width: 68px;\n\n  gap:0px;\n  padding: var(--2);\n  /*border-left:1px solid var(--main-color);*/\n  border-left:1px solid #888;\n  border-top:1px solid #888;\n  color: #888;\n\n  border-radius:  var(--border-radius) 0px 0px 0px;\n\n  transition-duration: 0.5s;\n  transition-timing-function: ease-in-out;\n}\n\n.info-panel-left.no-borders{\n  border: none;\n}\n\n.info-panel-left.not-fixed{\n  position : absolute;\n  top: 0;\n  left: 0;\n  right: auto;\n  z-index: 11;\n}\n\n.info-panel-right{\n  position : fixed;\n  display: flex;\n  flex-direction: column;\n  align-items: end;\n\n  top: var(--2);\n  left: calc(50% + 50px);\n  width: calc(50% - 58px);\n  max-width: 242px;/*600 - 100 /2  -10px*/\n  flex:none;\n  min-height: 50px;\n  min-width: 68px;\n\n  gap:0px; \n  color: #888;\n  padding: var(--2);\n  /*border-left:1px solid var(--main-color);*/\n  border-right:1px solid #888;\n  border-top:1px solid #888;\n\n  border-radius:  0px var(--border-radius) 0px 0px;\n  text-align: right;\n\n  transition-duration: 0.5s;\n  transition-timing-function: ease-in-out;\n}\n\n\n.info-panel-right.not-fixed{\n  position : absolute;\n  top: 0;\n  right: 0;\n  left: auto;\n  z-index: 11;\n}\n\n.info-panel-right.no-borders{\n  border: none;\n}\n\n.info-panel-right-bottom{\n  position : absolute;\n  bottom: 0;\n  right: 0;\n  left: auto;\n  z-index: 11;\n  display: flex;\n  flex-direction: column;\n  align-items: end;\n  justify-content: end;\n\n  width: 50px;/*600 - 100 /2  -10px*/\n  flex:none;\n  min-height: 50px;\n\n  gap:0px; \n  color: #888;\n  padding: var(--2);\n  /*border-left:1px solid var(--main-color);*/\n  border-right:1px solid #888;\n  border-bottom:1px solid #888;\n\n  border-radius:  0 0 var(--border-radius) 0;\n  text-align: right;\n\n  transition-duration: 0.4s;\n  transition-timing-function: ease-in-out;\n}\n\n.info-panel-right.no-border,\n.info-panel-left.no-border,\n.info-panel-right-bottom.no-border,\n.info-panel-left-bottom.no-border{\n  padding: 0;\n  border: none;\n}\n\n\n.info-panel-left-bottom{\n  position : absolute;\n  bottom: 0;\n  left: 0;\n  right: auto;\n  z-index: 11;\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  justify-content: end;\n  flex:none;\n  min-height: 50px;\n  width: 50px;\n\n  gap:0px; \n  color: #888;\n  padding: var(--2);\n  /*border-left:1px solid var(--main-color);*/\n  border-left:1px solid #888;\n  border-bottom:1px solid #888;\n\n  border-radius:  0 0 0 var(--border-radius) ;\n  text-align: left;\n\n  transition-duration: 0.4s;\n  transition-timing-function: ease-in-out;\n\n}\n\n.info-panel-left-bottom.active,\n.info-panel-right-bottom.active{\n  color: var(--main-color);\n  border-color: var(--main-color);\n}\n\n.info-panel-center{\n  position : fixed;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  top: var(--2);\n  gap:0px;\n  left: calc(50% - 50px);\n  width: 100px;\n  /*border:1px solid var(--main-color);*/\n\n  min-height: 20px;\n  max-width: 100px;\n}\n\n.info-panel-center::after{\n  position: absolute;\n  bottom:0px;\n  border-left:1px solid var(--main-color);\n  border-right:1px solid var(--main-color);\n  border-bottom:1px solid var(--main-color);\n  border-radius: 0 0 5px 5px;\n  width: 100%;\n  height: 10px;\n\n}\n\n.info-panel-center-modal{\n  position : fixed;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 50px;\n  top: calc(50% - 100px);\n  left: calc(50% - 150px);\n  right: calc(50% - 150px);\n\n  background-color: var(--background-color);\n  border:1px solid var(--main-color);\n  padding:10px;\n  min-height: 200px;\n  min-width: 300px;\n  border-radius: var(--border-radius);\n  text-align: center;\n  z-index: 1000;\n}\n\n.freight-tax-text{\n  white-space: pre-line;\n  color: #888;\n}\n\n\n.faction-logo{\n  width:50px;\n  height:50px;\n  border: 1px solid cyan;\n  border-radius: 5px;\n  display: none;\n}\n\n\n.key1{\n  position : fixed;\n  bottom: 50px;\n  left: 50px;\n  border-radius:10px;\n  width:40px;\n  height:40px;\n  border: solid 2px white;\n}\n\n\n.key2, .key3, .key4, .key1{\n  display: none;\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n.inventory-old{\n  display: flex;\n  color: var(--main-color);\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap:20px;\n  overflow-y: scroll;\n  max-height: 100%;\n  /*max-width: 800px;\n  margin:auto*/\n}\n\n\n.total-stats-section{\n  position: relative;\n  width:calc(100%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: var(--3);\n  gap:30px;\n  border-radius: 10px;\n  align-self: center;\n  overflow: scroll;\n}\n\n.total-stats-section .title{\n  width:calc(100%);\n  text-align: center;\n}\n\n.total-stats-section .stats {\n  width:calc(100%);\n  display: flex;\n  flex-direction: row;\n  gap:10px;\n  justify-content: space-between;\n}\n\n.total-stats-section .stats .left-stats{\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n}\n\n.total-stats-section .stats .right-stats{\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  justify-content: start;\n  align-self: start;\n}\n\n.general-inventory{\n  position: relative;\n  width:100%;\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  justify-content: start;\n\n  padding: var(--2);\n  gap:var(--2);\n  max-width: 600px;\n  border-radius: 10px;\n  height:calc(100% - 90px);\n  flex: none;\n\n  margin-bottom: 90px ;\n  --dot-bg: #2E2E52;\n\n  --dot-color: var(--secondary-color);\n  --dot-size: 1px;\n  --dot-space: 24px;\n\n  \n  transition-duration: 0.4s;\n  transition-timing-function: ease-in-out;\n\t/*\n  border: 1px solid var(--secondary-color);\n\n  background:\n\t\tlinear-gradient(90deg, var(--dot-bg) calc(var(--dot-space) - var(--dot-size)), transparent 1%) center / var(--dot-space) var(--dot-space),\n\t\tlinear-gradient(var(--dot-bg) calc(var(--dot-space) - var(--dot-size)), transparent 1%) center / var(--dot-space) var(--dot-space),\n\t\tvar(--dot-color);\n    background-position: center center ;*/\n\n}\n\n.voyage .general-inventory{\n  padding:0;\n  margin-bottom: 0;\n  flex:auto;\n  height: calc(50% - 50px);\n}\n\n\n.general-inventory .hull {\n  width: calc(100%);\n  height: calc(70%);\n  border-radius: 150px;\n  top: -35%;\n  position: absolute;\n  border-radius: var(--border-radius);\n  flex:none;\n  overflow: hidden;  \n  pointer-events: none;\n  z-index: 15;\n}\n\n\n.general-inventory .items {\n  position: relative;\n  width:calc(100%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: calc(100%);\n  gap: var(--1);\n  justify-content: start;\n  /*height:500px;*/\n  /*overflow-y: scroll;*/\n}\n\n.general-inventory .items .background-color-pulse{\n  position: absolute;\n  width: 100%;\n  left:0;\n  right:0;\n  top:-79%;\n  aspect-ratio: 1/1;\n  border-radius: calc(50%) ;\n  border-left: 40px solid transparent;\n  border-top: 40px solid transparent;\n  border-right: 40px solid var(--background-color);\n\n  border-bottom: 40px solid var(--background-color);\n  animation: background-color-pulse 1s ease-out;\n  opacity: 0;\n}\n\n@keyframes background-color-pulse {\n  0% {\n    transform: rotate(45deg) scale(0);\n    opacity: 1;\n  }\n  100% {\n    transform:  rotate(45deg)  scale(2);\n    opacity: 1;\n  }\n}\n\n.general-inventory .items::after123 {\n  position: absolute;\n  content: \"\";\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 10%;  \n  border-radius: 0 0 var(--border-radius) var(--border-radius);\n  border: 1px solid #888;\n  border-top: none;\n  pointer-events: none;\n}\n\n.appear{\n  animation: appear 0.5s ease;\n  opacity: 1;\n}\n\n@keyframes appear {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes appear-delayed {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n\n@keyframes appear-with-opacity-delayed {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 0.4;\n  }\n}\n\n@keyframes appear-with-scale-delayed {\n  0% {\n    opacity: 0;\n    transform: scale(0);\n  }\n  50% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n\n\n.appear-with-shift{\n  animation: appear-with-shift 0.5s ease;\n  opacity: 1;\n}\n\n@keyframes appear-with-shift {\n  0% {\n    transform: translate(0, 100px);\n    opacity: 0;\n  }\n  100% {\n    transform: none;\n    opacity: 1;\n  }\n}\n\n.appear-with-shift-left{\n  animation: appear-with-shift-left 0.5s ease;\n  opacity: 1;\n}\n\n@keyframes appear-with-shift-left {\n  0% {\n    transform: translate(50px, 0);\n    opacity: 0;\n  }\n  100% {\n    transform: none;\n    opacity: 1;\n  }\n}\n\n.appear-with-shift-right{\n  animation: appear-with-shift-right 0.5s ease;\n  opacity: 1;\n}\n\n@keyframes appear-with-shift-right {\n  0% {\n    transform: translate(-50px, 0);\n    opacity: 0;\n  }\n  100% {\n    transform: none;\n    opacity: 1;\n  }\n}\n\n.appear-with-shift-down{\n  animation: appear-with-shift-right 0.5s ease;\n  opacity: 1;\n}\n\n@keyframes appear-with-shift-down {\n  0% {\n    transform: translate(0px, -50px);\n    opacity: 0;\n  }\n  100% {\n    transform: none;\n    opacity: 1;\n  }\n}\n\n\n\n.items .info-left{\n  position: absolute;\n  top: calc(28%);\n  right: calc(50% + var(--2));\n  left: 0;\n\n  color: #888;\n  z-index: 0;\n  border-right: 1px solid #888;\n  padding:var(--2);\n  padding-top: var(--2);\n  padding-bottom: var(--2);\n  \n  top: calc(50% + 20px);\n  transform: translateY(-50%)\n}\n\n.items .info-left::after12{\n  content: '';\n  position: absolute;\n  top: -100px;\n  right: -1px;\n  left: 0;\n  border-right: 1px solid #888;\n  height: 100px;\n}\n\n.items .info-right{\n  position: absolute;\n  top: calc(28%);\n  left: calc(50% + var(--2)) ;\n  right: 0;\n  color: #888;\n  z-index: 0;\n  border-left: 1px solid #888;\n  padding:var(--2);\n  padding-top: var(--2);\n  padding-bottom: var(--2);\n    \n  top: calc(50% + 20px);\n  transform: translateY(-50%)\n}\n\n\n.general-inventory .hull img{\n\n  /*width:100%;\n  height:100%;\n    box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.5);  \n  filter: grayscale(80%); \n\n  object-fit: cover;*/\n  left: 0; \n  right: 0; \n  margin-left: auto; \n  margin-right: auto; \n  height: calc(100%);\n  top: 0;\n  bottom:0;\n  position: absolute;\n  aspect-ratio: 1/1;\n  object-fit: contain;\n  border-radius:20px;\n  z-index: 10;\n  pointer-events: none;\n  transition-duration: 0.3s;\n  transition-timing-function: ease-in-out;\n}\n\n.img-float-animation{\n  animation: img-float-animation 6s ease-in-out infinite;\n}\n\n\n.general-inventory .hull .circle{\n  position: absolute;\n  left: 0; \n  right: 0; \n  margin: auto; \n  top:calc(20%);\n  height: calc(60%);\n  z-index: 1;\n  aspect-ratio: 1/1;\n  border-radius: calc(50%);\n  border: 1px solid transparent;\n  background-color: transparent;\n  pointer-events: all;\n}\n\n/*\n.general-inventory .hull .circle::before{\n  position: absolute;\n  background:#2E2E52;\n  top:-50px;\n  left:-50px;\n  width:300px;\n  z-index: -1;\n  aspect-ratio: 1/2;\n  border-radius:150px;\n  border: 1px solid var(--main-color);\n    content: \"\";\n    display: none;\n}\n*/\n\n.general-inventory .hull .circle::before{\n  position: absolute;\n  top: calc(-20% - 1px);\n  left:calc(-20% - 1px);\n  height: calc(140%);\n  z-index: -1;\n  aspect-ratio: 1/1;\n  border-radius: calc(70%);\n  border: 1px solid #2E2E52;\n  border-top: 1px dashed var(--main-color);\n\n  border-left: 1px solid var(--main-color);\n  border-right: 1px solid var(--main-color);\n  border-bottom: 1px dashed var(--main-color);\n\n  border: 1px solid #888;\n\n  transition-duration: 0.6s;\n  transition-timing-function: ease-in-out;\n\n  background-color: var(--background-color);\n\n  transform: rotate(45deg);\n    content: \"\";\n}\n\n.general-inventory .hull .circle.active1::before{\n    animation: circle-tap-effect1 0.5s ease-in;\n\n}\n.general-inventory .hull .circle.active2::before{\n  animation: circle-tap-effect2 0.7s ease-in;\n\n}\n\n@keyframes circle-tap-effect1 {\n  0%, 100% {\n    background-color: var(--background-color);\n  }\n  50% {\n    background-color: red;\n  }\n}\n@keyframes circle-tap-effect2 {\n  0%, 100% {\n    background-color: var(--background-color);\n  }\n  50% {\n    background-color: red;\n  }\n}\n/*\n.general-inventory .items .hull:hover .circle::before {\n  transform: rotate(180deg);\n}*/\n\n\n.tabs-row{\n  z-index: 100;\n  width: calc(100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: calc(var(--border-radius));\n  border: 1px solid #888;  \n  padding: var(--1);\n  gap: var(--1);\n  transition-duration: 0.2s;\n  transition-timing-function: ease-in-out;\n}\n\n.tabs-row .tab{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  padding: var(--2);\n  border-radius: 5px;\n  flex: auto;\n  color: var(--main-color);\n  justify-content: center;\n  cursor: pointer;\n  flex: 1 1 0;\n  width: 0;\n  text-wrap: nowrap;\n}\n\n.tab:hover{\n  color: #fff;\n}\n\n.tabs-row .tab.selected{\n  background-color: var(--main-color);\n  color: #000;\n}\n\n.general-inventory .items .ship-present-card{\n  position: relative;\n  width:100%;\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  gap:var(--2);\n  justify-content: start;\n  border-radius: var(--border-radius);\n  height: 100%;\n  flex:auto;\n  overflow: hidden;\n}\n\n.ship-present-card .modules-block-list,\n.ship-present-card .crews-block-list{\n  position: absolute;\n  width: 40%;\n  top:0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n\n}\n\n.ship-present-card .crews-block-list{\n  left: auto;\n  right: 0;\n\n}\n\n.general-inventory .items .items-row{\n  position: relative;\n  width:100%;\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  gap:var(--2);\n  justify-content: start;\n  border-radius: var(--border-radius);\n  height: auto;\n  flex:auto;\n  overflow-y: auto;\n  padding: var(--2);\n}\n\n.general-inventory .items .section-title{\n  position:absolute;\n  left:0; \n  right: 0;\n  border-radius: var(--border-radius) var(--border-radius) 0px 0px;\n  padding: var(--2);\n  top:0px;\n  background-color:#888;  \n  color:var(--background-color);\n  margin:-1px;\n  text-align: start;\n  \n}\n\n.general-inventory .items .items-row .equip-items,\n.general-inventory .items .items-row .crew-items{\n  width:calc(100%);\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  gap:var(--2);\n  justify-content: start;\n  border-radius: var(--border-radius);\n}\n\n.general-inventory .items .items-row .crew-items::beforex,\n.general-inventory .items .items-row .equip-items::beforex{\n  content:\"equip\";\n  position:absolute;\n  top:-18px;\n  left:-1px;\n  border-radius: var(--border-radius) var(--border-radius) 0px 0px;\n  padding-left: 5px;\n  padding-right: 5px;\n  height: 18px;\n  width:70px;\n  background-color:var(--main-color);  \n  color:#2E2E52;\n  \n  text-align: center;\n}\n\n.general-inventory .items .ship-present-card::afterx,\n.general-inventory .items .items-row .equip-items::afterx,\n.general-inventory .items .items-row .crew-items::afterx{\n\n  content:\"\";\n  position:absolute;\n  top:0;\n  left:0;\n  bottom: 0;\n  border-radius: 0 0 0 var(--border-radius);\n  width:78px;\n  border: 1px solid  var(--main-color);  \n  border-right: none;\n  border-top: none;\n\n}\n\n.general-inventory .items .items-row .crew-itemsx{\n  width:92px;\n  border-radius: 10px 0px 10px 10px;\n}\n\n.general-inventory .items .items-row .crew-items::beforex{\n  content:\"crew\";\n  left:auto;\n  right:-1px;\n}\n\n.general-inventory .items .item {\n  width:80px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  aspect-ratio: 1/1;\n  gap:10px;\n  justify-content: center;\n  border-radius: 0 0 5px 5px;\n  flex:none;\n  z-index: 1;\n  padding: 3px;\n  border: 1px solid #888;  \n  margin-top:12px;\n\n}\n\n.general-inventory .items .item .name{\n  position: absolute;\n  top:-13px;\n  height: 13px;\n  left: -1px;\n  right: -1px;\n  background-color: #888;\n  border-radius: 5px 5px 0 0;\n  color: var(--background-color );\n\n  overflow: hidden;\n  text-wrap: nowrap;\n  text-overflow: ellipsis;\n  padding-left: var(--1);\n  padding-right: var(--1);\n}\n\n.general-inventory .items .navigator-items{\n  width: calc(100%);\n  height: calc(100%);\n}\n\n.general-inventory .items .item.navigator{\n  width: calc(100%);\n  height: calc(100%);\n}\n\n.general-inventory .items .item:hover::before123,\n.general-inventory .items .item:hover::after123{\n  width:40px;\n}\n\n.general-inventory .items .item.crew img{\n  border-radius: 10px;\n}\n\n/*\n.general-inventory .items .item::before {\n  position: absolute;\n  width:84px;\n  aspect-ratio: 1/1;\n  left:-4px;\n  top:-4px;\n  flex:none;\n  border: 1px solid  transparent;\n  border-left: 1px solid  var(--main-color);\n  transform: rotate(45deg);\n  border-radius: 42px ;\n  content: \"\";\n  z-index: 10;\n}*/\n\n.general-inventory .items .item::before123 {\n  position: absolute;\n  width:20px;\n  aspect-ratio: 1/1;\n  left:-2px;\n  top:-2px;\n  flex:none;\n  border: 1px solid  transparent;\n  border-left: 1px solid  var(--main-color);\n  border-top: 1px solid  var(--main-color);\n  border-radius: 5px 0px;\n  content: \"\";\n  z-index: 10;\n  \n  transition-duration: 0.2s;\n  transition-timing-function: ease-in-out;\n}\n\n.general-inventory .items .item::after123 {\n  position: absolute;\n  width:20px;\n  aspect-ratio: 1/1;\n  right:-2px;\n  bottom:-2px;\n  flex:none;\n  border: 1px solid  transparent;\n  border-right: 1px solid  var(--main-color);\n  border-bottom: 1px solid  var(--main-color);\n  border-radius: 5px 0px;\n  content: \"\";\n  z-index: 10;\n  \n  transition-duration: 0.2s;\n  transition-timing-function: ease-in-out;\n}\n\n\n.general-inventory .items .item img{\n  width:100%;\n  aspect-ratio: 1/1;\n  object-fit: contain;\n  z-index: 10;\n  display: none;\n}\n\n\n.category{\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap:20px;\n  justify-content: start;\n  align-items: center;\n  width: 100%;\n  max-width: 800px;\n  margin: auto;\n  /*background-color: var(--main-color);\n  padding:10px;\n  color: black;*/\n  max-height: calc(100%);\n  overflow-y: scroll;\n}\n\n.category .title{\n  \n}\n\n.category .card-row{\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap:var(--2);\n  max-width: 630px;\n  padding-right: var(--1);\n  scroll-snap-type: y mandatory;\n  width: calc(100%)\n}\n\n.category .card-row.vertical{\n  flex-direction: column;\n}\n\n\n\n.hull-card,\n.hull-card-placeholder,\n  .stats-holder{\n    width:300px;\n    /*width:80px;*/\n    aspect-ratio: 3 / 5;\n  }\n\n.hull-card-placeholder{\n  border-radius: 10px;\n  border: 1px dashed var(--main-color);\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.hull-card{\n  position: relative;\n  border-radius: 20px;\n  scroll-snap-align: start;\n\n  background: #2E2E52;\n  background: radial-gradient(circle at top, #32b5f2, #2E2E52, #2E2E52);  \n\n  background: radial-gradient(circle at top, #e66465, #2E2E52, #2E2E52);  \n  flex:none;\n  box-shadow: 1px 1px 5px 1px rgba(42, 42, 42, 0.5);  \n  border: 1px solid var(--secondary-color);\n\n}\n\n\n.crew-card,\n.crew-card-placeholder,\n.crew-stats-holder{\n    width:150px;\n    aspect-ratio: 3/4;\n  }\n\n.crew-card{\n  position: relative;\n  border-radius: 10px 10px 10px 10px;\n  margin-right:150px;\n  width:150px;\n  /*width:80px;*/\n  /*background: #e8ded4;\n  background: #d3cac1;*/\n  background: #bdbdbd;\n  background: var(--main-color);\n\n  /*background: radial-gradient(circle at bottom, #32b5f2, #2E2E52, #2E2E52);  */\n  flex:none;\n  box-shadow: 1px 1px 5px 1px rgba(42, 42, 42, 0.5);  \n  border: 2px solid var(--secondary-color);\n  border-right: 2px solid var(--main-color);\n  border-top: 2px solid var(--main-color);\n  color: var(--main-color);\n}\n\n.crew-card .middle-line{\n  position: absolute;\n  top: 0px;\n  width:0px;\n  border-right: 2px solid var(--secondary-color);\n  left:149px;\n  height:200px;\n  display: none;\n}\n\n.crew-card::after{\n  position: absolute;\n  border-radius: 20px 0px 0px 20px;\n  left:-12px;\n  top: 10px;\n  width:0px;\n  height:100px;\n  border-left: 14px solid var(--main-color);\n  content: \"\";\n}\n\n.crew-card::before{\n  position: absolute;\n  border-radius: 0px 20px 20px 0px;\n  left:140px;\n  top: -2px;\n  width:160px;\n  height:170px;\n  border: 1px solid var(--main-color);\n\n  border-left: 0px;\n  content: \"\";\n}\n\n.crew-card-placeholder{\n  border-radius: 10px;\n  border: 2px dashed var(--main-color);\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.crew-card .description-right{\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  top: 10px;\n  bottom: 10px;\n  left:160px;\n  width:140px;\n  gap:10px;\n}\n\n.crew-card img{\n\n  /*width:100%;\n  height:100%;\n    box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.5);  \n  filter: grayscale(80%); \n\n  object-fit: cover;*/\n  position: absolute;\n  width:130px;\n  height:130px;\n  top:6px;\n  left:9px;\n  object-fit: cover;\n  border-radius: 10px;\n  z-index: 10;\n  border: 2px solid var(--secondary-color);\n\n}\n\n.crew-card .name{\n  position: absolute;\n  top:140px;\n  left:10px;\n  right:160px;\n  color: #000;\n}\n\n\n/*\n.inventory .hull-card::after{\n  position: absolute;\n  border-radius:  10px 10px 10px 0px;\n  right:0px;\n  top:-10px;\n  width:150px;\n  height:503px;\n  border-right: 1px solid var(--main-color);\n  border-bottom: 1px solid var(--main-color);\n  border-top: 10px solid var(--main-color);\n  content: \"\";\n}\n\n.inventory .hull-card::before{\n  position: absolute;\n  border-radius: 10px  0px 10px  10px;\n  left:0px;\n  bottom:-10px;\n  width:150px;\n  height:503px;\n  border-left: 1px solid var(--main-color);\n  border-top: 1px solid var(--main-color);\n  border-bottom: 10px solid var(--main-color);\n  content: \"\";\n}*/\n\n.hull-card img{\n\n  /*width:100%;\n  height:100%;\n    box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.5);  \n  filter: grayscale(80%); \n\n  object-fit: cover;*/\n  position: absolute;\n  width:94%;\n  aspect-ratio: 1/1;\n  object-fit: contain;\n  border-radius:20px;\n  margin:3%;\n  z-index: 10;\n\n}\n\n.hull-card .middle-line{\n  position: absolute;\n  top: 280px;\n  width:1px;\n  background-color: var(--main-color);\n  left:149px;\n  height:170px;\n}\n\n.hull-card .circle{\n  position: absolute;\n  top:50px;\n  left:50px;\n  width:200px;\n  z-index: 1;\n  aspect-ratio: 1/1;\n  border-radius:100px;\n  background-color: var(--main-color);\n}\n\n.hull-card .circle::before{\n  position: absolute;\n  top:-16px;\n  left:-16px;\n  width:230px;\n  z-index: 1;\n  aspect-ratio: 1/1;\n  border-radius:115px;\n  border: 1px solid var(--main-color);\n    content: \"\";\n}\n\n.hull-card .description-left{\n  display: flex;\n  flex-direction: column;\n  align-items: end;\n  justify-content: start;\n  top: 300px;\n  right:170px; /*150 + 20*/\n  left:20px;\n  position: absolute;\n  height: 130px;\n  gap:5px;\n  text-align: end;\n}\n\n.transparent-text{\n  color: transparent;\n}\n\n.highlight{\n  color:#2E2E52;\n  font-weight: 400;\n    background-color:var(--main-color);\n}\n\n.main-border-highlight{\n  background-color:#2E2E52;\n  border: 1px solid var(--main-color);\n  color:var(--main-color);\n}\n\n.inactive-border-highlight{\n  background-color:#2E2E52;\n  border: 1px solid #888;\n  color: #888;\n}\n\n.grey-highlight{\n  color:#2E2E52;\n  background-color:#888;\n}\n\n.grey-highlight-inversed{\n  background-color:#2E2E52;\n  color:#888;\n}\n\n.red-highlight{\n  color:black;\n  background-color:red;\n}\n\n.cyan-highlight{\n  color:black;\n  background-color:cyan;\n}\n\n.yellow-highlight{\n  color:black;\n  background-color:yellow;\n}\n\n.white-highlight{\n  color:black;\n  background-color:white;\n}\n\n.black-highlight{\n  color:var(--main-color);\n  background-color:black;\n}\n\n.white-font{\n  color: #fff;\n}\n\n.hull-card .description-right{\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  justify-content: start;\n  top: 300px;\n  left:170px; /*150 + 20*/\n  right:20px;\n  position: absolute;\n  height: 130px;\n  gap:5px;\n}\n\n\n.hull-card .title{\n  position: absolute;\n  text-align: left;\n  left: 20px;\n  right: 20px;\n  margin: auto;\n  bottom: 20px;\n  padding: 5px;\n  padding-left: 10px;\n  padding-right: 10px;\n  color:#2E2E52; \n  \n  border-radius: 10px;\n  background-color:var(--main-color);\n}\n\n\n\n.equip-card,\n.equip-card-placeholder,\n.crew-stats-holder{\n    min-width:300px;\n    width: 100%;\n    height: 200px;\n  }\n\n\n.equip-card{\n  position: relative;\n  border-radius: var(--border-radius);\n  /*width:80px;*/\n  /*background: #e8ded4;*/\n  background: #2E2E52;\n  overflow: hidden;\n  /*background: radial-gradient(circle at bottom, #32b5f2, #2E2E52, #2E2E52);\n    box-shadow: 1px 1px 5px 1px rgba(42, 42, 42, 0.5);  \n  */\n  flex:none;\n  border: 1px solid #888;\n  color: #888;\n  order: 10;\n  opacity: 0.5;\n}\n\n.equip-card.navigator{\n  height: 250px;\n  background-size: cover;\n}\n\n.equip-card.navigator.chosen{\n  height: calc(100%);\n  height: 250px;\n  border: 1px solid #888;\n  opacity: 1;\n}\n\n.equip-card.navigator .price-text{\n  z-index:10;\n  right:10px;\n}\n\n.equip-card.navigator .description,\n.equip-card.navigator .title{\n  z-index:10;\n  left: 10px;\n  right:100px;\n  color: white;\n}\n.equip-card.navigator .description{\n display: none;\n}\n\n.navigator-accent-line{\n  position: absolute;\n  z-index:1;\n  width:auto;\n  left: 0;\n  right:0;\n  top:0;\n  bottom: 0;\n  background-color: none;\n  background: radial-gradient(ellipse at bottom left,var(--background-color), transparent, transparent);\n}\n\n\n\n\n.equip-card.selected{\n  border: 1px solid var(--main-color);\n  color: var(--main-color);\n  opacity: 1;\n}\n\n.equip-card.equipped{\n  background-color: var(--background-color);\n  order: 1;\n  border: none;\n  color: #fff;\n  border-radius: 0;\n  border: none;\n  border-bottom: 1px solid #fff;\n  border-top: 1px solid #fff;\n  opacity: 1;\n}\n\n\n.equip-card.equipped::after{\n  content: \"\";\n  position: absolute;\n  top: -1px;\n  left: -1px;\n  right: -1px;\n  bottom: -1px;\n  border-radius: var(--border-radius);\n  z-index: 10;\n\n}\n\n.equip-card .left-accent{\n  position: absolute;\n  border-radius: 0px  20px  20px 0px;\n  left:-1px;\n  top: 55px;\n  width:0px;\n  height:90px;\n  border-left: 12px solid #888;\n  content: \"\";\n}\n\n.equip-card.selected .left-accent{\n  border-left: 12px solid var(--main-color);\n}\n\n.equip-card.equipped .left-accent{\n  border-left: none;\n}\n\n.equip-card-placeholder{\n  border-radius: 10px;\n  border: 2px dashed var(--main-color);\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.equip-card img{\n\n  /*width:100%;\n  height:100%;\n    box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.5);  \n  filter: grayscale(80%); \n\n  object-fit: cover;*/\n  position: absolute;\n  width:150px;\n  height:150px;\n  top:25px;\n  right:10px;\n  object-fit: contain;\n\n  z-index: 10;\n\n}\n\n.equip-card .crew-img{\n  border-radius: var(--border-radius);\n  border: 1px solid #888;\n  height: 100px;\n  width: 100px;\n  right: 25px;\n  top: 50px;\n}\n\n.equip-card.selected .crew-img{\n  border: 1px solid var(--main-color);\n}\n\n\n.equip-card .accent-line{\n  position: absolute;\n  top:0px;\n  right:40px;\n  width:60px;\n  height: calc(100%);\n  z-index: 1;\n  border-radius: 0px;\n  background-color: #888;\n}\n\n.equip-card.equipped .accent-line{\n  background-color: #fff;\n\n}\n\n.equip-card.selected .accent-line{\n  background-color: var(--main-color);\n}\n\n.equip-card .accent-circle{\n  position: absolute;\n  top:0px;\n  right:30px;\n  width:110px;\n  border-radius: 0 0 55px 55px;\n  height:160px;\n  z-index: 1;\n  background-color: #888;\n}\n\n\n.equip-card.selected .accent-circle{\n  background-color: var(--main-color);\n}\n\n.equip-card.equipped .accent-circle{\n  border: 1px solid #fff;\n  border-top: none;\n  background-color: var(--background-color);\n  color: #000;\n  order: 1;\n}\n\n.equip-card .accent-circle::after{\n  position: absolute;\n  content: '';\n  top:-10px;\n  bottom: -10px;\n  left: -10px;\n  right: -10px;\n  border: 1px solid #888;\n  border-radius: 0 0 65px 65px;\n}\n\n.equip-card.equipped .accent-circle::after{\n\n  border: 1px solid #fff;\n}\n\n\n.equip-card.selected .accent-circle::after{\n  border: 1px solid var(--main-color);\n}\n\n.equip-card .title{\n  position: absolute;\n  bottom:10px;\n  left:10px;\n  right:160px;\n  \n}\n\n\n.equip-card .description{\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  position: absolute;\n  top: 60px;\n  bottom: 50px;\n  left:20px;\n  right:150px;\n  white-space: pre-wrap; /* or pre-line */\n  \n}\n\n\n.equip-card .hull-description{\n  display: flex;\n  justify-content: space-between;\n  align-items: start;\n  position: absolute;\n  top: 50px;\n  bottom: 50px;\n  left:var(--2);\n  right:180px;\n  gap: var(--4);\n  max-width: 200px;\n}\n\n\n\n.equip-card .price-text{\n  position: absolute;\n  top:10px;\n  left:10px;\n  right:160px;\n  background-color: #888;\n  color: var(--background-color);\n  text-align: center;\n  text-transform: uppercase;\n}\n\n.equip-card.equipped .price-text{\n  background-color: #fff;\n\n}\n\n.equip-card.selected .price-text{\n  background-color: var(--main-color);\n}\n\n.terminal{\n  width:100%;\n  max-width: 500px;\n  padding:10px;\n  padding-bottom: 20px;\n  position: relative;\n  align-self: center;\n  border-radius: 10px ;\n  /*width:80px;*/\n  /*background: #e8ded4;*/\n  background: var(--main-color);\n  /*background: radial-gradient(circle at bottom, #32b5f2, #2E2E52, #2E2E52);  */\n  flex:none;\n  color: #000;\n  box-shadow: 1px 1px 5px 1px black;  \n  border: 2px solid var(--secondary-color);\n  border-right: 2px solid var(--main-color);\n  border-bottom: 2px solid var(--main-color);\n}\n\n.terminal::after{\n  content: \"\";\n  position: absolute;\n  width:310px;\n  left:calc(50% - 155px);\n  bottom:-8px;\n  height:15px;\n  background: #2E2E52;\n  background: linear-gradient(black, #2E2E52);\n  border-radius: 10px 10px 0px 0px;\n}\n\n.terminal .window{\n  width:100%;\n  aspect-ratio: 3/2;\n  position: relative;\n  border-radius: 10px ;\n  /*width:80px;*/\n  /*background: #e8ded4;*/\n  background: #2E2E52;\n  /*background: radial-gradient(circle at bottom, #32b5f2, #2E2E52, #2E2E52);  */\n  flex:none;\n  box-shadow: 1px 1px 5px 1px inset rgba(42, 42, 42, 0.5);  \n  border: 4px solid var(--secondary-color);\n  color: #000;\n  overflow: hidden;\n}\n\n.terminal .keyboard{\n  width:100%;\n  height:100px;\n  position: relative;\n  margin: auto;\n  margin-top: 10px;\n  border-radius: 10px ;\n  /*width:80px;*/\n  /*background: #e8ded4;*/\n  background: var(--main-color);\n  /*background: radial-gradient(circle at bottom, #32b5f2, #2E2E52, #2E2E52);  */\n  flex:none;\n  box-shadow: 1px 1px 5px 1px rgba(42, 42, 42, 0.5);  \n  overflow: hidden;\n}\n\n\n.terminal img{\n\n  position: absolute;\n  width:100%;\n  aspect-ratio: 3/2;\n  object-fit:cover;\n  border-radius: 10px ;\n}\n\n.terminal .description{\n  position: absolute;\n  left:10px;\n  top: 10px;\n  padding:10px;\n  border-radius: 10px 0px 0px 0px;\n  border-left: 1px solid var(--main-color);\n  border-top: 1px solid var(--main-color);\n  max-height:200px;\n  color: var(--main-color);\n}\n\n\n.gray img{\n  -webkit-filter: grayscale(100%);\n  -moz-filter: grayscale(100%);\n    -o-filter: grayscale(100%);\n   -ms-filter: grayscale(100%);\n       filter: grayscale(100%); \n}\n\n/*\ncanvas{\n  background:#000;\n}\n\n.hud{\n  color: #7ab98d;\n}\n\n.info-panel-left,\n.info-panel-right,\n.order-btn,\n.commands-panel{\n  border-color: #7ab98d;\n}\n\n.commands-panel .selected{\n  background-color: #7ab98d;\n  color:#000;\n}\n\n.order-btn h2{\n  color:#000;\n  background-color: #7ab98d;\n  padding: 10px;\n}\n*/\n@keyframes glitch1 {\n  0% {\n    transform: none;\n    opacity: 1;\n  }\n  7% {\n    transform: skew(-0.5deg, -0.9deg);\n    opacity: 0.75;\n  }\n  10% {\n    transform: none;\n    opacity: 1;\n  }\n  27% {\n    transform: none;\n    opacity: 1;\n  }\n  30% {\n    transform: skew(0.8deg, -0.1deg);\n    opacity: 0.75;\n  }\n  35% {\n    transform: none;\n    opacity: 1;\n  }\n  52% {\n    transform: none;\n    opacity: 1;\n  }\n  55% {\n    transform: skew(-1deg, 0.2deg);\n    opacity: 0.75;\n  }\n  50% {\n    transform: none;\n    opacity: 1;\n  }\n  72% {\n    transform: none;\n    opacity: 1;\n  }\n  75% {\n    transform: skew(0.4deg, 1deg);\n    opacity: 0.75;\n  }\n  80% {\n    transform: none;\n    opacity: 1;\n  }\n  100% {\n    transform: none;\n    opacity: 1;\n  }\n}\n\n@keyframes glitch2 {\n  0% {\n    transform: none;\n    opacity: 0.25;\n  }\n  7% {\n    transform: translate(-4px, -5px);\n    opacity: 0.5;\n  }\n  10% {\n    transform: none;\n    opacity: 0.25;\n  }\n  27% {\n    transform: none;\n    opacity: 0.25;\n  }\n  30% {\n    transform: translate(-7px, -3px);\n    opacity: 0.5;\n  }\n  35% {\n    transform: none;\n    opacity: 0.25;\n  }\n  52% {\n    transform: none;\n    opacity: 0.25;\n  }\n  55% {\n    transform: translate(-5px, -1px);\n    opacity: 0.5;\n  }\n  50% {\n    transform: none;\n    opacity: 0.25;\n  }\n  72% {\n    transform: none;\n    opacity: 0.25;\n  }\n  75% {\n    transform: translate(-2px, -6px);\n    opacity: 0.5;\n  }\n  80% {\n    transform: none;\n    opacity: 0.25;\n  }\n  100% {\n    transform: none;\n    opacity: 0.25;\n  }\n}\n\n@keyframes glitch3 {\n  0% {\n    transform: none;\n    opacity: 0.25;\n  }\n  7% {\n    transform: translate(2px, 3px);\n    opacity: 0.5;\n  }\n  10% {\n    transform: none;\n    opacity: 0.25;\n  }\n  27% {\n    transform: none;\n    opacity: 0.25;\n  }\n  30% {\n    transform: translate(5px, 2px);\n    opacity: 0.5;\n  }\n  35% {\n    transform: none;\n    opacity: 0.25;\n  }\n  52% {\n    transform: none;\n    opacity: 0.25;\n  }\n  55% {\n    transform: translate(5px, 1px);\n    opacity: 0.5;\n  }\n  50% {\n    transform: none;\n    opacity: 0.25;\n  }\n  72% {\n    transform: none;\n    opacity: 0.25;\n  }\n  75% {\n    transform: translate(2px, 6px);\n    opacity: 0.5;\n  }\n  80% {\n    transform: none;\n    opacity: 0.25;\n  }\n  100% {\n    transform: none;\n    opacity: 0.25;\n  }\n}\n\n.ally-mark{\n  fill: #F2B43B;\n}\n\n#ally-mark{\n  fill: #F2B43B;\n}\n\n.enemy-mark{\n  fill: #FC5D47;\n}\n\n.modal-list{\n  position: fixed;\n  background:#2E2E52;\n  border-radius: var(--border-radius);\n  border: 1px solid var(--main-color);\n  /*box-shadow: 1px 1px 20px black;*/\n  display: flex;\n  flex-direction: column;\n  max-width: 800px;\n  margin: 0% auto; /* Only centers horizontally not vertically! */\n  bottom: var(--4);\n  top:var(--2);\n  left: var(--2);\n  right: var(--2);\n  z-index: 1000;\n}\n\n.modal-list .btns{\n  padding: 20px;\n  width:100%;\n  border-bottom:1px solid var(--main-color);\n}\n\n.modal-list .btns .back-btn{\n  flex:none;  \n  cursor: pointer;\n}\n\n.modal-list .category{\n  padding-top: 20px;\n  padding-bottom: 20px;\n  overflow: scroll;\n  flex: auto;\n  order: 1;\n  align-self: stretch;\n  flex-grow: 1;\n}\n\n\n.voyage{\n  position: relative;\n  width:100%;\n  max-width: 600px;\n\n  height: calc(100%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: start;\n  /*padding: var(--2);*/\n  /*max-width: 600px;*/\n  overflow: hidden;\n  /*margin-bottom: 50px;*/\n  gap:var(--2);\n  padding-top: var(--2);\n  padding: var(--2);\n\n  \n  transition-duration: 0.2s;\n  transition-timing-function: ease-in-out;\n}\n\n.voyage .voyage-section{\n  position: relative;\n  width:100%;\n  height: calc(100% - 86px);\n  margin-bottom: 86px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: start;\n  /*padding: var(--2);*/\n  /*max-width: 600px;*/\n  /*margin-bottom: 50px;*/\n  gap:var(--1);\n  z-index: 100;\n\n}\n\n.opacity-transform{\n  opacity: 0.2;\n}\n\n.opacity-transform-full{\n  opacity: 0;\n}\n\n.station-card-div{\n  position: relative;\n  width: 100%;\n  min-height: 200px;\n  object-fit:cover !important;\n  background-size: cover;\n  border-radius: var(--border-radius) var(--border-radius);\n  overflow: hidden;\n  opacity: 1;\n  max-height: none;\n\n  transition-duration: 0.4s;\n  transition-timing-function: ease-in-out;\n}\n\n.bottom-drawer.hidden .station-card-div{\n  opacity: 0;\n  max-height: 200px;\n  height: 200px;\n}\n\n.station-card-background{\n  position: relative;\n  width: 100%;\n  min-height: 200px;\n  max-height: 100%;\n  object-fit:cover !important;\n  background-size: cover;\n}\n\n.station-card-div::after{\n  content: '';\n  position: absolute;\n  width: 100%;\n  height: 100px;\n  left:0;\n  right:0;\n  bottom: 0;\n  z-index: 12;\n}\n\n.background-canvas{\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 0;\n  \n}\n\n.voyage .anomaly-canvas{\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 0;\n  overflow: hidden;\n  opacity: 0.2;\n  \n}\n\n.voyage .anomaly-canvas .anomaly-alert{\n  position: absolute;\n  width:2px;\n  height: 2px;\n  border-radius: 50%;\n  background-color: red;\n}\n\n\n.voyage .anomaly-canvas .anomaly-alert .anomaly-label{\n  color: #888;\n}\n\n\n.voyage .full-absolute-div{\n  position: absolute;\n  flex: none;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 0;\n}\n\n.background-canvas .anomaly-alert .anomaly{\n\n}\n\n.background-canvas .cross{\n  position: absolute;\n  width:1px;\n  height: 1px;\n  \n\n  transition-duration: 1s;\n  transform-origin: bottom center;\n  transition-timing-function: ease-in-out;\n  opacity: 0.2;\n}\n\n\n.background-canvas .cross.light{\n  opacity: 0.5;\n}\n\n  .background-canvas .cross.light::before,\n  .background-canvas .cross.light::after{\n      \n}\n\n.background-canvas .cross::before{\n  content: '';\n  position: absolute;\n  width:1px;\n  height: 7px;\n  left: 0px;\n  top:-3px;\n  background-color: var(--main-color);\n}\n\n.background-canvas .cross::after{\n  content: '';\n  position: absolute;\n  width: 7px;\n  height: 1px;\n  left: -3px;\n  top:0px;\n  background-color: var(--main-color);\n}\n\n.background-canvas .cross.cyan::before11,\n  .background-canvas .cross.cyan::after11{\n    background-color: cyan;\n    /*animation:glitch2 13s infinite;*/\n    opacity: 0;\n    \n}\n\n\n.background-canvas .cross.red::before11,\n  .background-canvas .cross.red::after11{\n    background-color: red;\n    animation:glitch3 21s infinite;\n  }\n\n\n\n.background-canvas .dot-star,\n.background-canvas .dot-star-big{\n  position: absolute;\n  width:1px;\n  height: 1px;\n  \n\n  transition-duration: 1s;\n  transform-origin: bottom center;\n  transition-timing-function: ease-in-out;\n  background-color: #fff;\n  opacity: 0.8;\n}\n\n.background-canvas .dot-star-big{\n  opacity: 0.3;\n}\n\n\n.star-shift-animation .background-canvas .cross{\n  animation: pulsate-twice  1.5s ease-in-out;\n  /*transform: translateY(70px) scaleY(50);   \n  opacity: 0.5;*/\n\n}\n\n.star-shift-animation .background-canvas .cross.light{\n  animation: pulsate-twice-2  1.5s ease-in-out;\n  /*transform: translateY(70px) scaleY(50);   \n  opacity: 0.5;*/\n\n}\n\n.voyage .star-shift-animation .background-canvas .dot-star{\n  animation: star-shift-animation 1.3s ease-in-out;\n  \n  /*transform: translateY(70px) scaleY(50);   \n  opacity: 0.5;*/\n\n}\n\n.voyage .star-shift-animation .background-canvas .dot-star-big{\n  animation: star-shift-animation 1.15s ease-in-out;\n  /*transform: translateY(50px) scaleY(30);   \n  opacity: 0.5;*/\n\n}\n\n\n@keyframes star-shift-animation {\n  0%, 100%{\n  }\n  50% {\n    transform: scaleY(150) translateY(3px);  \n    opacity: 0; \n  }\n  50.01% {\n    transform: scaleY(100) translateY(-3px);  \n    opacity: 0; \n  }\n\n}\n\n.voyage .hyperdive-animation .background-canvas .dot-star{\n  animation: hyperdive-animation-frames 1.0s ease-in-out;\n  transform-origin: center center;\n\n  /*transform: translateY(70px) scaleY(50);   \n  opacity: 0.5;*/\n\n}\n\n.voyage .hyperdive-animation .background-canvas .dot-star-big{\n  transform-origin: center center;\n  animation-delay: 100ms;\n  animation: hyperdive-animation-frames 0.90s ease-in-out;\n  /*transform: translateY(50px) scaleY(30);   \n  opacity: 0.5;*/\n\n}\n\n\n@keyframes hyperdive-animation-frames {\n  0%, 100%{\n  }\n  50%{\n    background-color: var(--background-color);\n    transform: translateY(-100px) scaleY(100); \n  }\n  51%{\n    background-color: var(--background-color);\n    transform: translateX(-100px) scaleX(-100);\n  }\n}\n\n\n\n\n.voyage .secondary-screen{\n  z-index: 10;\n  display: flex;\n  flex: auto;\n  width: calc(100%);\n  height: auto;\n  max-height: 600px;\n  position: relative;\n  justify-content: start;\n  align-items: center;\n  border-top: none;\n\n\n  transition-duration: 0.4s;\n  transition-timing-function: ease-in-out;\n  overflow-x: auto;\n  gap: var(--2);\n}\n\n\n.secondary-screen .path{\n  position: relative;\n  overflow: hidden;\n  flex: none;\n  height: 100%;\n  width: 1000%;\n}\n\n.voyage .secondary-screen .indicators-boxes{\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  flex: auto;\n  gap: var(--1);\n  overflow: hidden;\n  align-self: stretch;\n  padding: var(--2);\n}\n\n.voyage .secondary-screen .indicators-boxes .label{\n  position: relative;\n  width: 100%;\n  color: #888;\n  border: 1px solid #888;\n  text-wrap: nowrap;\n  overflow: hidden;\n  flex: none;\n  text-align: center;\n}\n\n.voyage .secondary-screen .indicator-box{\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  flex: auto;\n  overflow: hidden;\n  gap: var(--1);\n  background-color: var(--background-color-transparent);\n}\n\n.radar-waves-box{\n  position: absolute;\n  right:0;\n  left: 0;\n  top:0;\n  bottom:0px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n  overflow: hidden;\n  opacity: 0.7;\n  z-index: 11;\n  pointer-events: none;\n}\n\n.radar-waves-svg{\n  width: 100%;\n}\n\n.animated-line {\n  stroke: #888;\n  stroke-width: 2;\n  transform-origin: center top; /* Set origin so the line shrinks from the top */\n  animation: shrinkAnimation infinite ease-in-out;\n}\n\n\n.animated-line.second-line{\n\n}\n\n@keyframes shrinkAnimation {\n  0%, 100% {\n    transform: translateY(0%); /* Full height */\n  }\n  50% {\n    transform: translateY(10%); /* Shrinks to half height */\n  }\n}\n.voyage .secondary-screen .indicator-box .probability-label{\n  height: 100%;\n  width: 80px;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  align-items: stretch;\n  justify-content: center;\n  flex: auto;\n  overflow: hidden;\n  color: var(--main-color);\n  opacity: 0.8;\n  text-align: center;\n}\n\n.voyage .secondary-screen .indicator-box .probability-label .header{\n  border: 1px solid var(--main-color);\n  background-color: var(--background-color-transparent);\n}\n\n.voyage .secondary-screen .indicator-box .probability-label .label-body{\n  \n}\n\n.voyage .secondary-screen .indicator-box::after{\n  content:\"\";\n  position: absolute;\n  bottom:0;\n  left:0;\n  right:0;\n  height: var(--border-radius);\n  border: 1px solid  #888;\n  border-top: none;\n  border-radius: 0 0  calc(var(--border-radius)/2) calc(var(--border-radius)/2);\n}\n\n\n.voyage .secondary-screen .indicator-box::before{\n  content:\"\";\n  position: absolute;\n  top:0;\n  left:0;\n  right:0;\n  height: var(--border-radius);\n  border: 1px solid  #888;\n  border-bottom: none;\n  border-radius: calc(var(--border-radius)/2) calc(var(--border-radius)/2) 0 0  ;\n}\n\n\n.voyage .secondary-screen .indicator-box::before123{\n  content:\"\";\n  position: absolute;\n  left:0;\n  bottom:0;\n  top:0;\n  width: var(--border-radius);\n  border: 1px solid  #888;\n  border-right: none;\n  border-radius:  calc(var(--border-radius)/2) 0 0 calc(var(--border-radius)/2);\n}\n\n.voyage .secondary-screen .indicator-box::after123{\n  content:\"\";\n  position: absolute;\n  right:0;\n  bottom:0;\n  top:0;\n  width: var(--border-radius);\n  border: 1px solid #888;\n  border-left: none;\n  border-radius: 0 calc(var(--border-radius)/2)  calc(var(--border-radius)/2) 0;\n}\n\n\n.voyage .secondary-screen .indicator-box.locations-list{\n  display: flex;\n  flex-direction: column;\n  border-radius: 0;\n  gap: var(--1);\n  align-items: center;\n  justify-content: space-evenly;\n  color: #888;\n  border: none;\n  padding: var(--2);\n}\n\n/*\n.voyage .secondary-screen .indicator-box.locations-list::after,\n  .voyage .secondary-screen .indicator-box.locations-list::before{\n    display: none;\n}*/\n\n.voyage .secondary-screen .locations-list .title{\n  border: 1px solid #888;\n  color: #888;\n  width: 100%;\n  padding-left: var(--1);\n  padding-right: var(--1);\n  text-align: center;\n  border-radius: var(--border-radius) ;\n\n}\n\n\n.voyage .secondary-screen .locations-list .sector{\n  overflow: hidden;\n  width: 120px;\n  max-width: calc(100%);\n  border-radius: 0;\n  padding: var(--1);\n  gap: 0;\n  color: #888;\n  border-top: none;\n  border: 1px solid #888;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: center;\n  z-index: 20;\n  flex: none;\n  height: auto;\n  opacity: 0.5;\n  text-align: center;\n}\n\n\n.voyage .secondary-screen .locations-list .sector.selected{\n  color: var(--main-color);\n  border-color: var(--main-color);\n  opacity: 1;\n}\n\n.voyage .secondary-screen .locations-list .sector.not-selected{\n  color: red;\n  border-color: red;\n}\n\n\n.voyage .secondary-screen .locations-list .sector .location-name{\n  background-color: #888;\n  color: var(--background-color);\n}\n\n.voyage .secondary-screen .locations-list .sector.selected .location-name{\n  background-color: var(--main-color);\n  color: var(--background-color);\n}\n\n\n.voyage .secondary-screen .locations-list .sector.not-selected .location-name{\n  background-color: red;\n  color: var(--background-color);\n}\n\n.location-type-name{\n  color: #888;\n  width: 60px;\n  margin-top: var(--2);\n}\n\n.location-name{\n  margin-bottom: 10px;\n  margin-bottom: 0px;\n}\n\n.toggler-boxes-row{\n  display: flex;\n  gap:var(--1);\n  flex-direction: row;\n  flex: auto;\n  height: 130px;\n  align-items: stretch;\n  justify-content: stretch;\n}\n\n.toggler-box{\n  height: 100%;\n  min-width: 50px;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n  gap: var(--1);\n  transition-duration: 0.3s;\n  transition-timing-function: linear;\n  transition-delay: 0ms;\n  color: #888;\n  overflow: hidden;\n  \n  padding: var(--1);\n  padding-top: var(--2);\n  padding-bottom: var(--2);\n\n}\n\n\n.toggler-box.on{\n}\n\n.toggler-box .title{\n  text-wrap: none;\n  text-align: center;\n  width: 100%;\n  color: #888;\n  transition-duration: 0.2s;\n  transition-timing-function: ease-in;\n  transition-delay: 0ms;\n  border: 1px solid #888;\n  background-color: var(--background-color);\n}\n\n.toggler-box.on .title{\n  border: 1px solid var(--main-color);\n  color: var(--main-color);\n\n}\n\n.toggler-box .label{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: nowrap;\n  gap:var(--1);\n  transition-duration: 0.2s;\n  transition-timing-function: ease-in;\n  transition-delay: 0ms;\n  width: 100%;\n}\n\n\n\n.toggler-box .label .lamp{\n  width: 7px;\n  border-radius: 50%;\n  aspect-ratio: 1/1;\n  border: 1px solid #888;\n  margin-top:2px;\n}\n\n.toggler-box.on .label.on,\n.toggler-box.off .label.off{\n  color:var(--main-color)\n}\n\n.toggler-box.on  .label.on .lamp,\n.toggler-box.off .label.off .lamp{\n  border: 1px solid var(--main-color);\n  background-color: var(--main-color);\n}\n\n\n.toggler-box .vertical-toggler{\n  min-width: 50px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  flex: auto;\n  gap: 0;\n  padding:var(--1);\n  \n}\n\n.toggler-box .vertical-toggler::after{\n  content:\"\";\n  position: absolute;\n  bottom:0;\n  left:0;\n  right:0;\n  height: var(--border-radius);\n  border: 1px solid  var(--main-color);\n  border-top: none;\n  border-radius: 0 0  calc(var(--border-radius)/2) calc(var(--border-radius)/2);\n}\n\n\n.toggler-box .vertical-toggler::before{\n  content:\"\";\n  position: absolute;\n  top:0;\n  left:0;\n  right:0;\n  height: var(--border-radius);\n  border: 1px solid  var(--main-color);\n  border-bottom: none;\n  border-radius: calc(var(--border-radius)/2) calc(var(--border-radius)/2) 0 0;\n\n}\n/*\n.toggler-box.on .vertical-toggler::before,\n.toggler-box.off .vertical-toggler::after{\n  border-color: var(--main-color);\n}\n*/\n.toggler-box .vertical-toggler .toggler{\n  width: 100%;\n  border-radius: calc(var(--border-radius)/2 - 2px);\n  height: 10px;\n  background-color: var(--main-color);\n  flex: none;\n}\n\n\n\n.toggler-box .vertical-toggler .white-space{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: auto;\n  transition-duration: 0.1s;\n  transition-timing-function: ease-in;\n  transition-delay: 0ms;\n  height:60%;\n  color: #fff;\n  background-color: var(--background-color-transparent);\n  width: 100%;\n}\n\n\n.toggler-box.on .vertical-toggler .white-space.on,\n.toggler-box.off .vertical-toggler .white-space.off{\n  flex: none;\n  height:0;\n  \n}\n\n\n\n\n.voyage .screen{\n  z-index: 10;\n  display: flex;\n  flex: none;\n  width: calc(100%);\n  height: calc(100% - 50px); /*раньше табы шли сверху*/\n  height: calc(100%);\n\n  /*max-height: 600px;*/\n  position: relative;\n  justify-content: end;\n  border-top: none;\n\n  transition-duration: 0.4s;\n  transition-timing-function: ease-in-out;\n  transition-delay: 0ms;\n  \n}\n\n.voyage .screen.no-tab{\n  height: calc(100%);\n}\n\n.voyage .screen.shrinked{\n  height: calc(50%);\n}\n\n\n\n\n.voyage .screen-bottom{\n  --group-window-size: 120px;\n  z-index: 10;\n  pointer-events: none;\n\n  flex: none;\n  width: calc(100%);\n  height: 120px;\n  height: calc(100% - 120px);\n  position: relative;\n  align-self: end;\n  border: 1px solid #888;\n  border: none;\n  border-radius: 0 0 var(--border-radius) var(--border-radius);\n  \n  transition-duration: 0.5s;\n  transition-timing-function: ease-in-out;\n}\n\n.hyperdive-map{\n  position: absolute;\n  aspect-ratio: 1/1;\n  height: calc(100%);\n  width: calc(100%);\n  z-index: 10;\n  pointer-events: none;\n  margin-left: auto;\n  margin-right: auto;\n  left: 0;\n  top: 0;\n\n  opacity: 1;\n\n  display: flex;\n  justify-content: center;\n  align-items: start;\n\n  user-select: none;\n  overflow: hidden;\n\n}\n\n.hyperdive-map::after123{\n  z-index: 20;\n  content:'';\n  position: absolute;\n  height: calc(100%);\n  width: 20px;\n  z-index: 10;\n  pointer-events: none;\n  left: 0;\n  top: 0;\n\n  opacity: 1;\n\n  background: linear-gradient(90deg, var(--background-color), transparent);\n}\n\n\n\n\n\n.hyperdive-map .hyperdive-map-header{\n  position: absolute;\n  top:-32px;\n  left:0px;\n  height:32px;\n  right: 0px;\n  background-color: #888;\n  padding: var(--2);\n  color: var(--background-color);\n  border-radius: var(--border-radius) var(--border-radius) 0 0;\n\n  display: none;\n}\n\n.hyperdive-map .map-grid{\n  position: absolute;\n  max-width: calc(100%);\n  height: calc(100%);\n  display: flex;\n  flex-direction: column-reverse;\n\n  flex:auto;\n  align-items: stretch;          \n  align-self: top;\n  /*border: 1px solid #888;*/\n  border-radius:  0 0 var(--border-radius) var(--border-radius);\n  background-color: var(--background-color);\n  overflow: scroll;\n  pointer-events: all;\n  padding-bottom: 220px;\n  animation: appear-with-zoom-in 0.4s ease-in-out;\n\n}\n\n\n\n.appear-with-zoom-in{\n  animation: appear-with-zoom-in 1s ease-in-out;\n  opacity: 1;\n}\n\n@keyframes appear-with-zoom-in {\n  0% {\n    transform: scale(2);\n    opacity: 0;\n  }\n  100% {\n    transform: none;\n    opacity: 1;\n  }\n}\n\n\n.scroll-bar-hide{\n  -ms-overflow-style: none;  /* IE and Edge */\n  scrollbar-width: none;  /* Firefox */\n}\n\n.scroll-bar-hide::-webkit-scrollbar {\n  display: none;\n}\n\n.hyperdive-map .map-grid .row{\n  flex:auto;\n  display: flex;\n  flex-direction: row;\n}\n\n\n.hyperdive-map .map-grid .row .loc-box{\n  flex:auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n  width: 70px;\n  height: 70px;\n  position: relative;\n  /*\n  border-left:1px dashed  #3a3a52;\n  border-top:1px dashed  #3a3a52;\n  */\n  pointer-events: all;\n}\n\n\n.hyperdive-map .map-grid .loc-selection{\n  flex:none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n  bottom:220px;\n  left:0;\n  width: 70px;\n  height: 70px;\n  position: absolute;\n  \n  pointer-events: none;\n\n  transition-duration: 0.3s;\n  transition-timing-function: ease-in-out;\n  transition-delay: 0ms;\n}\n\n.hyperdive-map .map-grid .selected-direction{\n  flex:none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n  bottom:240px;\n  left:20px;\n  width: 30px;\n  height: 30px;\n  z-index: 100;\n  position: absolute;\n  pointer-events: none;\n  color: var(--background-color);\n  background-color: cyan;\n  animation: pulsate 1s infinite ease-in-out;\n\n  transition-duration: 0.3s;\n  transition-timing-function: ease-in-out;\n  transition-delay: 0ms;\n}\n\n.hyperdive-map .map-grid .loc-selection .selection-border-1::before,\n.hyperdive-map .map-grid .loc-selection .selection-border-1::after,\n.hyperdive-map .map-grid .loc-selection .selection-border-2::before,\n.hyperdive-map .map-grid .loc-selection .selection-border-2::after{\n  content: '';\n  position: absolute;\n  width: 6px;\n  height: 6px;\n}\n\n\n.hyperdive-map .map-grid .loc-selection .selection-border-1::before{\n  left:0;\n  top:0;\n  border-top: 1px solid #888;\n  border-left: 1px solid #888;\n}\n\n.hyperdive-map .map-grid .loc-selection .selection-border-1::after{\n  right:0;\n  top:0;\n  border-top: 1px solid #888;\n  border-right: 1px solid #888;\n}\n\n.hyperdive-map .map-grid .loc-selection .selection-border-2::before{\n  left:0;\n  bottom:0;\n  border-bottom: 1px solid #888;\n  border-left: 1px solid #888;\n}\n\n.hyperdive-map .map-grid .loc-selection .selection-border-2::after{\n  right:0;\n  bottom:0;\n  border-bottom: 1px solid #888;\n  border-right: 1px solid #888;\n}\n\n\n\n.hyperdive-map .map-grid .row .loc-box .loc-mark{\n  position: absolute;\n  left:0;\n  top:0;\n  right:0;\n  bottom:0;\n  overflow: scroll;\n}\n\n.hyperdive-map .map-grid .row .loc-box .dive-level{\n  position: absolute;\n    left:0;\n    top:0;\n    right:0;\n    bottom:0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 20;\n  \n}\n\n\n.hyperdive-map .map-grid .row .loc-box .loc-label{\n  position: absolute;\n    left: 0;\n    top: 60%;\n    bottom:0;\n    right:0;\n    display: flex;\n    align-items: start;\n    justify-content: center;\n    vertical-align: start;\n    opacity: 1;\n    color: var(--main-color);\n    z-index: 100;\n    text-align: center;\n  }\n\n  .hyperdive-map.no-markers .map-grid .row .loc-box .loc-label{\n    opacity: 0;\n  }\n  .hyperdive-map .map-grid .row .loc-box .loc-label.hyperdive-loc-label{\n    top: 70%;\n  }\n  \n\n.loc-box .dive-level .hyperdive-loc{\n    flex:none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex: none;\n    left:20px;\n    width: 26px;\n    height: 26px;\n    z-index: 100;\n    pointer-events: none;\n    color: var(--background-color);\n    background-color: cyan;\n    animation: pulsate 1s infinite ease-in-out;\n  \n    transition-duration: 0.3s;\n    transition-timing-function: ease-in-out;\n    transition-delay: 0ms;\n  \n}\n\n\n.loc-box .dive-level .storm{\n  position: relative;\n  width: 5px;\n  height: 5px;\n  aspect-ratio: 1/1;\n  flex:none;\n  color: #888;\n}\n\n.loc-box .dive-level .storm::before{\n  position: absolute;\n  align-self: center;\n  /*width: calc(30%);*/\n  height: 100%;\n  width: 1px;\n  left: calc(50% - 0.5px);\n  background-color: red;\n  content: '';\n  z-index: 2;\n\n}\n\n.loc-box .dive-level .storm::after{\n  position: absolute;\n  align-self: center;\n  /*width: calc(30%);*/\n  width: 100%;\n  height: 1px;\n  top: calc(50% - 0.5px);\n  background-color: red;\n  content: '';\n  z-index: 2;\n\n}\n\n.loc-box .dive-level .null-sector{\n\n}\n\n\n.loc-box .dive-level .null-sector::before,\n.loc-box .dive-level .null-sector::after{\n    background-color: red;\n}\n\n.loc-box .dive-level .station-loc{\n\n  position: relative;\n  width: 7px;\n  height: 7px;\n  border: 1px solid cyan;\n  rotate: 45deg;\n  border-radius: 1px;\n}\n\n.loc-box .dive-level .station-loc::before{\n  position: absolute;\n  height: 1px;\n  width: 1px;\n  left: calc(50% - 0.5px);\n  top: calc(50% - 0.5px);\n  background-color: cyan;\n  content: '';\n}\n\n.hyperdive-map .team-location{\n  flex:none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n  bottom:220px;\n  left:0;\n  width: 70px;\n  height: 70px;\n  position: absolute;\n  \n  pointer-events: none;\n\n  transition-duration: 0.5s;\n  transition-timing-function: ease-in-out;\n  transition-delay: 0ms;\n}\n\n.team-location .marker{\n  transform: rotate(180deg);\n  height: 31px;\n  width: 31px;\n  margin-top:5px;\n}\n\n.loc-box .dive-level .possible_direction{\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  flex:none;\n  z-index:50;\n  display: flex;\n  flex: none;\n  align-items: center;\n  justify-content: center;\n}\n\n\n.loc-box .dive-level .minerals-loc{\n\n  position: relative;\n  width: 5px;\n  height: 5px;\n  border: 1px dotted var(--main-color);\n  animation: border-pulsate 1s infinite;\n}\n\n@keyframes border-pulsate {\n  0% {\n    border: 1px dotted var(--main-color);\n  }\n\n  50% {\n    border: 1px solid var(--main-color);\n  }\n}\n\n.loc-box .dive-level .minerals-loc::before{\n  position: absolute;\n  height: 1px;\n  width: 1px;\n  left: calc(50% - 0.5px);\n  top: calc(50% - 0.5px);\n  background-color: var(--main-color);\n  content: '';\n}\n\n.loc-box .dive-level .level-0{\n  opacity: 0.1;\n}\n\n.loc-box .dive-level .storm.level-1{\n  opacity: 1;\n}\n\n.loc-box .dive-level .storm.level-2{\n  opacity: 1;\n}\n\n.loc-box .dive-level .storm.level-2::before{\n  background-color: red;\n}\n\n.loc-box .dive-level .storm.level-2::after{\n  background-color: red;\n}\n\n.loc-box .dive-level .only-dot::before{\n  position: absolute;\n  height: 1px;\n  width: 1px;\n  left: calc(50% - 0.5px);\n  top: calc(50% - 0.5px);\n  background-color: var(--main-color);\n  content: '';\n}\n\n.loc-box .dive-level .only-dot::after{\n  display: none;\n}\n\n.loc-box .dive-level .only-dot::before{\n  position: absolute;\n  height: 1px;\n  width: 1px;\n  left: calc(50% - 0.5px);\n  top: calc(50% - 0.5px);\n  background-color: red;\n  content: '';\n}\n\n.loc-box .dive-level .only-dot::after{\n  display: none;\n}\n\n\n.hyperdive-map .map-grid .row .loc-box .dive-level{\n  opacity: 1;\n}\n\n.hyperdive-map .map-grid .row .loc-box .dive-level.level-2{\n  opacity: 1;\n\n}\n.hyperdive-map .map-grid .row .loc-box .dive-level.level-3{\n  opacity: 1;\n}\n\n.loc-box .dive_level.level-3::after{\n  background-color: red;\n  box-shadow: rgba(240, 46, 170, 0.4) 5px 5px, rgba(240, 46, 170, 0.3) 10px 10px, rgba(240, 46, 170, 0.2) 15px 15px, rgba(240, 46, 170, 0.1) 20px 20px, rgba(240, 46, 170, 0.05) 25px 25px;\n}\n.loc-box .dive_level.level-3::before{\n  background-color: red;\n  box-shadow: rgba(240, 46, 170, 0.4) 5px 5px, rgba(240, 46, 170, 0.3) 10px 10px, rgba(240, 46, 170, 0.2) 15px 15px, rgba(240, 46, 170, 0.1) 20px 20px, rgba(240, 46, 170, 0.05) 25px 25px;\n}\n\n.voyage .screen .event-card{\n  z-index: 9;\n  position: absolute;\n\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--2);\n  margin:auto;\n  color: var(--background-color);\n  overflow: hidden;\n  \n  left:calc(50% - 120px);\n  right:calc(50% - 120px);\n  top: calc(30px);\n  \n  bottom: calc(30px);\n  user-select: none ;\n}\n\n.voyage .screen .event-card .event-card-face{\n  width: 100px;\n  height: 150px;\n  flex:none;\n  background-color: red;\n}\n\n.voyage .screen .event-card .event-card-description{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color: #fff;\n  align-self: stretch ;\n  justify-content: center;\n  width: 100%;\n  color: cyan;\n  gap: var(--1);\n}\n\n.voyage .screen .event-card .event-card-description p{\n  max-height: 70px;\n}\n\n.loading-bar{\n  height: 5px;\n  width: 100%;\n  position: relative;\n  border: 1px solid red;\n}\n\n.loading-bar .bar{\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  left:0;\n  transform-origin: left;\n  background-color: red;\n  transition-duration: 1s;\n  transition-timing-function: linear;\n}\n\n\n.cyan-warning .loading-bar{\n  border: 1px solid cyan;\n\n\n}\n\n.cyan-warning .loading-bar .bar{\n  background-color: cyan;\n}\n\n\n.voyage .screen .hyperdive-portal-1,\n  .voyage .screen .hyperdive-portal-2,\n    .voyage .screen .hyperdive-portal-3{\n      position: absolute;\n  left: calc(50% - 50px);\n  top: calc(50% - 50px);\n  width:100px;\n  aspect-ratio: 1/1;\n  transform: rotate(45deg);\n  border-radius: 30px;\n  animation: portal-shrink infinite 1.5s ease-in;\n  opacity: 0;\n  /*background-color: #000;*/\n  border: 1px solid cyan;\n}\n\n.voyage .screen .hyperdive-portal-2{\n  animation-delay: 0.5s;\n}\n\n\n.voyage .screen .hyperdive-portal-3{\n    animation-delay: 1s;\n\n}\n\n\n@keyframes portal-shrink {\n  0% {\n    opacity: 0;\n    transform: scale(2) rotate(45deg);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(0) rotate(45deg);\n  }\n}\n\n\n.voyage .screen .station-description{\n  /*padding-top: 20px;*/\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap:var(--3);\n}\n\n.voyage .screen .station-description .description{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap:0;\n  transition-duration: 0.2s;\n  transition-timing-function: linear;\n}\n\n\n.voyage .screen .station-marker{\n  width:26px;\n  height: 26px;\n  margin: var(--3);\n  border: 1px solid cyan;\n  transform: rotate(45deg);\n  border-radius: 2px;\n}\n\n\n\n.voyage .screen .station-marker::after{\n  content: '';\n  position: absolute;\n  top: var(--1);\n  left: var(--1);\n  right: var(--1);\n  bottom: var(--1);\n  background-color: cyan;\n  animation: pulsate 2s infinite ease-in-out;\n}\n\n.voyage .screen .station-marker-2{\n  width:110px;\n  height: 110px;\n  margin: var(--3);\n  border: 1px solid #888;\n  transform: rotate(45deg);\n  border-radius: 20px;\n  background-color: var(--background-color);\n\n}\n\n.voyage .screen .station-marker-2::after{\n  content: '';\n  position: absolute;\n  top: var(--2);\n  left: var(--2);\n  right: var(--2);\n  bottom: var(--2);\n  transform: translate(-20px,20px);\n  border-left: 1px solid cyan;\n  border-bottom: 1px solid cyan;\n  animation: pulsate 2s infinite ease-in-out;\n  border-radius: 0 22px 0 22px;\n}\n\n.voyage .screen .station-marker-2::before{\n  content: '';\n  position: absolute;\n  top: var(--2);\n  left: var(--2);\n  right: var(--2);\n  bottom: var(--2);\n  transform: translate(20px,-20px);\n  border-right: 1px solid cyan;\n  border-top: 1px solid cyan;\n  animation: pulsate 2s infinite ease-in-out;\n  border-radius: 0 22px 0 22px;\n}\n\n.voyage .screen .player-marker{\n  position: absolute;\n  width: 0px;\n  height: 0px;\n  animation: marker-float-animation 10s ease infinite;\n  z-index: 10;\n  pointer-events: none;\n  user-select: none ;\n\n}\n\n\n.voyage .screen .player-marker .label{\n  position: absolute;\n  left: 50px;\n  bottom: 20px;\n  text-wrap: nowrap;\n  z-index: 10;\n  /*border-left: 1px solid cyan;*/\n  border-bottom: 1px solid transparent;\n  padding-top: 0px;\n  padding-left: var(--2);\n  \n  transition-duration: 0.3s;\n  transition-timing-function: ease-in-out;\n  \n}\n\n\n.voyage .screen .player-marker .label::after123{\n  content: '';\n  position: absolute;\n  left: -15px;\n  bottom: -35px;\n  width: 29px;\n  height: 29px;\n  border-right: 1px solid transparent;\n\n  border-top: 1px solid cyan;\n  transform: rotate(-45deg);\n}\n\n\n.voyage .screen .player-marker .label .extra-label{\n  position: absolute;\n  display: flex;\n  flex: none;\n  top: 0px;\n  left:-140px;\n  width: 130px;\n  justify-content: end;\n  text-align: end;\n  overflow: hidden;\n  background-color: var(--background-color-transparent);\n}\n\n\n.scan-wave{\n  position: absolute;\n  top: -38px;\n  left: -35px;\n  width:100px;\n  opacity: 0;\n  height:100px;\n  border-radius: 50px;\n  border: 1px solid #888;\n  animation: scan-wave-animation 7s linear infinite;\n}\n\n.voyage .screen .player-marker .marker{\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform: rotate(180deg);\n  height: 31px;\n  width: 31px;\n}\n\n.voyage .screen .player-marker .tracer{\n  position: absolute;\n  width: 1px;\n  left: 15px;\n  height: 80px;\n  top: 26px;\n  opacity: 0.5;\n  background: linear-gradient(cyan, transparent, transparent);\n\tbackground-size: 100% 200%;\n  transform-origin: top;\n\n  animation: tracer-flame-animation 2s linear infinite;\n\n}\n\n\n.overfloat-inventory{\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  width: auto;\n  height: auto;\n  z-index: 100;\n  opacity: 0;\n  transition-duration: 0.4s;\n  transition-timing-function: ease;\n  pointer-events:all;\n}\n\n.overfloat-inventory.reveal{\n  opacity: 1;\n}\n\n.overfloat-inventory .inventory-background-circle{\n  position: absolute;\n  left: -85px;\n  top:-87px;\n  width: 200px;\n  height: 200px;\n  z-index: 50;\n  border-radius: 100px;\n  opacity: 0.5;\n  background-color: #000;\n}\n\n.overfloat-inventory .inventory-circle{\n  position: absolute;  \n\n  left: -15px;\n  top:-17px;\n  width: 60px;\n  height: 60px;\n  z-index: 100;\n  border-radius: 0px;\n  border: 1px solid cyan;\n  border-radius: 0 0 4px 4px;\n}\n\n.overfloat-inventory .hull-name{\n  position: absolute;\n  left: -15px;\n  top:-29px;\n  width: 60px;\n  max-width: 60px;\n  z-index: 100;\n  background-color: cyan;\n  color:var(--background-color);\n  text-wrap: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-left: var(--1);\n  border-radius: 4px 4px 0 0;\n}\n\n\n.overfloat-inventory .inventory-list{\n  position: absolute;\n  left: -20px;\n  top:70px;\n  z-index: 100;\n  width:auto;\n  display: flex;\n  flex-direction: column;\n  padding: var(--1);\n}\n\n.module-block-connector{\n  border-top: 1px solid cyan;\n  position: absolute;\n  left: -51px;\n  top: 46px;\n  width: 34px;\n  transform: rotate(-30deg);\n}\n\n\n.crew-block-connector{\n  border-top: 1px solid cyan;\n  position: absolute;\n  right: -81px;\n  bottom: 30px;\n  width: 34px;\n  transform: rotate(-30deg);\n}\n\n\n.overfloat-inventory .inventory-list.module-list{\n  left: -49px;\n  top: 55px;\n  border-left: 1px solid cyan;\n}\n\n.overfloat-inventory .inventory-list.crews-list{\n  left: -50px;\n  top: -95px;\n  text-align: end;\n  border-right: 1px solid cyan;\n}\n\n.overfloat-inventory .inventory-list .list-item{\n  color: cyan;\n  background-color: var(--background-color);\n  text-wrap: nowrap;\n  flex: none;\n  width: 120px;\n  overflow: hidden;\n  background-color: var(--background-color);\n  text-overflow: ellipsis;\n}\n\n.overfloat-inventory .inventory-list .list-item.section-name{\n  background-color: cyan;\n  color: var(--background-color);\n  padding-left: var(--1);\n  padding-right: var(--1);\n}\n\n.player-marker.marker-1{\n  left:calc(50% - 15px);\n  top:calc(50% - 25px);\n}\n\n.marker-main-svg-line{\n  position: absolute;\n  top:0;\n  left:-40px;\n}\n\n\n.player-marker.marker-2{\n  left:calc(65% - 15px);\n  top:calc(50% + 70px);\n}\n\n.player-marker.marker-2,\n.player-marker.marker-2 .scan-wave,\n.player-marker.marker-2 .tracer{\n  animation-delay: 0.5s !important;\n}\n\n.player-marker.marker-3{\n  left:calc(35% - 15px);\n  top:calc(50% + 70px);\n}\n\n\n.player-marker.marker-3,\n.player-marker.marker-3 .scan-wave,\n.player-marker.marker-3 .tracer{\n  animation-delay: 1.5s !important;\n}\n\n\n@keyframes img-float-animation {\n  0% {\n    transform: translate(0, 0);\n  }\n  50% { \n    transform: translate(0px,-10px);\n  }\n  100% { \n    transform: translate(0, 0);\n  }\n}\n\n@keyframes marker-float-animation {\n  0% {\n    transform: translate(0, 0);\n  }\n  20% { \n    transform: translate(-4px,2px);\n  }\n  40% { \n    transform: translate(0px,0px);\n  }\n  50% { \n    transform: translate(2px,2px);\n  }\n  70% { \n    transform: translate(4px,0px);\n  }\n  90% { \n    transform: translate(4px,-2px);\n  }\n\n  100% { \n    transform: translate(0, 0);\n  }\n}\n\n@keyframes scan-wave-animation {\n  0% {\n    transform: scale(0.5);\n    opacity: 1;\n  }\n  10% { \n    transform: scale(2);\n    opacity: 0;\n  }\n  100% { \n    transform: scale(0.5);\n    opacity: 0;\n  }\n}\n\n\n@keyframes tracer-flame-animation {\n  0%{background-position:0% 0%}\n  50%{\n    background-position:0% 0%;\n  }\n  60%{\n    background-position:0% 50%;\n  }\n  70%{\n    background-position:0% 0%;\n  }\n  80%{\n    background-position:0% 40%;\n  }\n\n  100%{background-position:0% 0%}\n}\n\n@keyframes tracer-shift-animation {\n  0%{transform: rotate(0)}\n  40%{\n    background-position:0% 30%;\n    transform: rotate(5deg)\n  }\n  70%{\n    background-position:0% 40%;\n    transform: rotate(-5deg)\n  }\n  90%{\n    background-position:0% 40%;\n    transform: rotate(3deg)\n  }\n\n  100%{transform: rotate(0)}\n}\n\n.voyage .screen .warning-message{\n  z-index: 160;\n  /*position: absolute;\n  left:calc(50% - 100px);\n  top: calc(50% - 30px);\n  top: -10px;*/\n  opacity: 0.8;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: var(--2);\n  width: 200px;\n  margin:auto;\n  pointer-events: none;\n}\n\n.warning-message .red-alarm{\n  background-color: red;\n  color: black;\n}\n\n.top-center-loc-bar{\n  position: absolute;\n  z-index: 20;\n  left:30%;\n  right:30%;\n  top: 0px;\n  border-top: 1px solid var(--background-color);\n  user-select: none ;\n  transition-duration: 0.1s;\n  transition-timing-function: ease-in-out;\n}\n\n.top-center-loc-bar .destination-btn{\n  text-wrap: nowrap;\n}\n\n.top-center-loc-bar .label-bar{\n  width: 100%;\n  text-align: center;\n  border-radius: var(--border-radius);\n  color: #888;\n  padding:var(--2);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-wrap: nowrap;\n  transition-duration: 0.4s;\n  transition-timing-function: ease-in-out;\n}\n\n.top-center-loc-bar .label{  \n  color: #888;\n  transition-duration: 0.4s;\n  transition-timing-function: ease-in-out;\n}\n\n.top-center-loc-bar .position-bar{\n  height: 8px;\n  position: relative;\n  width: calc(100%);\n  border: 1px solid #888;\n  border-top: none;\n  border-radius:  0 0 var(--border-radius) var(--border-radius);\n  transition-duration: 0.4s;\n  transition-timing-function: ease-in-out;\n}\n\n\n/*\n.top-center-loc-bar.active .label-bar,\n.top-center-loc-bar.active .position-bar {\n  border-color: cyan;\n  color: cyan\n}\n*/\n\n.top-center-loc-bar .position-bar .rail-bar{\n  height: 100%;\n  position: relative;\n  width: calc(100%);\n  display: flex;\n  flex-direction: row;\n  gap: var(--1);\n  padding: var(--1);\n}\n\n.top-center-loc-bar .position-bar .rail-bar.danger-1 .danger-mark{\n  background-color: #888;\n}\n\n.top-center-loc-bar .position-bar .rail-bar.danger-2 .danger-mark{\n  background-color: var(--main-color);\n}\n.top-center-loc-bar .position-bar .rail-bar.danger-3 .danger-mark{\n  background-color: var(--main-color);\n  animation: pulsate 2s infinite;\n}\n\n.top-center-loc-bar .position-bar .rail-bar .position-mark{\n  position: absolute;\n  margin: var(--1);\n  height: 100%;\n  height: 4px;\n  max-width: calc(100% - 2* var(--1));\n  top:-6px;\n  left: 0;\n  background-color: cyan;\n  transition-duration: 1s;\n  transition-timing-function: ease-in-out;\n  border-radius: var(--border-radius);\n}\n\n.top-center-loc-bar .position-bar .rail-bar .danger-mark{\n  height: 4px;\n  width: calc((100% - 2 * var(--1))/3);\n  background-color: cyan;\n  transition-duration: 1s;\n  transition-timing-function: ease-in-out;\n  border-radius: var(--border-radius);\n}\n\n.top-center-loc-bar .position-bar .rail-bar .danger-mark.disabled{\n  width: 0;\n}\n\n.voyage .screen-bottom .left-info-bar,\n.voyage .screen-bottom .right-info-bar{\n  position: absolute;\n  z-index: 10;\n  left: 0;\n  top:  0;\n  height: calc(100% - var(--2));\n}\n\n\n.voyage .screen-bottom .right-info-bar{\n  right: 0;\n  left: auto;\n}\n\n\n.voyage .screen-bottom .right-corner-info,\n.voyage .screen-bottom .left-corner-info{\n    position: absolute;\n  z-index: 10;\n  left: calc(4 * var(--2));\n  bottom:  var(--2);\n  color: var(--main-color)\n}\n\n.voyage .screen-bottom .right-corner-info{\n  right: calc(4 * var(--2));\n  left: auto;\n  bottom:  var(--2);\n  top:auto;\n}\n\n\n.altitude-bar{\n  position: relative;\n  display: flex;\n  flex:auto;\n  flex-direction: column;\n  align-items: end;\n  height: calc(100%);\n  justify-content: stretch;\n  border-radius: 0;\n  border: none;\n  width: 8px;\n  border-bottom: 1px solid #888;\n  border-right: 1px solid #888;\n  border-radius: 0 0 4px  0;\n  user-select: none ;\n\n  height: 150px;\n  border-radius: 0 !important;\n  border: 0 !important ;\n}\n\n\n.altitude-bar .full-scale{\n  height: auto;\n  flex: auto;\n  width: calc(100%);\n  border-top: 1px solid #888;\n  position: relative;\n  opacity: 1;  \n\n  transition-duration: 1s;\n  transition-timing-function: ease-in-out;\n\n}\n\n\n.altitude-bar .no-scale{\n  height: auto;\n  flex: auto;\n  width: calc(100%);\n  position: relative;\n}\n\n .altitude-bar .label,\n .altitude-bar .end-label{\n  position: absolute;\n  left: -20px;\n  top: -9px;\n  height: 16px;\n  width: 20px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #888;\n\n  transition-duration: 1s;\n  transition-timing-function: ease-in-out;\n}\n\n\n.altitude-bar .full-scale.highlighted,\n.altitude-bar .empty.highlighted,\n.altitude-bar .end-label.highlighted{\n    opacity: 1\n}\n\n.altitude-bar .end-label{\n  top: auto;\n  bottom: -8px;\n  opacity: 0.5;\n\n  transition-duration: 1s;\n  transition-timing-function: ease-in-out;\n}\n\n\n.altitude-bar.left .label{\n  left: auto;\n  right: -20px;\n}\n\n.altitude-bar.left .end-label{\n  left: auto;\n  right: -20px;\n}\n\n.altitude-bar .half-scale{\n  height: auto;\n  flex: auto;\n  width: calc(60%);\n  border-top: 1px solid #888;\n  position: relative;\n  opacity: 1;\n  margin: calc(20%);\n\n  \n\n  transition-duration: 1s;\n  transition-timing-function: ease-in-out;\n\n}\n.altitude-bar .empty{\n  height: auto;\n  flex: auto;\n  width: calc(100%);\n  position: relative;\n  border-top: 1px solid transparent;\n  opacity: 0.5;\n\n  \n\n  transition-duration: 1s;\n  transition-timing-function: ease-in-out;\n}\n\n\n.altitude-bar .scale-marker{\n  position: absolute;\n  height:0%;\n  width: calc(100%);\n  bottom: 0;\n  left: 0px;\n  opacity: 1;\n  transition-duration: 1s;\n  transition-timing-function: ease-in-out;\n}\n\n.altitude-bar .scale-marker .marker-label{\n  position: absolute;\n  right: 9px;\n  top: -8px;\n  border: 1px solid #888;\n  height: 16px;\n  padding-right: 15px;\n  border-radius: 2px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n}\n\n.altitude-bar .scale-marker .marker-label small{\n  height: calc(100%);\n  background-color: #888;\n  color: var(--background-color);\n  padding-left: var(--1);\n  padding-right: var(--1);\n  vertical-align: center;\n}\n\n.altitude-bar.left .scale-marker .marker-label{\n  right: auto;\n  text-align: left;\n  left: 9px;\n  padding-left: 15px;\n  padding-right: 0;\n}\n\n.altitude-bar .scale-marker .marker-label.negative1{\n  border-color: white;\n}\n.altitude-bar .scale-marker .marker-label.negative1 small{\n  background-color: white;\n}\n\n\n.altitude-bar.left{\n  border-left: 1px solid #888;\n  border-right: none;\n  align-items: start;\n  border-radius: 0 0 0 4px;\n}\n\n\n\n.voyage .screen-bottom .stat-bar{\n  flex:auto;\n  flex-direction: column;\n  align-items: start;\n  height: calc(100%);\n  border-radius: 0;\n  border: none;\n  border-bottom: 1px solid var(--main-color);\n}\n\n.voyage .screen-bottom .stat-bar .full,\n.voyage .screen-bottom .stat-bar .empty{\n  width:auto;\n  border: none;\n  border-bottom: 1px solid var(--main-color);\n  border-left: 1px solid var(--main-color);\n  flex:auto;\n  width: 6px;\n}\n\n\n\n.voyage .screen-bottom .stat-bar .full{\n  position: relative;\n  width: 10px;\n}\n\n.voyage .screen-bottom .right-info-bar .stat-bar{\n  align-items: end;\n}\n\n.voyage .screen-bottom .left-info-bar .stat-bar .full,\n.voyage .screen-bottom .left-info-bar .stat-bar .empty{\n  border: none;\n  border-top: 1px solid var(--main-color);\n  border-left: 1px solid var(--main-color);\n}\n\n.voyage .screen-bottom .left-info-bar .stat-bar .full::afterzz,\n.voyage .screen-bottom .right-info-bar .stat-bar .full::afterzz{\n  position: absolute;\n  top: -1px;\n  bottom: -1px;\n  left:-1px;\n  right: 50%;\n  content: '';\n  border-top: 2px solid var(--background-color);\n}\n\n.voyage .screen-bottom .right-info-bar .stat-bar .full::afterzz{\n  right:-1px;\n  left: 50%;\n  border-right: 1px solid var(--background-color);\n}\n\n\n.voyage .screen-bottom .right-info-bar .stat-bar .full,\n.voyage .screen-bottom .right-info-bar .stat-bar .empty{\n  border: none;\n  border-top: 1px solid var(--main-color);\n  border-right: 1px solid var(--main-color);\n}\n\n.voyage .screen-bottom .title{\n  background-color: #888;\n  width:100%;\n}\n\n.voyage .content{\n  position: absolute;\n  z-index: 10;\n  left: 100px;\n  right: 0px;\n  top: 0px;\n  bottom: 0px;\n}\n\n\n.voyage-stats-list{\n  min-width: 150px;\n  color: var(--main-color);\n  flex:none;\n  display: flex;\n  flex-direction: column;\n}\n\n.voyage-stats-list.right{\n  text-align: right;\n  justify-content: end;\n  align-items: end;\n}\n\n.voyage-stats-list .positive-stat{\n  color: cyan;\n}\n\n\n.voyage-stats-list .negative-stat{\n  color: red;\n}\n\n\n\n.voyage-stats-list .stat{\n  position: relative;\n  text-wrap: nowrap;\n  white-space: nowrap;\n}\n\n\n.voyage-stats-list .stat.short-wrapable{\n  width: 70%;\n  text-wrap:wrap ;\n  white-space: wrap;\n}\n\n.voyage-stats-list.cut-content{\n  gap:var(--1);\n}\n\n.voyage-stats-list.cut-content .stat{\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: var(--main-color);\n  width: 100%;\n}\n\n.voyage-stats-list.cut-content .stat:hover{\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: auto;\n  color: #fff;\n}\n\n/*\n.voyage-stats-list .stat .delta-stat{\n  position: absolute;\n  right: 0px;\n  top: 0px;\n  background-color: var(--background-color);\n}\n\n.voyage-stats-list.right .stat .delta-stat{\n  right: auto;\n  left: 0px;\n}\n*/\n\n\n\n.stat-bar{\n  display: flex;\n  flex-direction: row;\n  gap: 0px;\n  align-items: start;\n  align-self: flex-start;\n  width: fit-content;\n  flex:none;\n  overflow: hidden;\n  flex-wrap: nowrap;\n  border-bottom: 1px solid var(--main-color);\n}\n\n\n.stat-bar .full,\n.stat-bar .empty{\n  height:3px;\n  width:16px;\n  flex:none;\n\n  background-color: var(--main-color);\n}\n.stat-bar .empty{\n  background-color: transparent;\n  border-right: 1px solid var(--main-color);\n}\n\n\n.voyage .screen-bottom .group-window .steps-bottom-stats{\n  z-index: 100;\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  padding: var(--2);\n  padding-top: 0px;\n  gap: var(--1);\n  left:0;\n  bottom: -25px;\n  width: 800px;\n}\n\n\n.voyage .screen-bottom .group-window .steps-bottom-stats .text-stats{\n  z-index: 100;\n  position: absolute;\n  padding: var(--2);\n  gap: var(--1);\n  top:5px;\n  left: 0px;\n  color: var(--secondary-color); \n  width: var(--group-window-size);\n}\n\n\n.group-window .steps-bottom-stats .stat-bar{\n  flex:auto;\n  width: calc(var(--group-window-size) - 2 * var(--2) - 2px);\n  border-radius: 0;\n  border: none;\n}\n\n.group-window .steps-bottom-stats .stat-bar .full,\n.group-window .steps-bottom-stats .stat-bar .empty{\n  width:auto;\n  border: none;\n  border-top: 1px solid var(--main-color);\n  border-right: 1px solid var(--main-color);\n  flex:auto;\n  height: 6px;\n}\n\n.group-window .steps-bottom-stats .stat-bar .full{\n  height: 10px;\n}\n\n\n\n.voyage .screen-bottom .group-window .layer-left-stats{\n  z-index: 100;\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  padding: var(--2);\n  padding-top: 0px;\n  gap: var(--1);\n  left:0;\n  bottom: 0;\n}\n\n.voyage .screen-bottom .group-window .layer-left-stats .text-stats{\n  z-index: 100;\n  position: absolute;\n  gap: var(--1);\n  right:-35px;\n  top:35px;\n  color: var(--secondary-color); \n  width: var(--group-window-size);\n  transform: rotate(-90deg);\n}\n\n\n.group-window .layer-left-stats .stat-bar{\n  flex:auto;\n  flex-direction: column;\n  align-items: end;\n  height: calc(100%);\n  border-radius: 0;\n  border: none;\n}\n\n.group-window .layer-left-stats .stat-bar .full,\n.group-window .layer-left-stats .stat-bar .empty{\n  width:auto;\n  border: none;\n  border-top: 1px solid var(--main-color);\n  border-right: 1px solid var(--main-color);\n  flex:auto;\n  width: 6px;\n}\n\n.group-window .layer-left-stats .stat-bar .full{\n  width: 10px;\n}\n\n\n.voyage .stats-passive{\n  position: absolute;\n  z-index: 10;\n  bottom:  var(--2);\n  width: auto;\n  right: var(--2);\n  padding: var(--2);\n  color: var(--main-color);\n}\n\n\n.cross-background-old {\n  position: absolute;\n  left: 0px;\n  right: 0px;\n  top: 0px;\n  aspect-ratio: 1/1;\n  z-index: 1;\n  background: \n  radial-gradient(circle, transparent 10%, var(--background-color) 10%),\n  linear-gradient(0deg, transparent 49.5%, var(--main-color) 49.5%, var(--main-color) 50.5%, transparent 50.5%), \n  linear-gradient(90deg, transparent 49.5%, var(--main-color) 49.5%, var(--main-color) 50.5%, transparent 50.5%);\n  background-size: 37px 37px;\n  opacity: 0.5;\n}\n\n.cross-background{\n  position: absolute;\n  left: 0px;\n  right: 0px;\n  top: 0px;\n  bottom: 0;\n  z-index: 1;\n\n  background-color: #e5e5f7;\n  opacity: 0.3;\n  background: radial-gradient(circle, transparent 20%, var(--background-color) 20%,var(--background-color) 80%, transparent 80%, transparent), \n  radial-gradient(circle, transparent 20%, var(--background-color) 20%,var(--background-color) 80%, transparent 80%, transparent) 40px 40px, \n  linear-gradient(#888 2px, transparent 2px) 0 -1px,\n  linear-gradient(90deg, #888 2px, var(--background-color) 2px) -1px 0;\n  background-size: 80px 80px, 80px 80px, 40px 40px, 40px 40px;\n}\n\n.dotted-cross-background {\n  position: absolute;\n  left: -100px;\n  right: -60px;\n  top: -60px;\n  bottom: -60px;\n  z-index: 1;\n  background: \n  radial-gradient(circle, transparent 2.5%, var(--background-color) 2.5%),\n  linear-gradient(0deg, transparent 49.5%, var(--secondary-color) 49.5%, var(--secondary-color) 50.5%, transparent 50.5%), \n  linear-gradient(90deg, transparent 49.5%, var(--secondary-color) 49.5%, var(--secondary-color) 50.5%, transparent 50.5%);\n  background-size: 73px 73px;\n}\n\n.cross-background-shift-far{\n  opacity: 1;\n  animation: cross-background-shift-animation-far 10s linear infinite;\n}\n.background-canvas-shift{\n  opacity: 1;\n  animation: background-canvas-shift-animation 140s linear infinite;\n}\n\n.background-canvas-shift-close{\n  opacity: 1;\n  animation: background-canvas-shift-animation 60s linear infinite;\n}\n\n.background-canvas-shift-far{\n  opacity: 1;\n  animation: background-canvas-shift-animation 200s linear infinite;\n}\n\n.cross-background-shift{\n  opacity: 0.5;\n  background-size: 101px 101px;\n  animation: cross-background-shift-animation 4s linear infinite;\n}\n\n@keyframes background-canvas-shift-animation {\n  0% {\n    transform: translate(0, 0);\n  }\n  100% { \n    transform: translate(0,100%);\n  }\n}\n\n\n@keyframes cross-background-shift-animation-far {\n  0% {\n    transform: translate(0, 0);\n  }\n  100% { \n    transform: translate(0,73px);\n  }\n}\n\n@keyframes cross-background-shift-animation {\n  0% {\n    transform: translate(0, 0);\n  }\n  100% { \n    transform: translate(0,101px);\n  }\n}\n\n\n.ui-window{\n  z-index: 10;\n  position: relative;\n  width: calc(100%);\n  flex:none;\n  height: auto;\n  display: flex;\n  gap: 0;\n\n  border: 1px solid #888;\n  border-radius: var(--border-radius);\n  overflow: hidden;\n\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: start;\n  justify-content: space-evenly;\n  gap:var(--3);\n  max-width: 800px;\n  border-radius: 10px;\n}\n\n.ui-window-title{\n  z-index: 100;\n  display: flex;\n  flex-direction: row;\n  width: calc(100%);\n  justify-content: space-between;\n  flex:none;\n  color: var(--background-color);\n  background-color: #888;\n  padding-left:var(--2);\n  padding-right:var(--2);\n  padding: var(--2);\n}\n\n\n.tabs{\n  width: calc(100%);\n  display: flex;\n  flex-direction: row;\n  gap: 0;\n  border-bottom: 1px solid #888;\n}\n\n.tabs .tab{\n  padding: var(--2);\n  padding-left: var(--4);\n  padding-right: var(--4);\n  text-align: center;\n  color: #888;\n  margin-bottom: -1px;\n}\n\n.tabs .tab.active{\n  color: var(--main-color);\n  border-bottom: 1px solid var(--main-color);\n}\n\n.journal{\n\n  z-index: 9;\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  width: calc(100%);\n\n  color: var(--main-color);\n\n  padding: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n\n  max-height: calc(100%);\n  overflow: hidden;\n  background-color: var(--background-color-transparent);\n}\n\n.journal .events{\n  width: calc(100%);\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  gap: var(--3);\n  flex-direction: column-reverse;\n  height: auto;\n  overflow-y: scroll;\n  padding: var(--1);\n  padding-bottom: var(--3);\n  padding-top: var(--3);\n  \n}\n\n\n.journal .events::before {\n  position: absolute;\n  content: \"\";\n  top: 0;\n  left: var(--2);\n  right: var(--2);\n  height: 16px;  \n  border-bottom: none;\n  pointer-events: none;\n  z-index: 100;\n  /*border: 1px solid red;*/\n  background: linear-gradient(var(--background-color), transparent);\n}\n\n.journal .events::after {\n  position: absolute;\n  content: \"\";\n  bottom: 0;\n  left: var(--2);\n  right: var(--2);\n  height: 16px;  \n  border-bottom: none;\n  pointer-events: none;\n  z-index: 100;\n  background: linear-gradient(transparent, var(--background-color));\n}\n\n\n.journal .hidden-closing-btn{\n  width: 100%;\n  height: 450px;\n  content: '';\n  position: absolute;\n  top: -450px;\n  background-color: transparent;\n  \n}\n\n.journal.hidden {\n  transform: translateY(calc(100%));\n}\n\n\n.journal .event{\n  z-index: 10;\n  position: relative;\n  width: calc(100%);\n  flex:none;\n  text-wrap: balance;\n  height: auto;\n  color: #fff;\n  border-left: 1px solid #888;\n  padding-left: var(--2);\n}\n\n.journal .event.answer{\n  text-align: right;\n  border: none;\n  padding-right: var(--2);\n  color: var(--main-color);\n  border-right: 1px solid var(--main-color);\n}\n\n.journal .event.answer.inactive{\n  color: #888;\n  border-right: 1px solid #888;\n}\n\n\n/*\n.journal .event .description{\n  display: flex;\n  flex-direction: column;\n  gap: var(--3);\n  width: calc(100%);\n  height: calc(100%);\n  overflow: scroll;\n  opacity: 1;\n  flex:none;\n  color: #fff;\n  flex-direction: column-reverse\n}\n*/\n.journal .event.description-appear{\n  animation: description-appear 1s ease-in-out;\n  overflow: hidden;\n  max-height: 400px;\n\n}\n\n.journal .event-title,\n.journal .event-note{\n  width: calc(100%);\n  color: var(--main-color);\n  text-align: start;\n  padding-left: var(--2);\n  border-left: 1px solid #888;\n  padding-bottom: var(--2);\n  margin-bottom: calc(-1 * var(--3));\n  text-transform: uppercase;\n}\n\n\n.journal .event-note{\n  text-transform: none;\n  border: none;\n}\n\n.journal .options-list{\n  animation: description-appear 1s ease-in-out;\n  overflow: hidden;\n  max-height: 400px;\n}\n\n\n@keyframes description-appear {\n  0% {\n    max-height: 0;\n  }\n  80% {\n    max-height: 300px;\n  }\n  100% {\n    max-height: 400px;\n  }\n}\n\n\n.journal .options-list .options-list-break{\n  margin: 30px;\n  height: 1px;\n  width: calc(100% - 2* 30px);\n}\n\n.journal .event .title{\n  display: flex;\n  flex-direction: row;\n  width: calc(100%);\n  justify-content: space-between;\n  flex:auto;\n  color: var(--background-color);\n  background-color: #888;\n  padding-left:var(--2);\n  padding-right:var(--2);\n  padding: var(--2);\n\n}\n\n\n.journal.hidden .hidden-closing-btn{\n  display: none;\n}\n\n\n\n.background-document{\n  background: radial-gradient(ellipse at bottom right,var(--secondary-color), var(--main-color) );\n}\n\n.event-options{\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  width: calc(100%);\n  align-items: center;\n  flex: none;\n    \n  \n  transition-duration: 1s;\n  transition-timing-function: ease-in-out;\n}\n\n.event-options .options-list{\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  flex: auto;\n  align-self: stretch;\n  justify-content: center;\n  margin-right: 0px;\n\n}\n\n.event-options .options-list .option{\n  display: flex;\n  flex-direction: column;\n  text-align: start;\n  cursor: pointer;\n  margin: 0px;  \n  text-align: left;\n  color: #888;\n  padding: var(--2);\n  border-right: 1px solid #888;\n\n}\n\n.event-options .options-list .option.disabled-option{\n  opacity: 0.5;\n  margin: 0px;  \n  border-right: 1px solid red;\n  margin-right: 0px;\n}\n\n.event-options .options-list .option.disabled-option .requirements{\n  color: red !important;\n}\n\n.event-options .options-list .option.disabled-option .title{\n}\n\n.event-options .options-list .option:active{\n  margin: 0px;  \n  margin-right: 0px;\n  /*box-shadow: 1px 1px #009999; \n\n  border: 1px solid cyan;*/\n  border-right: 1px solid #fff;\n  color: #fff;\n\n}\n\n\n\n .event-options .options-list .option:active .title{\n  /*background-color: cyan !important;*/\n  color: #888;\n  \n}\n\n\n.event-options .options-list .option:active .cost,\n.event-options .options-list .option:active .requirements{\n  color: #888;\n}\n\n\n.event-options .options-list .option.selected{\n  margin: 0px;  \n  margin-right: 0px;\n  /*box-shadow: 1px 1px #009999; \n\n  border: 1px solid cyan;*/\n  border-right: 1px solid var(--main-color);\n}\n\n.event-options .options-list .option.selected .title{\n  /*background-color: cyan !important;*/\n  /*background-color:  var(--main-color)!important;*/\n  color: var(--main-color);\n  \n}\n\n\n.event-options .options-list .option.selected .cost,\n.event-options .options-list .option.selected .requirements{\n  color: #fff;\n}\n\n\n.option .title{\n  text-wrap: nowrap;\n  vertical-align: middle;\n}\n\n\n\n.option .option-body{\n  width: calc(100%);\n  color: #888;\n}\n\n.option .cost{\n  width: calc(100%);\n  color: #888;\n}\n\n.option .requirements{\n  width: calc(100%);\n  color: #888;\n}\n\n\n.journal .accept-btn{\n  display: flex;\n  flex-direction: row;\n  border: 1px solid var(--main-color);\n  border-top: 1px solid var(--background-color);\n  background-color: var(--background-color);\n  margin-top: -1px;\n  overflow: hidden;\n  padding: var(--2);\n  width: 150px;\n  border-radius: 0 0 var(--border-radius) var(--border-radius);\n  justify-content: center;\n}\n\n.voyage .accept-btn:hover{\n  background-color: var(--main-color);\n  color: var(--background-color);\n  border: 1px solid var(--main-color);\n\n}\n\n.voyage .accept-btn:active{\n  background-color: #fff;\n  border: 1px solid #fff;\n  color: var(--background-color)\n}\n\n\n.journal .bottom-panel{\n\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  gap: var(--2);\n  width: calc(100%);\n  justify-content: space-between;\n  align-items: center;\n  border-top:1px solid var(--main-color);\n}\n\n.journal .bottom-panel .calculation{\n  width: calc(100%);\n  max-height: 32px;\n  color: white;\n  padding: var(--2);\n  text-overflow: ellipsis;\n  white-space:nowrap;\n  text-wrap: nowrap;\n  overflow: hidden;\n}\n\n.journal .btn{\n  /*border-radius: 0;*/\n  height: 32px;\n  justify-content: space-between;\n  display: flex;\n  flex-direction: row;\n  text-overflow: ellipsis;\n  align-items: center;\n  gap: var(--2);\n  white-space:nowrap;\n  text-wrap: nowrap;\n  overflow: hidden;\n  background-color: var(--background-color);\n  color: #fff;\n  border: 1px solid #fff;\n}\n\n.journal .btn:active{\n  background-color: var(--secondary-color);\n\n}\n\n.journal .order-btn.inactive{\n  color: black;\n}\n\n.journal .next-target-btn{\n  border: 1px solid var(--background-color) ;\n  color: var(--background-color);\n}\n\n\n\n\n.card-roulette{\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin:20px;\n}\n\n.card-roulette .warp-card{\n  position: relative;\n  width:320px;\n  /*aspect-ratio: 1 / 2;*/\n  height:600px;\n  flex:none;\n  display: flex;\n  flex-direction: column;\n}\n\n\n\n.warp-card .card-back{\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  transform-style: preserve-3d;\n  transform-origin: center right;\n  transition: transform 1s;\n  backface-visibility: hidden;\n\n  box-shadow: 2px 2px 20px 1px rgba(0, 0, 0, 1);  \n  border: 2px solid var(--main-color);\n  border-radius: 20px;\n  background: #2E2E52;\n \n  /*--dot-bg: #2E2E52;\n\n  --dot-color: var(--secondary-color);\n  --dot-size: 2px;\n  --dot-space: 76px;\n\tbackground:\n\t\tlinear-gradient(90deg, var(--dot-bg) calc(var(--dot-space) - var(--dot-size)), transparent 1%) center / var(--dot-space) var(--dot-space),\n\t\tlinear-gradient(var(--dot-bg) calc(var(--dot-space) - var(--dot-size)), transparent 1%) center / var(--dot-space) var(--dot-space),\n\t\tvar(--dot-color);*/\n}\n\n.dotted-background{\n  --dot-bg: var(--background-color);\n\n  --dot-color: var(--secondary-color);\n  --dot-size: 1px;\n  --dot-space: 18px;\n  background-position: center center ;\n\tbackground:\n\t\tlinear-gradient(90deg, var(--dot-bg) calc(var(--dot-space) - var(--dot-size)), transparent 1%) center / var(--dot-space) var(--dot-space),\n\t\tlinear-gradient(var(--dot-bg) calc(var(--dot-space) - var(--dot-size)), transparent 1%) center / var(--dot-space) var(--dot-space),\n\t\tvar(--dot-color);\n}\n\n\n.warp-card .card-back img{\n\n  width:100%;\n  height:100%;\n  object-fit: cover;\n}\n\n.warp-card .card-back .moon{\n  width: 200px;\n  position: relative;\n  aspect-ratio: 1/1;\n  background-color: var(--secondary-color);\n  border-radius: 100px;\n  flex:none;\n  align-self: center;\n}\n\n.warp-card .card-back .moon::after{\n  position: absolute;\n  width: 150px;\n  top:25px;\n  right:-3px;\n  aspect-ratio: 1/1;\n  background-color:  #2E2E52;\n  border-radius: 75px;\n  flex:none;\n  align-self: center;\n    content: \"\";\n}\n\n.warp-card .card-back .diamond1{\n  width: 40px;\n  position: absolute;\n  right:125px;\n  top:50px;\n  aspect-ratio: 1/1;\n  background-color: var(--secondary-color);\n  transform: scaleX(0.5) rotate(45deg);\n}\n\n.warp-card .card-back .diamond2{\n  width: 40px;\n  position: absolute;\n  right:125px;\n  bottom:50px;\n  aspect-ratio: 1/1;\n\n  background-color: var(--secondary-color);\n  transform: scaleX(0.5) rotate(45deg);\n}\n\n\n.warp-card .is-flipped {\n  transform: translateX(-100%) rotateY(-180deg);\n}\n\n\n.warp-card .card-face{\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: start;\n  cursor: pointer;\n  transform-style: preserve-3d;\n  transform-origin: center right;\n  transition: transform 1s;\n  backface-visibility: hidden;\n  box-shadow: 2px 2px 20px 1px rgba(0, 0, 0, 1);  \n  border: 1px solid var(--main-color);\n  border-radius: 20px;\n  background: #2E2E52;\n\n}\n\n.warp-card .card-face .header{\n  width: 100%;\n  padding: 10px;\n  padding-left: 20px;\n  padding-right: 20px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--main-color);\n  backface-visibility: hidden;\n  position: relative;\n}\n\n.warp-card .card-face .header::before{\n  content: \"\";\n  position: absolute;\n  bottom:-11px;\n  right:10px;\n  background: #2E2E52;\n  width: 70px;\n  height:10px;\n  border: 1px solid var(--main-color);\n  border-top: 0px solid var(--main-color);\n  border-radius: 0px 0px 10px 10px;\n  z-index: 10;\n}\n\n.warp-card .card-face .pic{\n  position: relative;\n  width: 100%;\n  height: 200px;\n  border-bottom: 1px solid var(--main-color);\n  overflow: hidden;\n  flex:none;\n  backface-visibility: hidden;\n}\n\n.warp-card .card-face .pic img{\n  width:100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: 10;\n}\n\n.warp-card .card-face .description{\n  display: flex;\n  backface-visibility: hidden;\n  flex: auto;\n  align-self: stretch;\n  flex-direction: column;\n  justify-content: start;\n  align-items: start;\n  width: 100%;\n  padding: 10px;\n  gap:5px;\n  min-height: 150px;\n  font-weight: 200;\n  line-height: 30px;\n  overflow: scroll;\n}\n\n.voyage .answers-section{\n  position: relative;\n  width:300px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px;\n  gap:30px;\n  border-radius: 10px;\n}\n\n.voyage .answers-section .answers{\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  align-items: start;\n  width: 100%;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  gap:10px;\n}\n\n.voyage .answers-section .answers .answer{\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  align-items: start;\n  width: 100%;\n  padding: 10px;\n  border: 1px solid var(--main-color);\n  border-radius: 20px;\n  gap:5px;\n  background: #2E2E52;\n}\n\n.voyage .answers-section .answer:before {\n  content: ;\n  position:absolute;\n  top:-40px;\n  left:0;\n  height:40px;\n  width: 40px;\n  border-bottom-left-radius: 50%;\n  background:#000;\n  box-shadow: 0 20px 0 0 #522d5b;\n}\n\n.voyage .answers-section .answers .answer:hover{\n  color:#000;\n  background-color: var(--main-color);\n}\n\n.voyage .answers-section .answers .answer:active{\n  color:#000;\n  background-color: #fff;\n}\n\n.voyage .answers-section .group-stats{\n\n}\n\n.on-graph-stats{\n  /*background-color: rgba(0, 0, 0, 0.7);*/\n  color: white;\n  flex-wrap: none;\n  text-wrap: nowrap;\n  margin-left:15px;\n  height: 16px;\n  margin-top:-12px;\n}\n\n.waiting-room{\n  display: flex;\n  color: var(--main-color);\n  flex-direction: column;\n  gap:0px;\n  /*max-width: 800px;\n  margin:auto*/\n  overflow-y: hidden;\n}\n\n.auto-chat{\n  display: flex;\n  height: 300px;\n  max-height: 300px;\n  flex-direction: column;\n  gap: 10px;\n  width: 300px;\n  overflow-y: scroll;\n  padding-top:10px;\n}\n.auto-chat .chat-message{\n  padding: 10px;\n}\n\n.auto-chat .chat-message.primary{\n  color:var(--main-color);\n  border-left: 2px solid var(--main-color);\n}\n\n.auto-chat .chat-message.secondary{\n  color:#888;\n  border-left: 2px solid #888;\n}\n\n.auto-chat .chat-message.warning{\n  color:red;\n  border-left: 2px solid red;\n}\n\n.waiting-room .header{\n  margin-top: 30px;\n  display: flex;\n  flex-direction: row;\n  text-align: center;\n  width: 300px;\n  height: 50px;\n  align-items: center;\n  padding: 20px;\n  justify-content: center;\n  background-color:var(--main-color);\n  color:#000;\n}\n\n.waiting-room .header.inactive{\n  border: 1px solid var(--main-color);\n  background-color:transparent;\n  color:var(--main-color);\n}\n\n.waiting-room .btns-section{\n  display: flex;\n  height: 300px;\n  max-height: 300px;\n  flex-direction: column;\n  gap: 10px;\n  width: 300px;\n  padding: 10px;\n  overflow-y: scroll;\n  align-items: center;\n}\n\n.pulsate{\n  animation: pulsate 1.5s infinite;\n}\n\n.blink{\n  animation: pulsate 0.5s infinite;\n}\n\n.pulsate-once{\n  animation: pulsate-once 1s;\n}\n\n.pulsate-once-fast{\n  animation: pulsate-once 0.3s;\n}\n\n\n.hide-after-animation{\n  animation: hide 3s ease-out;\n  opacity: 0;\n  pointer-events: none;\n}\n\n@keyframes hide {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n.radar-indicator{\n  position: relative;\n  color: var(--main-color);\n  padding-left: 24px;\n  margin-top:-12px;\n  cursor: 'default'; \n  display: flex;\n  gap:2px;\n  flex:none;\n  align-items: start;\n  flex-direction: column;\n} \n\n\n.radar-indicator .row{\n  max-width: 200px; \n  min-width: 40px;\n  padding:0px;\n  text-wrap: nowrap;\n  flex-wrap: none;\n  line-height: 12px;\n  max-height: 12px;\n\n  overflow: hidden;\n  opacity: 0.8;\n  flex:none;\n}\n\n.radar-indicator .row.highlight{\n  padding-left: 2px;\n  padding-right: 2px;\n\n}\n\n.radar-animation-indicator {\n  position: relative;\n  color: var(--main-color);\n  padding-left: 14px;\n  margin-top:-11px;\n  cursor: 'default'; \n  display: flex;\n  gap:2px;\n  flex:none;\n  align-items: start;\n  flex-direction: column;\n  pointer-events: none;\n}\n\n.radar-animation-indicator .jets-marker{\n  left: -6px;\n  top:6px;\n  position: absolute;\n  width: 12px;\n  height: 12px;\n  border: 4px dotted #fff;\n}\n\n.radar-animation-indicator .jets-marker.red{\n  border: 4px dotted red;\n}\n\n.radar-animation-indicator .jets-marker.cyan{\n  border: 4px dotted cyan;\n}\n\n\n.triangle{\n\tcontent:'';\n\tposition:relative;\n  left: -17px;\n  top:-8px;\n\twidth:0px;\n\theight:0px;\n\tborder-left: 4px solid transparent;\n\tborder-right: 4px solid transparent;\n\tborder-bottom: 7px solid cyan;\n  transform: rotate(180deg);\n}\n\n.triangle::before{\n\tcontent:'';\n\tposition:absolute;\n\tdisplay:block;\n\tborder-left: 4px solid transparent;\n\tborder-right: 4px solid transparent;\n\tborder-bottom: 7px solid cyan;\n\ttop:9px;\n\tleft:-9px;\n}\n\n.triangle::after{\n\tcontent:'';\n\tposition:absolute;\n\tdisplay:block;\n\tborder-left: 4px solid transparent;\n\tborder-right: 4px solid transparent;\n\tborder-bottom: 7px solid cyan;\n\ttop:9px;\n  left:1px;\n}\n\n.triangle.red,\n.triangle.red::after,\n.triangle.red::before{\n\tborder-bottom: 7px solid red;\n}\n\n\n.radar-animation-indicator .rocket-aim-styler{\n  left: -12px;\n  top:0px;\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  border: 1px solid #888;\n}\n\n\n.radar-animation-indicator .heat-trap-animation{\n  left: -12px;\n  top:0px;\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  animation-delay: 0ms;\n  align-items: center;\n  transform:  scale(1);\n  opacity: 0.8;\n  text-align: center;\n  color: #fff;\n  border: 1px solid #fff;\n}\n\n.radar-animation-indicator .heat-trap-animation{\n  animation: heat-trap 0.6s infinite;\n}\n\n.radar-animation-indicator .heat-trap-animation.red-marker{\n  animation: heat-trap-red 0.6s infinite;\n}\n\n\n@keyframes heat-trap{\n  0%, 50%, 100%{\n    color: #fff;\n    border: 1px solid #fff;\n    transform: none;\n  }\n  30%{\n    border: 1px solid cyan;\n    transform: scew(15deg, 15deg);\n    color: cyan;\n  }\n\n}\n\n@keyframes heat-trap-red{\n  0%, 50%, 100%{\n    color: #fff;\n    border: 1px solid #fff;\n    transform: none;\n  }\n  30%{\n    border: 1px solid red;\n    transform: scew(15deg, 15deg);\n    color: red;\n  }\n\n}\n\n.radar-animation-indicator .ew-pulse-animation{\n  left: -20px;\n  top:-8px;\n  position: absolute;\n  width: 40px;\n  height: 40px;\n  background: radial-gradient(transparent, var(--background-color));\n  animation: ew-pulse 1s infinite;\n  border-radius: 20px;\n}\n\n@keyframes ew-pulse{\n  0%{\n    opacity: 1;\n    transform: scale(1);\n  }\n  100%{\n    opacity: 2;\n    transform: scale(10);\n  }\n}\n\n.radar-animation-indicator .ew-animation{\n  left: -20px;\n  top:-8px;\n  position: absolute;\n  width: 40px;\n  height: 40px;\n  opacity: 0.8;\n  border: 1px solid #888;\n}\n\n\n\n.radar-animation-indicator .ew-animation::after{\n  content: '';\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border: 1px solid red;\n  animation: ew-glitch 0.3s infinite;\n  animation-delay: 0ms;\n}\n\n.radar-animation-indicator .ew-animation::before{\n  content: '';\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border: 1px solid cyan;\n  animation: ew-glitch2 0.4s infinite;\n  animation-delay: 130ms;\n}\n\n@keyframes ew-glitch{\n  0%, 100%{\n    top: 0px;\n    left: 0;\n    opacity: 1;\n  }\n  20%{\n    top: 0;\n    left: -5px;\n    opacity: 0.7;\n    transform: scew(-15deg, -15deg);\n    background-color: var(--background-color);\n  }\n  40%{\n    top: 3px;\n    left: 0;\n    opacity: 0.2;\n  }\n  60%{\n    top: 0;\n    left: 7px;\n    opacity: 0.3;\n  }\n  80%{\n    top: 0;\n    left: 3;\n    opacity: 0.9;\n    transform: scew(15deg, 15deg);\n  }\n}\n\n@keyframes ew-glitch2{\n  0%{\n    top: 0;\n    left: -10px;\n    opacity: 0.7;\n    transform: scew(-15deg, -15deg);\n  }\n  20%, 100%{\n    top: 0px;\n    left: 0;\n    opacity: 1;\n  }\n  60%{\n    top: -7px;\n    left: 0;\n    opacity: 0.2;\n    transform: scew(35deg, 15deg);\n  }\n  80%{\n    top: 0;\n    left: -5px;\n    opacity: 0.3;\n    transform: scew(15deg, 15deg);\n  }\n  40%{\n    top: 0;\n    left: 0;\n    opacity: 0.9;\n  }\n}\n\n\n.rocket-aim-styler.red{\n  border: 1px solid red;\n}\n\n.rocket-aim-styler.cyan{\n  border: 1px solid cyan;\n}\n\n.station-radar-indicator{\n  color: var(--main-color);\n  padding-left: 0px;\n  height:0px;\n  cursor: 'default'; \n  display: flex;\n  gap:2px;\n  flex:none;\n  align-items: start;\n  flex-direction: column;\n  position: relative;\n  z-index: 10;\n} \n\n.station-radar-indicator .row{\n  position: absolute;\n  padding:0px;\n  text-wrap: nowrap;\n  line-height: 12px;\n  max-height: 12px;\n  left: 0px;\n  width: 2px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: end;\n  text-align: center;\n  flex:none;\n  top: -155px;\n  opacity: 0.5;\n  color: #fff;\n  z-index: 10;\n}\n.station-radar-indicator .row small{\n  text-wrap: nowrap;\n}\n\n.station-radar-indicator .indicators-column{\n  position: absolute;\n  padding:0px;\n  line-height: 12px;\n  left: 6px;\n  display: flex;\n  flex-direction: column;\n  flex:none;\n  top: -140px;\n  opacity: 0.5;\n  color: cyan;\n\n  left:10px;\n  top: -5px;\n  z-index: 10;\n\n}\n\n\n\n.station-radar-indicator .line{\n  position: absolute;\n  top: -140px;\n  height: 135px;\n  width: 10px;\n  border-left: 1px solid cyan;\n  opacity: 0.5;\n  z-index: 10;\n\n}\n\n\n.station-radar-indicator .center{\n  position: absolute;\n  bottom: -3px;\n  left: -2px;\n  height: 5px;\n  width: 5px;\n  border-radius: 2px;\n  background-color: cyan;\n  opacity: 1;\n  z-index: 10;\n\n}\n\n\n.station-radar-indicator .gdp-circle{\n  position: absolute;\n  bottom: -16px;\n  left: -15px;\n  height: 31px;\n  width: 31px;\n  border-radius: 2px;\n  background-color: cyan;\n  border-radius: 50%;\n  opacity: 0.2;\n  z-index: 10;\n\n}\n\n.station-radar-indicator .gdp-circle.owned::after{\n  content: '';\n  position: absolute;\n  top: -6px;\n  left: -6px;\n  width: calc(100% + 10px);\n  height: calc(100% + 10px);\n  border-radius: 50%;\n  border: 1px solid cyan; \n}\n\n.station-radar-indicator.selected .gdp-circle.owned::after{\n  border: 1px solid var(--main-color); \n}\n\n.station-radar-indicator .center-transparent-clickable{\n  position: absolute;\n  bottom: -11px;\n  left: -10px;\n  height: 20px;\n  width: 20px;\n  border-radius: 2px;\n  background-color: transparent;\n  border-radius: 50%;\n}\n\n.station-radar-indicator .row .name{\n  color: cyan;\n}\n\n.station-radar-indicator.selected .line{\n  border-left: 1px solid var(--main-color);\n  opacity: 1;\n}\n\n\n.station-radar-indicator.selected .gdp-circle{\n  background-color: var(--main-color);\n}\n\n\n.station-radar-indicator.selected .center{\n  background-color: var(--main-color);\n}\n\n.station-radar-indicator.selected .row{\n  opacity: 1;\n}\n\n.station-radar-indicator.selected .row .name{\n  color: var(--main-color);\n}\n\n.station-radar-indicator.type2 .line{\n  top: -170px;\n  height: 165px;\n}\n.station-radar-indicator.type2 .row{\n  top: -185px;\n}\n.station-radar-indicator.type2 .indicators-column123{\n  top: -170px;\n}\n\n\n.station-radar-indicator.type3 .line{\n  top: -50px;\n  height: 45px;\n}\n.station-radar-indicator.type3 .row{\n  top: -65px;\n}\n.station-radar-indicator.type3 .indicators-column123{\n  top: -50px;\n}\n\n\n\n\n.secondary-order-btn,\n.order-btn,\n.next-target-btn,\n.tabs-row,\n.btn,\n.noselect {\n  -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n     -khtml-user-select: none; /* Konqueror HTML */\n       -moz-user-select: none; /* Old versions of Firefox */\n        -ms-user-select: none; /* Internet Explorer/Edge */\n            user-select: none; /* Non-prefixed version, currently\n                                  supported by Chrome, Edge, Opera and Firefox */\n}\n\n.yesselect {\n  -webkit-touch-callout: text; /* iOS Safari */\n    -webkit-user-select: text; /* Safari */\n     -khtml-user-select: text; /* Konqueror HTML */\n       -moz-user-select: text; /* Old versions of Firefox */\n        -ms-user-select: text; /* Internet Explorer/Edge */\n            user-select: text; /* Non-prefixed version, currently\n                                  supported by Chrome, Edge, Opera and Firefox */\n}\n\n\n.team-page{\n  width: 100%;\n  max-width: 600px;\n  height: calc(100% - 90px);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: start;\n  padding: var(--2);\n  margin-bottom: 90px ;\n  gap: var(--1);\n}\n\n\n.team-page .team-overview{\n  position: relative;\n  width:100%;\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  justify-content: start;\n  flex: auto;\n  gap: var(--1);\n  overflow-y: scroll;\n}\n\n.team-overview .breakable-grid{\n  width: calc(100%);\n  position: relative;\n\n  display: flex;\n  flex-direction: row;\n  align-items:stretch;\n  gap:var(--1);\n  flex-wrap: wrap;\n}\n\n\n.team-overview .breakable-grid .non-breaking-half{\n  \n  min-width: 258px; /*580/2 - 5px /2 = 258*/\n  display: flex;\n  flex:auto;\n  flex-grow: 1;\n  position: relative;\n  flex-direction: column;\n  gap:var(--1);\n  flex-wrap: nowrap;\n  align-items:stretch;\n\n}\n\n.team-overview .breakable-grid .non-breaking-half .full-block{\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  justify-content: start;\n  width: 100%;\n  min-height: 50px;\n  gap: var(--1);\n  border: 1px solid #888;\n  border-radius: var(--border-radius);\n  flex:auto;\n  padding: 10px;\n}\n\n.team-overview .breakable-grid .non-breaking-half .full-block.navigation{\n  flex-direction: row;;\n  justify-content: space-between;\n  align-items: center;\n  text-align: center;\n  gap: var(--4);\n}\n\n.team-overview .breakable-grid .non-breaking-half .line{\n  display: flex;\n  flex-direction: row;\n  align-items: start;\n  justify-content: start;\n  width: 100%;\n  gap:var(--1);\n  height: 80px;\n  flex: none;\n}\n\n.team-overview .breakable-grid .non-breaking-half .line .non-flex-block{\n  border: 1px solid #888;\n  border-radius: var(--border-radius);\n  padding:10px;\n  height: 80px;\n  width: 80px;\n  flex:none;\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n}\n\n.non-flex-block.karma-btn{\n  background-color: var(--main-color);\n  color: var(--background-color);\n  border: 1px solid var(--main-color);\n}\n\n.team-overview .breakable-grid .non-breaking-half .line .flex-block{\n  border: 1px solid #888;\n  border-radius: var(--border-radius);\n  padding:10px;\n  height: 80px;\n  flex:auto;\n}\n\n.team-overview .breakable-grid .non-breaking-half .line .flex-block.station-name{\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: var(--2);\n  align-items: center;\n  text-align: center;\n}\n\n.hypderdive-circular-map{\n  position: relative;\n  width:100%;\n  height: 100%;\n  max-height: 90px;\n  border-radius: var(--border-radius);\n  overflow: hidden;\n}\n\n\n.hypderdive-circular-map .layer-5{\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top:0px;\n  left:0px;\n}\n\n.hypderdive-circular-map .layer-4{\n  position: absolute;\n  aspect-ratio: 1/1;\n  width:190px;\n  right:calc(50% - 95px);\n  top:calc(50% - 95px);\n  border-radius: 95px;\n\n  border: 1px solid var(--main-color);\n  margin:auto;\n  background-color: var(--background-color);\n  animation: breath 4s infinite;\n  animation-delay: 0ms;\n}\n\n\n.hypderdive-circular-map .layer-3{\n  position: absolute;\n  aspect-ratio: 1/1;\n  width:150px;\n  right:calc(50% - 75px);\n  top:calc(50% - 75px);\n  border-radius: 75px;\n\n  border: 1px solid var(--main-color);\n  margin:auto;\n  background-color: var(--background-color);\n  animation: breath 4s infinite;\n  animation-delay: 200ms;\n}\n\n.hypderdive-circular-map .layer-2{\n  position: absolute;\n  aspect-ratio: 1/1;\n  width:110px;\n  right:calc(50% - 55px);\n  top:calc(50% - 55px);\n  border-radius: 55px;\n\n  border: 1px solid var(--main-color);\n  margin:auto;\n  background-color: var(--background-color);\n  animation: breath 4s infinite;\n  animation-delay: 400ms;\n\n}\n\n.hypderdive-circular-map .layer-1{\n  position: absolute;\n  aspect-ratio: 1/1;\n  width:70px;\n  right:calc(50% - 35px);\n  top:calc(50% - 35px);\n  border-radius: 35px;\n\n  border: 1px solid var(--main-color);\n  margin:auto;\n  background-color: var(--background-color);\n  animation: breath 4s infinite;\n  animation-delay: 600ms;\n}\n\n.hypderdive-circular-map .layer-0{\n  position: absolute;\n  aspect-ratio: 1/1;\n  width:30px;\n  right:calc(50% - 15px);\n  top:calc(50% - 15px);\n  border-radius: 15px 15px 15px 15px;\n  border: 2px solid var(--main-color);\n  margin:auto;\n  background-color: var(--background-color);\n  animation-delay: 800ms;\n}\n\n.hypderdive-circular-map .map-grid{\n  position: absolute;\n  width:100%;\n  height: 1px;\n  rotate: 0deg;\n  left:0px;\n  border-top: 2px dotted #888;\n  top:calc(50% - 1px);\n  /*animation: breath 10s infinite;\n  animation-delay: 800ms;*/\n}\n\n.hypderdive-circular-map .map-grid2{\n  position: absolute;\n  height:100%;\n  left: 50%;\n  top:0;\n  border-left: 1px solid #888;\n}\n\n.hypderdive-circular-map .player-icon-layer-5,\n  .hypderdive-circular-map .player-icon-layer-4,\n    .hypderdive-circular-map .player-icon-layer-3,\n      .hypderdive-circular-map .player-icon-layer-2,\n        .hypderdive-circular-map .player-icon-layer-1,\n          .hypderdive-circular-map .player-icon-layer-0{\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  border-radius: 3px;\n  left:calc(50% - 118px);\n  top:calc(50% - 3px);\n  background-color: cyan;\n\n}\n\n.hypderdive-circular-map .player-icon-layer-4{left:calc(50% - 88px);}\n.hypderdive-circular-map .player-icon-layer-3{left:calc(50% - 68px);}\n.hypderdive-circular-map .player-icon-layer-2{left:calc(50% - 48px);}\n.hypderdive-circular-map .player-icon-layer-1{left:calc(50% - 28px);}\n.hypderdive-circular-map .player-icon-layer-0{left:calc(50% - 3px);}\n\n.hypderdive-circular-map .border-wave-top{\n  position: absolute;\n  aspect-ratio: 1/1;\n  width:300px;\n  right:calc(50% - 150px);\n  top:-280px;\n  border-radius: 100px;\n\n  border: 1px solid var(--main-color);\n  margin:auto;\n  background-color: var(--background-color);\n}\n\n.hypderdive-circular-map .border-wave-bottom{\n  position: absolute;\n  aspect-ratio: 1/1;\n  width:300px;\n  right:calc(50% - 150px);\n  bottom:-280px;\n  border-radius: 100px;\n\n  border: 1px solid var(--main-color);\n  margin:auto;\n  background-color: var(--background-color);\n}\n\n.hypderdive-circular-map .title-bottom{\n  position: absolute;\n  display: flex;\n  align-items: end;\n  justify-content: center;\n  bottom: var(--1);\n  height: 15px;\n  color: var(--main-color);\n  left: 10%;\n  width:80%;\n  text-align: center;\n}\n\n.hypderdive-circular-map .title-top{\n  position: absolute;\n  display: flex;\n  align-items: start;\n  justify-content: center;\n  top: 2px;\n  height: 15px;\n  color: var(--main-color);\n  left: 10%;\n  width:80%;\n  text-align: center;\n}\n\n\n\n.hypderdive-circular-map .title-layer-5,\n.hypderdive-circular-map .title-layer-4,\n.hypderdive-circular-map .title-layer-3,\n.hypderdive-circular-map .title-layer-2,\n.hypderdive-circular-map .title-layer-1,\n.hypderdive-circular-map .title-layer-0{\n  position: absolute;\n  display: flex;\n  align-items: end;\n  justify-content: start;\n  bottom: 2px;\n  height: 15px;\n  padding-left: 2px;\n  padding-bottom: -2px;\n  border-left: 1px solid #888;\n  color: #888;\n  left: calc(50%);\n  margin-left:-5px;\n  margin-top:-10px;\n}\n\n\n.hypderdive-circular-map .title-layer-5{\n  left: calc(50% - 125px);\n  height: 25px;\n}\n\n.hypderdive-circular-map .title-layer-4{\n  left: calc(50% - 85px);\n  height: 8px;\n}\n.hypderdive-circular-map .title-layer-3{\n  left: calc(50% - 65px);\n  height: 13px;\n}\n.hypderdive-circular-map .title-layer-2{\n  left: calc(50% - 45px)\n}\n.hypderdive-circular-map .title-layer-1{\n  left: calc(50% - 25px)\n}\n\n\n.hypderdive-circular-map .active-layer{\n  background-color: var(--main-color);\n}\n.team-overview .team-showroom{\n  max-width:600px;\n  width: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-around;\n  flex-wrap: wrap;\n  gap:5px;\n  padding: 10px;\n  border-radius: var(--border-radius);\n  border: 1px solid #888;\n\n  --dot-bg: #2E2E52;\n\n  --dot-color: var(--secondary-color);\n  --dot-size: 1px;\n  --dot-space: 24px;\n\tbackground:\n\t\tlinear-gradient(90deg, var(--dot-bg) calc(var(--dot-space) - var(--dot-size)), transparent 1%) center / var(--dot-space) var(--dot-space),\n\t\tlinear-gradient(var(--dot-bg) calc(var(--dot-space) - var(--dot-size)), transparent 1%) center / var(--dot-space) var(--dot-space),\n\t\tvar(--dot-color);\n\n}\n\n.team-overview .team-showroom .ship-card{\n  position: relative;\n  height: 280px;\n  width: 160px;\n  border-radius: 80px;\n  border: 1px solid #888;\n  background-color: var(--background-color);\n  flex:none;\n\n}\n.team-overview .team-showroom .ship-card .ship-img{\n  position: absolute;\n  top:0px;\n  left:0px;\n  width: 100%;\n  aspect-ratio: 1/1;\n  object-fit: contain;\n}\n\n\n.team-overview .team-showroom .ship-card .circle{\n  position: absolute;\n  top:20px;\n  left:19px;\n  height: 120px;\n  width: 120px;\n  background-color: var(--main-color);\n  border-radius: 60px;\n}\n\n.team-overview .team-showroom .ship-card .circle::after{\n  position: absolute;\n  content:'';\n  top:-10px;\n  left:-10px;\n  height: 140px;\n  width: 140px;\n  border: 1px solid #888;\n  border-radius: 80px;\n  margin:-1px;\n}\n\n.team-overview .team-showroom .ship-card .indicators{\n  display: flex;\n  flex-direction: row;\n  position: absolute;\n  top:138px;\n  left:0px;\n  height: 140px;\n  width: 100%;\n  border-radius: 80px;\n  align-items: center;\n  justify-content: stretch;\n  text-align: center;\n}\n\n.team-overview .team-showroom .ship-card .indicators .indicators-name{\n  display: flex;\n  width: calc(50%);\n  flex-direction: column;\n  align-items: end;\n  padding: 10px;\n}\n.team-overview .team-showroom .ship-card .indicators .indicators-count{\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  width: calc(50%);\n  padding: 10px;\n}\n\n.team-overview .team-showroom .ship-card .indicators::before{\n  position: absolute;\n  content:'';\n  top:0px;\n  left:calc(50%);\n  height: 100%;\n  border-left: 1px solid #888;\n}\n\n\n.team-overview .team-showroom .ship-card.reversed .indicators{\n  top:0px;\n  justify-content: end;\n}\n\n.team-overview .team-showroom .ship-card.reversed .circle{\n  top:138px;\n}\n\n.team-overview .team-showroom .ship-card.reversed .ship-img{\n  top:auto;\n  bottom:0px;\n}\n\n\n\n@keyframes pulsate {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes pulsate2 {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@keyframes pulsate-once {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes pulsate-twice {\n  0% {\n    opacity: 0;\n  }\n\n  90% {\n    opacity: 0;\n  }\n  \n  100% {\n    opacity: 0.2;\n  }\n}\n@keyframes pulsate-twice-2 {\n  0% {\n    opacity: 0;\n  }\n\n  90% {\n    opacity: 0;\n  }\n  \n  100% {\n    opacity: 0.5;\n  }\n}\n\n\n\n@keyframes breath {\n  0% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.2;\n\n  }\n  75% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes singularity{\n  0% {\n  }\n  25% {\n    transform: rotate(100deg);\n    box-shadow: rgba(240, 46, 170, 0.4) -5px 5px, rgba(240, 46, 170, 0.3) -10px 10px, rgba(240, 46, 170, 0.2) -15px 15px, rgba(240, 46, 170, 0.1) -20px 20px, rgba(240, 46, 170, 0.05) -25px 25px; \n  }\n  50% {\n    transform: rotate(200deg);\n    box-shadow: rgba(240, 46, 170, 0.4) -5px 5px, rgba(240, 46, 170, 0.3) -10px 10px, rgba(240, 46, 170, 0.2) -15px 15px, rgba(240, 46, 170, 0.1) -20px 20px, rgba(240, 46, 170, 0.05) -25px 25px;\n  }\n  75% {\n    transform: rotate(310deg);\n    box-shadow: rgba(240, 46, 170, 0.4) -5px 5px, rgba(240, 46, 170, 0.3) -10px 10px, rgba(240, 46, 170, 0.2) -15px 15px, rgba(240, 46, 170, 0.1) -20px 20px, rgba(240, 46, 170, 0.05) -25px 25px;  \n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n\n.fade-in{\n  animation: fade 3s;\n  animation-delay: 0ms;\n}\n\n@keyframes fade {\n  0% {\n    opacity: 0;\n  }\n  75% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.events-list{\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  height: 100%;\n  width: 100%;\n  padding: 20px;\n  overflow-y: scroll;\n  padding-bottom: 100px;\n}\n\n.events-list .top-stats{\n  display: flex;\n  flex-direction: row;\n  gap:20px;\n  color: #888;\n}\n\n.events-list .event{\n  border-radius: 10px;\n  /*border: 1px solid var(--main-color);*/\n  display: flex;\n  flex-direction: column;\n}\n\n\n.events-list .event .description{\n  gap:10px;\n  max-height: 40px;\n  position: relative;\n  padding-left: 30px;\n}\n\n.events-list .event .description::before{\n  content:'';\n  position: absolute;\n  /*border: 1px solid var(--main-color);*/\n  left: 15px;\n  top:-10px;\n  height: calc(100% + 10px);\n  border-left: 1px solid var(--main-color);\n}\n.events-list .event .description.is_delayed::before{\n  border-left: 1px dashed var(--main-color);\n\n}\n.events-list .event .description .hidden-text{\n  gap:10px;\n  height: 40px;\n  position: relative;\n  overflow: hidden;\n  color: #888;\n}\n\n.events-list .event .description .hidden-text p{\n  gap:10px;\n  height: auto;\n  padding-bottom: 40px;\n  background-color: var(--background-color);\n}\n\n.events-list .event .description .hidden-text:hover{\n  height: 40px;\n  overflow: visible;\n  z-index: 1000;\n}\n\n.events-list .event .consequences{\n  display: flex;\n  flex-direction: column;\n  padding-left: 30px;\n\n}\n\n.events-list .consequence{\n  gap:0px;\n  position: relative;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.events-list .consequence::after{\n  content:'';\n  position: absolute;\n  /*border: 1px solid var(--main-color);*/\n  left: -15px;\n  top:18px;\n  width: 30px;\n  border-top: 1px solid var(--main-color);\n}\n\n.events-list  .consequence::before{\n  content:'';\n  position: absolute;\n  /*border: 1px solid var(--main-color);*/\n  left: -15px;\n  top:0px;\n  height: 100%;\n  border-left: 1px solid var(--main-color);\n}\n\n.events-list .consequence.consequence-last::before{\n  left: -15px;\n  top:0px;\n  height: 19px;\n}\n\n.events-list .consequence .title{\n  width: fit-content;\n  display: flex;\n  flex-direction: row;\n  align-items: start;\n  gap:10px;\n  height: 16px;\n  padding-left: 30px;\n}\n\n\n.events-list .consequence .title::before{\n  content:'';\n  position: absolute;\n  /*border: 1px solid var(--main-color);*/\n  left: 10px;\n  top:13px;\n  height: 10px;\n  width: 10px;\n  background-color: var(--main-color);\n}\n\n.events-list .no-after-and-before::before{\n  display: none;\n}\n\n.events-list .no-after-and-before::after{\n  display: none;\n}\n\n\n.events-list .no-after-and-before::after{\n  display: none;\n}\n\n.event-list-commands{\n  position: fixed;\n  display: flex;\n  flex-direction: row;\n  gap:40px;\n  left:0;\n  align-items: center;\n  justify-content: center;\n  bottom: 20px;\n  width: 100%; \n}\n\n/*\n\n.typing-animation {\n  color:#0000;\n  background:\n    linear-gradient(-90deg,#00DFFC 5px,#0000 0) 10px 0,\n    linear-gradient(#00DFFC 0 0) 0 0;\n  background-size:calc(var(--typing-animation-speed)*1ch) 200%;\n  -webkit-background-clip:padding-box,text;\n  background-clip:padding-box,text;\n  background-repeat:no-repeat;\n  animation: \n   b .7s infinite steps(1),   \n   t calc(var(--typing-animation-speed)*.05s) steps(var(--typing-animation-speed)) forwards;\n}\n\n@keyframes t{\n  from {background-size:0 200%}\n}\n@keyframes b{\n  50% {background-position:0 -100%,0 0}\n}*/\n\n.background-roundwaves-pattern {\n  background-color: var(--background-color);\n  \n  opacity: 0.8;\n  background-image:  repeating-radial-gradient( circle at 0 0, transparent 0, var(--background-color) 10px ), repeating-linear-gradient( #888, var(--background-color) );\n}\n\n.background-diagonal-pattern{\n  background-color:var(--background-color);\nopacity: 0.8;\nbackground-size: 30px 30px;\nbackground-image: repeating-linear-gradient(45deg, #888 0, #888 1px, var(--background-color) 0, var(--background-color) 50%);\n}\n\n.stations-list{\n  display: flex;\n  flex-direction: column;\n  gap: var(--2);\n  width:calc(100%);\n  height: calc(100%);\n  overflow:hidden;\n  overflow-y: auto;\n}\n\n.stations-list .station{\n  border: 1px solid #888;\n  display: flex;\n  flex-direction: column;\n  padding: var(--2);\n  gap: var(--2);\n  border-radius: var(--border-radius);\n}\n\n.inline-svg{\n  display: inline-block;\n  width: 1em; /* Matches the font size of the text */\n  height: 1em; /* Matches the font size of the text */\n  stroke: currentColor; /* This applies the text color to the SVG stroke, if applicable */\n  vertical-align: middle;\n}\n\n.inline-svg-h2{\n  display: inline-block;\n  width: 1em; /* Matches the font size of the text */\n  height: 1em; /* Matches the font size of the text */\n  stroke: currentColor; /* This applies the text color to the SVG stroke, if applicable */\n  vertical-align: middle;\n  margin-bottom: 4px;\n}\n\n.svg-arrows{\n  display: block;\n  position: absolute;\n  flex:none;\n  z-index: 5;\n  scale: 1 -1;\n  pointer-events: none;\n}\n\n.svg-arrows.selected-target{\n  z-index: 4;\n}\n\n.svg-arrows .arrow{\n  opacity: 0.5;\n  animation: pulsate 0.2s ease-in-out;\n}\n\n.svg-arrows .arrow-path-pulsate{\n  animation: pulsate2 1.6s infinite ease-in-out;\n}\n\n.svg-arrows .arrow-path{\n  animation: appear-delayed 0.6s ease-in-out;\n  \n}\n\n.svg-arrows .arrow-selected-path{\n  animation: appear-delayed  0.4s ease-in-out;\n}\n\n.svg-arrows .circle-path{\n  animation: appear-with-scale-delayed 0.6 ease-in-out;\n}\n\n.arrow-days-label{\n  position: absolute;\n  flex: none;\n  width: 2px;\n  margin-left: -1px;\n  margin-top: -1px;\n  height: 2px;\n  pointer-events: none;\n  display: flex;\n  flex-direction: row;\n  align-items: center ;\n  justify-content: center;\n  text-align: center;\n  transition-duration: 0.4s;\n  transition-timing-function: ease-in-out;\n  transition-delay: 0ms;\n  z-index:110;\n}\n\n.arrow-days-label .grey-label,\n.arrow-days-label .cyan-label{\n  padding-left:2px;\n  padding-right: 2px;\n  border-left: 0px solid #888 ;\n  color: #888;\n  background-color: var(--background-color-transparent);\n}\n.arrow-days-label .cyan-label{\n  border-left: 0px solid cyan ;\n  color: cyan;\n}\n.station-section-block{\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  justify-content: start;\n  padding: var(--2);\n  gap: var(--3);\n  width: 100%;\n  border: 1px solid #888;\n  border-radius: var(--border-radius);\n  overflow-y: scroll;\n}\n\n\n.station-section-block .station-influence-bar-section{\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  justify-content: center;\n  gap: var(--2);\n  width: 100%;\n  \n  transition-duration: 1.5s;\n  transition-timing-function: ease-in-out;\n\n}\n\n.station-influence-bar-section .station-influence-bar{\n  width: calc(100%);\n  height: 6px;\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  gap:var(--1);\n}\n\n.station-influence-bar-section .station-influence-bar .segment{\n  height: calc(100%);\n  background-color: #888;\n  width: calc(100%);\n  border-radius: 3px;\n  transition-duration: 1.5s;\n  transition-timing-function: ease-in-out;\n}\n\n.station-influence-bar-section .station-influence-bar .segment.red{\n  background-color: red;\n}\n.station-influence-bar-section .station-influence-bar .segment.cyan{\n  background-color: cyan;\n}\n\n.station-influence-bar-section .legend{\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  gap: var(--2);\n}\n\n.station-influence-bar-section .legend .legend-item {\n  text-align: center;\n  width: 100%;\n}\n\n.station-influence-bar-section .legend .legend-item.left {\n  text-align: left;\n}\n\n.station-influence-bar-section .legend .legend-item.right {\n  text-align: right;\n}\n\n.station-section-block .line-with-btns{\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.inline-btn{\n  border: 1px solid var(--main-color);\n  color: var(--main-color);\n  padding-left: var(--2);\n  padding-right: var(--2);\n  border-radius: 4px;\n  cursor: pointer;\n  margin: -1px;\n}\n\n\n.inline-btn:hover{\n  background-color: var(--main-color);\n  color: black;\n}\n\n.inline-btn:active{\n  background-color: var(--secondary-color);\n  color: black;}\n\n.political-coordinates-select{\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  gap: var(--1);\n  padding: var(--2);\n}\n\n\n.political-coordinates-select{\n  align-self: center;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  position: relative;\n  width: 95%;\n}\n\n.political-coordinates-select .bar{\n  position: absolute;\n  width: 6px;\n  border-radius: 3px;\n  height: calc(100% - 2*var(--3));\n  left: calc(-1 * var(--1));\n  top: var(--3);\n\n  display: flex;\n  flex: none;\n  flex-direction: column;\n  gap: var(--2);\n}\n\n.political-coordinates-select .bar.right{\n  left: auto;\n  right: calc(-1 * var(--1));\n  display: none;\n}\n\n.political-coordinates-select .bar .segment{\n  width: 6px;\n  border-radius: 3px;\n  height: 20%;\n  background-color: #888;\n}\n\n.political-coordinates-select .bar .segment.red{\n  height: 40%;\n  background-color: red;\n}\n.political-coordinates-select .bar  .segment.cyan{\n  height: 40%;\n  background-color: cyan;\n}\n\n.political-coordinates-select .option{\n  position: relative;\n  padding: var(--2);\n  display: flex;\n  flex-direction: row;\n  gap: var(--4);\n  margin: var(--1);\n  border-radius: var(--border-radius);\n  align-items: center;\n  border: 1px solid var(--main-color);\n}\n\n.political-coordinates-select .option .box-select{\n  width: 12px;\n  height: 12px;\n  border: 1px solid var(--main-color);\n  border-radius: 2px;\n}\n\n\n.political-coordinates-select .option.selected{\n  opacity: 1;\n  border: 1px solid var(--main-color)\n}\n\n.political-coordinates-select .option.selected .box-select{\n  background-color: var(--main-color);\n  opacity: 1;\n}\n\n.political-coordinates-select .disabled{\n  border-color: #888;\n  color: #888;\n  opacity: 0.5;\n}\n\n.political-coordinates-select .option.disabled .box-select{\n  border-color: #888;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
